import React from "react";
import { Link } from "gatsby";

import Icon from "../../components/custom-widgets/icon";
import VimeoVideoFrame from "../../components/custom-widgets/vimeo-video-frame";
import AppDownloadHub from "../../components/mobile-online-banking/app-download-hub";

export const checkIcon = () => {
  return <Icon name="check" class="mr-2 text-success" />;
};
export const faqs = [
  {
    id: 1,
    question: (
      <>
        What is Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        Zelle<sup>&reg;</sup> is a fast, safe and easy way to send money directly between almost any bank accounts in
        the U.S., typically within minutes.<sup>1</sup> With just an email address or U.S. mobile phone number, you can
        send money to people you know and trust, regardless of where they bank.<sup>2</sup>
      </p>
    )
  },
  {
    id: 2,
    question: (
      <>
        Who can I send money to with Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          You can send money to friends, family and people you know.<sup>2</sup>
        </p>
        <p>
          Since money is sent directly from your bank account to another person's bank account typically within minutes,
          <sup>1</sup>
          it's important to only send money to people you trust, and always ensure you've used the correct email address
          or U.S. mobile number. Zelle<sup>&reg;</sup> should only be used to send money to friends, family or others
          you trust.
        </p>
      </>
    )
  },
  {
    id: 3,
    question: (
      <>
        How do I use Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          You can send, request, or receive money with Zelle<sup>&reg;</sup>. To get started, log into WaFd Bank's
          online banking or mobile app and choose Move Money then select "Send with Zelle<sup>&reg;</sup>". Enter your
          email address or U.S. mobile phone number, receive a one-time verification code, enter it, accept terms and
          conditions, and you're finished.
        </p>
        <p>
          To send money using Zelle<sup>&reg;</sup>, simply select someone from your mobile device's contacts (or add a
          trusted recipient's email address or U.S. mobile phone number), add the amount you'd like to send and an
          optional memo, review, then hit "Send." In most cases, the money is available to your recipient typically in
          minutes.<sup>1</sup>
        </p>
        <p>
          To request money using Zelle<sup>&reg;</sup>, choose "Request," select the individual from whom you'd like to
          request money, enter the amount you'd like to request, include an optional note, review and hit "Request."
          <sup>3</sup>
        </p>
        <p>
          To receive money, just share your enrolled email address or U.S. mobile phone number with a friend and ask
          them to send you money with Zelle<sup>&reg;</sup>.
        </p>
      </>
    )
  },
  {
    id: 4,
    question: (
      <>
        Someone sent me money with Zelle<sup>&reg;</sup>, how do I receive it?
      </>
    ),
    answer: (
      <>
        <p>
          If you have already enrolled with Zelle<sup>&reg;</sup>, you do not need to take any further action. The money
          will move directly into your bank account, typically within minutes.<sup>1</sup>
        </p>
        <p>
          If you have not yet enrolled with Zelle<sup>&reg;</sup>, follow these steps:
        </p>

        <ol>
          <li>Click on the link provided in the payment notification you received via email or text message.</li>
          <li>Select WaFd Bank.</li>
          <li>
            Follow the instructions provided on the page to enroll and receive your payment. Pay attention to the email
            address or U.S. mobile number where you received the payment notification&mdash;you should enroll with Zelle
            <sup>&reg;</sup> using that email address or U.S. mobile number to ensure you receive your money.
          </li>
        </ol>
      </>
    )
  },
  {
    id: 5,
    question: (
      <>
        What types of payments can I make with Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Zelle<sup>&reg;</sup> is a great way to send money to family, friends, and people you are familiar with such
          as your babysitter or neighbor.<sup>2</sup>
        </p>
        <p>
          Since money is sent directly from your bank account to another person's bank account typically within minutes,
          <sup>1</sup>
          Zelle<sup>&reg;</sup> should not be used to send money to people you don't know or trust.
        </p>
        <p>
          Zelle<sup>&reg;</sup> should only be used to send money to friends, family or others you trust. Neither WaFd
          Bank nor Zelle<sup>&reg;</sup> offers a protection program for any authorized payments made with Zelle
          <sup>&reg;</sup>&mdash;for example, if you do not receive the item you paid for or the item is not as
          described or as you expected. Please contact us with questions{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>
          .
        </p>
        <p>
          If you have any questions around what limits you have with Zelle<sup>&reg;</sup> transactions, please email{" "}
          <a className="faq-c3-email-link" href="mailto:onlinebanking@wafd.com">
            onlinebanking@wafd.com
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 6,
    question: (
      <>
        Are there any fees to send money using Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        WaFd Bank does not charge any fees to use Zelle<sup>&reg;</sup>.
      </p>
    )
  },
  {
    id: 7,
    question: <>How do I get started?</>,
    answer: (
      <>
        <p>
          It's easy&mdash;Zelle<sup>&reg;</sup> is already available within WaFd Bank's mobile banking app and online
          banking! Check our app or sign in online and follow a few simple steps to enroll with Zelle<sup>&reg;</sup>{" "}
          today.
        </p>
        <ol>
          <li>
            Enroll with Zelle<sup>&reg;</sup>&mdash;Zelle<sup>&reg;</sup> is built into the WaFd app but you still need
            to enroll your mobile number or email with Zelle<sup>&reg;</sup>
          </li>
          <li>After verifying your mobile number or email address, you are now ready to send or receive money.</li>
          <li>
            When using Zelle<sup>&reg;</sup>, make sure you know the person you are sending money to.
          </li>
        </ol>
      </>
    )
  },
  {
    id: 8,
    question: (
      <>
        How does Zelle<sup>&reg;</sup> work?
      </>
    ),
    answer: (
      <p>
        When you enroll with Zelle<sup>&reg;</sup> through the WaFd Bank app, your name, the name of your bank and the
        email address or U.S. mobile number you enrolled is shared with Zelle<sup>&reg;</sup> (no sensitive account
        details are shared&mdash;those stay with WaFd Bank). When someone sends money to your enrolled email address or
        U.S. mobile number, Zelle<sup>&reg;</sup> looks up the email address or mobile number in its “directory” and
        notifies WaFd Bank of the incoming payment. WaFd Bank then directs the payment into your bank account, all while
        keeping your sensitive account details private.
      </p>
    )
  },
  {
    id: 9,
    question: (
      <>
        Can I use Zelle<sup>&reg;</sup> internationally?
      </>
    ),
    answer: (
      <p>
        In order to use Zelle<sup>&reg;</sup>, the sender and recipient's bank accounts must be based in the U.S.
      </p>
    )
  },
  {
    id: 10,
    question: <>Can I cancel a payment?</>,
    answer: (
      <>
        <p>
          You can only cancel a payment if the person you sent money to hasn't yet enrolled with Zelle<sup>&reg;</sup>.
          To check whether the payment is still pending because the recipient hasn't yet enrolled, you can go to your
          activity page, choose the payment you want to cancel, and then select "Cancel This Payment."
        </p>
        <p>
          If the person you sent money to has already enrolled with Zelle<sup>&reg;</sup>, the money is sent directly to
          their bank account and <strong>cannot be canceled</strong>. This is why it's important to only send money to
          people you know and trust, and always ensure you've used the correct email address or U.S. mobile number when
          sending money.
        </p>
        <p>
          If you sent money to the wrong person, we recommend contacting the recipient and requesting the money back. If
          you aren't able to get your money back, please call us at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          so we can help you.
        </p>
      </>
    )
  },
  {
    id: 11,
    question: (
      <>
        How long does it take to receive money with Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Money sent with Zelle<sup>&reg;</sup> is typically available to an enrolled person within minutes.<sup>1</sup>
        </p>
        <p>
          If you send money to someone who isn't enrolled with Zelle<sup>&reg;</sup>, they will receive a notification
          prompting them to enroll. After enrollment, the money will move directly into your recipient's account.
        </p>
        <p>
          If your payment is still pending, we recommend confirming that the person you sent money to has enrolled with
          Zelle<sup>&reg;</sup> and that you entered the correct email address or U.S. mobile phone number. If you're
          waiting to receive money, you should check to see if you've received a payment notification via email or text
          message. If you haven't received a payment notification, we recommend following up with the sender to confirm
          they entered the correct email address or U.S. mobile phone number.
        </p>
        <p>
          Still having trouble? Please give the WaFd Bank customer support team a call toll-free at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          or get in touch through our support page.
        </p>
      </>
    )
  },
  {
    id: 12,
    question: <>Will the person I send money to be notified?</>,
    answer: <p>Yes! They will receive a notification via email or text message.</p>
  },
  {
    id: 13,
    question: <>Is my information secure?</>,
    answer: (
      <p>
        Keeping your money and information safe is a top priority for WaFd Bank. When you use Zelle<sup>&reg;</sup>{" "}
        within our mobile app or online banking, your information is protected with the same technology we use to keep
        your bank account safe.
      </p>
    )
  },
  {
    id: 14,
    question: (
      <>
        I'm unsure about using Zelle<sup>&reg;</sup> to pay someone I don't know. What should I do?
      </>
    ),
    answer: (
      <>
        <p>
          If you don't know the person, or aren't sure you will get what you paid for (for example, items bought from an
          online bidding or sales site), you should not use Zelle<sup>&reg;</sup> for these types of transactions.
        </p>
        <p>
          These transactions are potentially high risk (just like sending cash to a person you don't know is high risk).
          Neither WaFd Bank nor Zelle<sup>&reg;</sup> offers a protection program for any authorized payments made with
          Zelle<sup>&reg;</sup>&mdash;for example, if you do not receive the item you paid for or the item is not as
          described or as you expected.
        </p>
      </>
    )
  },
  {
    id: 15,
    question: <>What if I get an error message when I try to enroll an email address or U.S. mobile number?</>,
    answer: (
      <>
        <p>
          Your email address or US mobile phone number may already be enrolled with Zelle<sup>&reg;</sup> at another
          bank or credit union. If this is the case, when you enroll with Zelle<sup>&reg;</sup> in the WaFd Bank mobile
          app, you may be asked if you want your phone number or email address registered with Zelle<sup>&reg;</sup>{" "}
          through WaFd Bank instead of the original bank or credit union you enrolled with Zelle<sup>&reg;</sup> at.
          This will ensure money you receive through Zelle<sup>&reg;</sup> will be deposited in your WaFd Bank account.
        </p>
        <p>
          Once customer support moves your email address or phone number, it will be connected to your WaFd Bank account
          so you can start sending and receiving money with Zelle<sup>&reg;</sup>. Please call WaFd Bank customer
          support toll-free at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          for help.
        </p>
      </>
    )
  },
  {
    id: 44,
    question: <>I forgot my debit card PIN. How do I reset it?</>,
    answer: (
      <p>
        If you've forgotten your debit card PIN please call{" "}
        <a id="faq-debit-pin-tel-link" href="tel:800-992-3808">
          800-992-3808
        </a>
        . You can also update your PIN within the WaFd mobile app. Navigate to Manage Cards and choose Update PIN
      </p>
    )
  },
  {
    id: 45,
    question: <>How do I disable my lost or stolen debit card?</>,
    answer: (
      <>
        <p>
          If you've lost your debit card or suspect it's been stolen, there are two ways to lock it or temporarily
          disable your card:
        </p>
        <ol>
          <li>Online Banking or Mobile App: Sign In to your WaFd account and navigate to 'Manage Cards.'</li>
          <li>
            Contact Support: Call our support team at{" "}
            <a id="faq-c3-tel-link" href="tel:800-324-9375">
              800-324-9375
            </a>
            .
          </li>
        </ol>
        <p>Choose the option that's most convenient for you, and we'll assist you in securing your card.</p>
      </>
    )
  },
  {
    id: 46,
    question: <>What should I do if I see suspicious activity on my account?</>,
    answer: (
      <p>
        If you spot or receive a notification about suspicious activity on your account, please call us right away. You
        may call your{" "}
        <Link to="/locations" id="faq-locations-internal-link">
          local branch
        </Link>
        , or our Client Care Center is available at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 47,
    question: <>How do I access my funds if I'm traveling abroad?</>,
    answer: (
      <p>
        The security of your funds is our utmost concern. That's why we monitor your accounts for suspicious,
        international activity. If you're heading outside the US, please call your{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>{" "}
        or{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        and notify us of your travel plans. We'll adjust your debit card settings so that you're free to travel and
        access cash without disruption. For international travelers, our debit cards can be used at over 355,000 ATMs
        worldwide, third party usage and foreign exchange fees may apply.
      </p>
    )
  },
  {
    id: 48,
    question: <>How do I know if I can tap to pay with my card?</>,
    answer: (
      <p>
        Look for the Contactless Indicator on your card to know if you can use it to pay for purchases.{" "}
        <img src="/images/contactless-indicator-symbol.png" alt="" style={{ width: "25px" }} />
      </p>
    )
  },
  {
    id: 49,
    question: <>Do I actually have to tap my contactless card on the contactless-enabled terminal?</>,
    answer: (
      <p>
        No. However, the card should be close (within 1-2 inches) to the Contactless Symbol on the contactless-enabled
        terminal.
      </p>
    )
  },
  {
    id: 50,
    question: <>How long do I need to hold my contactless card to the contactless-enabled terminal?</>,
    answer: <p>You should hold your contactless card to the contactless-enabled terminal for 1-2 seconds.</p>
  },
  {
    id: 51,
    question: <>Can I unknowingly make a purchase if I am in close proximity to a contactless-enabled terminal?</>,
    answer: (
      <p>
        No. Contactless technology requires the merchant to first initiate the payment, and the contactless card must be
        held in close proximity (1-2 inches) to the terminal for the transaction to take place.
      </p>
    )
  },
  {
    id: 79,
    question: <>When should you refinance?</>,
    answer: (
      <p>
        Conventional wisdom says that you should consider{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/home-loans/mortgage-refinance">
          refinancing
        </Link>{" "}
        if you can drop your interest rate by about 20%. But be sure to look at what you owe before you refinance and
        compare it to your loan balance after refinancing. If you're adding thousands to your mortgage balance, it might
        end up costing you money to refinance.
      </p>
    )
  },
  {
    id: 80,
    question: <>When will I begin to save money from a refinance?</>,
    answer: (
      <p>
        To calculate when your refinance will actually begin to save you money, take the total cost of your{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/home-loans/mortgage-refinance">
          refinance
        </Link>{" "}
        and divide it by your monthly savings after you refinance. This will tell you how many months it will take to
        pay off the refinance. You will need to live in the property longer than the number of months it takes to payoff
        to actually realize any savings.
      </p>
    )
  },
  {
    id: 81,
    question: <>Can I invest my refinancing savings?</>,
    answer: (
      <>
        <p>
          <Link className="faq-internal-page-link" to="/personal-banking/home-loans/mortgage-refinance">
            Mortgage refinancing
          </Link>{" "}
          can save you tens of thousands of dollars. If you're not strapped for cash, be sure to have a plan in place
          for the money you save from refinancing.
        </p>
        <ul>
          <li>Will you invest in your child's education?</li>
          <li>
            Reinvest in your home and remodel or make other updates that will increase the value of your home so you can
            sell for a higher price in years to come.
          </li>
          <li>Are you going to add your monthly savings into a 401(K) or another retirement savings account?</li>
        </ul>
        <p>
          Be sure to run some financial calculations to see just how much you can save, and have a plan in place for
          your savings to get the most out of your mortgage refinance.
        </p>
      </>
    )
  },
  {
    id: 82,
    question: <>What is a construction to permanent loan?</>,
    answer: (
      <p>
        WaFd Bank's{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/home-loans/construction-loans">
          construction to permanent loan
        </Link>
        is a home loan based on the estimated value of your home after construction. To determine that value upfront, we
        order an appraisal based on your plans. Once your home is built, your construction loan automatically becomes a
        mortgage, so you don't have to worry about refinancing or going through more than one approval process. Please
        note that rates can change daily. Subject to a lock-in deposit.
      </p>
    )
  },
  {
    id: 83,
    question: <>Which remodeling projects have the most cost recouped at resale?</>,
    answer: (
      <>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th style={{ width: "25px" }}>Project</th>
                <th style={{ width: "25px" }}>Job Cost</th>
                <th style={{ width: "25px" }}>Resale Value</th>
                <th style={{ width: "25px" }}>Cost Recouped</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Garage Door Replacement</td>
                <td>$4,041</td>
                <td>$3,769</td>
                <td>93.3%</td>
              </tr>
              <tr>
                <td>Manufactured Stone Veneer</td>
                <td>$11,066</td>
                <td>$10,109</td>
                <td>91.4%</td>
              </tr>
              <tr>
                <td>Minor Kitchen Remodel</td>
                <td>$28,279</td>
                <td>$20,125</td>
                <td>71.2%</td>
              </tr>
              <tr>
                <td>Single Door Replacement: Fiber-Cement</td>
                <td>$22,093</td>
                <td>$15,090</td>
                <td>68.3%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="https://www.remodeling.hw.net/cost-vs-value/2022/">
            https://www.remodeling.hw.net/cost-vs-value/2022/
          </a>
        </p>
      </>
    )
  },
  {
    id: 84,
    question: <>Which remodeling projects have the least cost recouped at resale?</>,
    answer: (
      <>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th style={{ width: "25px" }}>Project</th>
                <th style={{ width: "25px" }}>Job Cost</th>
                <th style={{ width: "25px" }}>Resale Value</th>
                <th style={{ width: "25px" }}>Cost Recouped</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Bathroom Addition</td>
                <td>$63,986</td>
                <td>$33,160</td>
                <td>51.8%</td>
              </tr>
              <tr>
                <td>Major Kitchen Remodel</td>
                <td>$80,809</td>
                <td>$45,370</td>
                <td>56.1%</td>
              </tr>
              <tr>
                <td>Deck Addition - Wood</td>
                <td>$19,248</td>
                <td>$12,464</td>
                <td>64.8%</td>
              </tr>
              <tr>
                <td>Bathroom Remodel</td>
                <td>$27,164</td>
                <td>$15,990</td>
                <td>58.9%</td>
              </tr>
              <tr>
                <td>Prime Suite Addition</td>
                <td>$175,473</td>
                <td>$93,762</td>
                <td>53.4%</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="https://www.remodeling.hw.net/cost-vs-value/2022/">
            https://www.remodeling.hw.net/cost-vs-value/2022/
          </a>
        </p>
      </>
    )
  },
  {
    id: 114,
    question: <>What is WaFd Bank's routing number?</>,
    answer: (
      <p>
        The WaFd Bank routing number is <strong>325070980</strong> for all transactions, including wire transfers,
        automatic or direct deposits, Automated Clearing House (ACH) transactions and ordering checks.
      </p>
    )
  },
  {
    id: 115,
    question: <>What if I've forgotten my username or password?</>,
    answer: (
      <ul>
        <li>
          You can reset your username online by going to our{" "}
          <a
            id="forgot-username-external-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://online.wafdbank.com/link/forgotusername?application=olb"
          >
            Forgot Username
          </a>{" "}
          or{" "}
          <a
            id="forgot-password-external-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://online.wafdbank.com/link/forgotpassword?application=olb"
          >
            Forgot Password
          </a>{" "}
          page.
        </li>
        <li>
          If you run into trouble and need help, please feel free to call our Client Care Center which is open 24 hours
          a day 7 days a week at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          or email{" "}
          <a className="faq-c3-email-link" href="mailto:onlinebanking@wafd.com">
            onlinebanking@wafd.com
          </a>
          .
        </li>
        <li>
          If you're a business, you should call us or email{" "}
          <a className="faq-business-deposit-ops-email-link" href="mailto:businessdepositops@wafd.com">
            businessdepositops@wafd.com
          </a>
          . Email inquiries are responded to within 1-2 business days.
        </li>
      </ul>
    )
  },
  {
    id: 116,
    question: <>What to do if I've lost my debit card?</>,
    answer: (
      <p>
        Call us right away if you've lost your debit card or suspect it might be stolen. You may call your{" "}
        <Link to="/locations" className="faq-internal-page-link">
          local branch
        </Link>
        , or our Client Care Center is available at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 117,
    question: <>Does WaFd Bank offer car, motorcycle, RV, or boat loans?</>,
    answer: (
      <p>
        WaFd Bank does not offer car, motorcycle, RV, or boat loans, but our WaFd Bank Insurance Group does offer
        insurance policies for these items and more to meet your insurance needs. To learn more visit{" "}
        <a
          id="wafd-insurance-external-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.wafdinsurance.com/"
        >
          www.wafdinsurance.com
        </a>{" "}
        or call{" "}
        <a id="faq-wafd-insurance-tel-link" href="tel:800-562-2555">
          800-562-2555
        </a>
        .
      </p>
    )
  },
  {
    id: 118,
    question: <>Did Washington Federal change its name?</>,
    answer: (
      <p>
        We did change our name from Washington Federal to WaFd Bank. We are still the same bank you trust. We launched
        the simplified name because the previous title did not emphasize that we are a bank. Our solution? Put the word
        "bank" in our name -{" "}
        <Link className="faq-internal-page-link" to="/about-us">
          WaFd Bank
        </Link>
        .
      </p>
    )
  },
  {
    id: 119,
    question: <>What does WaFd stand for?</>,
    answer: (
      <p>
        WaFd is our longtime nickname and an abbreviation of Washington Federal for over a century. WaFd Bank also
        aligns with our{" "}
        <a
          id="nasdaq-external-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.nasdaq.com/market-activity/stocks/wafd"
        >
          NASDAQ
        </a>{" "}
        ticker symbol—WAFD. We pronounce it &ldquo;Wah-Fed&rdquo;. For more information visit our{" "}
        <Link className="faq-internal-page-link" to="/about-us">
          About Us
        </Link>{" "}
        page.
      </p>
    )
  },
  {
    id: 120,
    question: <>How do I find my WaFd Bank account number?</>,
    answer: (
      <>
        <p>
          Find your account number by signing in to online banking, checking your bank statement or looking at the
          bottom line of your printed checks. You may also contact your{" "}
          <Link className="faq-internal-page-link" to="/locations">
            local branch
          </Link>{" "}
          for further assistance.
        </p>
        <img
          src="/images/thumbnail-routing-acct-check.png"
          id="faq-check-img"
          alt="WaFd check's routing, checking and check number"
          className="mb-4"
        />
      </>
    )
  },
  {
    id: 121,
    question: (
      <>
        Does WaFd Bank have Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        WaFd Bank has Zelle. It's a fast, safe and easy way to send money to friends, family and associates in minutes
        <sup>1</sup>, right from the WaFd Bank mobile app or online banking. You must have a bank account in the U.S. to
        use Zelle. Transactions typically occur in minutes when the recipient's email address or U.S. mobile number is
        already enrolled with Zelle.{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/mobile-banking-app/zelle">
          Send money with Zelle
        </Link>
        .
      </p>
    )
  },
  {
    id: 122,
    question: <>How many branches does WaFd Bank have?</>,
    answer: (
      <p>
        We currently have over 200 WaFd Bank Branches to serve our clients in the nine western states of Arizona,
        California, Idaho, Nevada, New Mexico, Oregon, Texas, Utah and Washington. Check out our{" "}
        <Link className="faq-internal-page-link" to="/locations">
          branch locations
        </Link>{" "}
        and{" "}
        <Link className="faq-internal-page-link" to="/locations/atm">
          ATM locations
        </Link>
        .
      </p>
    )
  },
  {
    id: 123,
    question: <>Is WaFd Bank a credit union?</>,
    answer: (
      <p>
        WaFd Bank is not a credit union. We are a full-service national bank that does not require membership. We
        provide FDIC deposit insurance for our clients.
      </p>
    )
  },
  {
    id: 124,
    question: <>Can my WaFd Bank account be under $1000?</>,
    answer: (
      <p>
        Yes. WaFd checking and savings accounts may be opened for as low as $25. The Money Market account opening
        deposit is $100. Visit WaFd Bank's{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/checking-account">
          Checking
        </Link>{" "}
        and{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/savings-account">
          Savings
        </Link>{" "}
        pages for more details.
      </p>
    )
  },
  {
    id: 127,
    question: <>Does WaFd Bank offer notary services?</>,
    answer: (
      <p>
        WaFd Bank is pleased to offer complimentary notary services at our{" "}
        <Link className="faq-internal-page-link" to="/locations">
          branch locations
        </Link>
        .
      </p>
    )
  },
  {
    id: 128,
    question: <>How do I go paperless with WaFd Bank?</>,
    answer: (
      <>
        <p>
          To receive paperless statements, simply{" "}
          <a href="https://online.wafdbank.com/index.html" id="faq-128-olb-sign-in-link">
            Sign In
          </a>{" "}
          to Online Banking, select Statements from the menu and then select Account Statements. On the right click the
          "Go Green! Go Paperless!" link.
        </p>
        <img
          src="/images/thumbnail-go-green-go-paperless.jpg"
          alt="WaFd Bank, go green! go paperless!"
          className="my-3"
          style={{ maxWidth: "600px", height: "auto" }}
        />
      </>
    )
  },
  {
    id: 129,
    question: <>Does WaFd Bank have ATMs?</>,
    answer: (
      <p>
        Do we ever! We have <strong>thousands</strong> of Fee-Free{" "}
        <Link className="faq-internal-page-link" to="/locations/atm">
          ATM locations
        </Link>
        .
      </p>
    )
  },
  {
    id: 130,
    question: <>Can I open an account online at WaFd Bank?</>,
    answer: (
      <p>
        Yes.{" "}
        <Link className="faq-internal-page-link" to="/open-bank-account-online">
          Apply for a WaFd Bank account
        </Link>{" "}
        through our simple and secure site in just minutes.
      </p>
    )
  },
  {
    id: 132,
    question: <>How do I order or reorder checks?</>,
    answer: (
      <>
        <p>
          Order personal checks by calling us at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          or contacting your{" "}
          <Link className="faq-internal-page-link" to="/locations">
            local branch
          </Link>
          .
        </p>
        <p>
          To order <strong>business</strong> checks, contact Superior, our new check vendor, directly at{" "}
          <a id="faq-superior-tel-link" href="tel:888-590-7998">
            888-590-7998
          </a>{" "}
          Monday through Friday from 5am to 6pm Pacific Standard Time. You can also{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            id="faq-132-superiorpress-get-a-quote-external-link"
            href="https://www.superiorpress.com/products/business-check-printing#get-a-quote"
          >
            request a quote
          </a>{" "}
          to have a Superior representative contact you.
        </p>
      </>
    )
  },
  {
    id: 133,
    question: <>How do I request a copy of my bank tax statement?</>,
    answer: (
      <p>
        Please contact the Client Care Center at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        to request your 1099/1098 as they are not available online.
      </p>
    )
  },
  {
    id: 134,
    question: <>How do I change my address with WaFd Bank?</>,
    answer: (
      <p>
        To change your address for your bank account, please contact your{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>{" "}
        or our Client Care Center at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 135,
    question: <>How do I close my bank account?</>,
    answer: (
      <p>
        Closing a bank account requires a physical signature, please reach out to your{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local WaFd Bank branch
        </Link>
        .
      </p>
    )
  },
  {
    id: 136,
    question: <>How do I add/remove someone to/from my bank account?</>,
    answer: (
      <p>
        Please visit your{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>{" "}
        to add/remove someone to/from a bank account as this type of change requires a physical signature.
      </p>
    )
  },
  {
    id: 137,
    question: <>When can I expect an electronic bank deposit to my WaFd Bank account?</>,
    answer: (
      <p>
        WaFd Bank processes electronic payments during business hours Monday through Friday, except on Federal holidays
        when the bank is closed.
      </p>
    )
  },
  {
    id: 138,
    question: <>Does WaFd Bank process payments on public bank holidays or weekends?</>,
    answer: (
      <p>
        No, WaFd Bank processes electronic payments during business hours Monday through Friday as we are closed on
        Federal holidays.
      </p>
    )
  },
  {
    id: 150,
    question: <>What is "Hold: Visa Provisioni Visa Provisioning S CAUS"?</>,
    answer: (
      <p>
        When you setup your WaFd Bank debit card in Apple Wallet, Google, or some other digital wallet application they
        will place a hold for $0.00 on your account. The hold will typically last for 72 hours and then will fall off
        your pending transaction list.
      </p>
    )
  },
  {
    id: 152,
    question: <>Can I view my loan statements from online and mobile banking?</>,
    answer: <p>Yes, loan statements are available in both online and mobile banking.</p>
  },
  {
    id: 154,
    question: <>How can I update my phone, email, and mailing address?</>,
    answer: (
      <p>
        You can update your phone and email via online and mobile banking. To update your mailing address, contact your
        local branch or call our Client Care Center at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 156,
    question:
      'I was trying to add an external account and received the following message: "The routing number is invalid or not supported. Please check the ABA/routing number you have entered or enter a different ABA/routing number." What do I do?',
    answer: (
      <p>
        While we are able to instantly verify many external banks in the US when an account is being added, some
        financial institutions are not supported. If you receive this message, we recommend using Zelle<sup>&reg;</sup>{" "}
        as an alternative which supports sending funds to email, phone, and account/routing number.
      </p>
    )
  },
  {
    id: 159,
    question: <>How do I pay my WaFd Bank mortgage?</>,
    answer: (
      <p>
        After logging in to the app or online banking, select Move Money, then Internal Transfer to pay from your WaFd
        account. You can also set up EZ-Pay to automatically pay from a WaFd checking account; visit a branch or call us
        at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        to set this up. For other loans, go to Bill Pay.
      </p>
    )
  },
  {
    id: 162,
    question: <>How can I apply for a credit card?</>,
    answer: (
      <>
        <ol>
          <li>
            Visit{" "}
            <a className="faq-internal-page-link" href="/creditcard">
              wafdbank.com/creditcard
            </a>
            .
          </li>
          <li>
            Click <strong>Apply Now</strong> under the credit card product you want.
          </li>
          <li>Follow the prompts for the online application process.</li>
        </ol>
        <p>
          Please visit your{" "}
          <Link to="/locations" className="faq-internal-page-link">
            local branch
          </Link>{" "}
          if you need additional assistance.
        </p>
      </>
    )
  },
  {
    id: 163,
    question: <>How do I access my credit card account?</>,
    answer: (
      <ol>
        <li>
          Visit{" "}
          <a className="faq-internal-page-link" href="/creditcard">
            wafdbank.com/creditcard
          </a>
          .
        </li>
        <li>Access the credit card portal.</li>
        <li>
          Type your credentials to log in.
          <br />
          <em>If you're a new user, you'll be prompted to enroll to create your account.</em>
        </li>
        <li>
          If you're a WaFd Bank consumer accountholder (with a checking or savings account) with WaFd Bank online
          banking, you can:
          <ul>
            <li>Verify your credit card balance.</li>
            <li>View limited related information.</li>
            <li>Access a direct link to the credit card portal for full functionality.</li>
          </ul>
        </li>
      </ol>
    )
  },
  {
    id: 164,
    question: <>How long until I receive my credit card?</>,
    answer: <p>Those who were automatically approved should receive their credit card in 7-10 business days.</p>
  },
  {
    id: 165,
    question: <>My application is being reviewed. When will I be approved?</>,
    answer: (
      <p>
        Generally, we begin manually reviewing applications the next business day. If we have additional questions,
        we'll reach out to you. Usually, the review can take a week or so, but sometimes can take a couple of weeks.
      </p>
    )
  },
  {
    id: 166,
    question: <>I was not approved. Why?</>,
    answer: (
      <>
        <p>Your credit card application underwent a thorough decisioning process based on the following:</p>
        <ul>
          <li>Your credit history</li>
          <li>Underwriting standards</li>
          <li>Bank's risk policies</li>
        </ul>
        <p>
          Our decision may have been based in whole or in part on information obtained in a report from a consumer
          reporting agency. The reporting agency played no part in our decision and is unable to supply specific reasons
          why we have denied credit to you. Those who are denied will receive a letter in the mail defining the reasons
          for the denial.
        </p>
      </>
    )
  },
  {
    id: 167,
    question: <>How do I activate my credit card?</>,
    answer: (
      <>
        <p>You must enroll before you are able to activate your new credit card.</p>
        <p>
          <strong>Enroll</strong>
        </p>
        <ol>
          <li>
            Visit{" "}
            <a className="faq-internal-page-link-2" href="/creditcard">
              wafdbank.com/creditcard
            </a>
            .
          </li>
          <li>Access the credit card portal, and follow the prompts to create credentials.</li>
        </ol>
        <p>
          <strong>Activate online</strong>
        </p>
        <ol>
          <li>
            Visit{" "}
            <a className="faq-internal-page-link-3" href="/creditcard">
              wafdbank.com/creditcard
            </a>
            .
          </li>
          <li>Access the credit card portal.</li>
          <li>Log into the portal.</li>
          <li>
            Select the <strong>Account Services</strong> menu.
          </li>
          <li>
            Locate and select the <strong>Card Activation</strong> link, and follow the prompts to activate your card.
          </li>
        </ol>
        <p>
          <strong>Activate by phone</strong>
        </p>
        <p>
          Activate your card by phone at{" "}
          <a className="faq-credit-card-activation-tel-link-2" href="tel:866-513-0483">
            866-513-0483
          </a>
          . For issues with activation, call our Client Care Center at{" "}
          <a className="faq-credit-card-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 168,
    question: <>I already have a WaFd Bank credit card. Is this one different?</>,
    answer: (
      <>
        <p>
          If you already have a credit card with a WaFd Bank logo, then yes, it is different! The credit card you have
          was provided by WaFd Bank through a partnership with Elan. We made the decision to end our partnership with
          Elan and will no longer be offering their credit card products effective April 1, 2020.
        </p>
        <ul>
          <li>
            Your existing credit card account and terms will not change. It just will no longer be supported by WaFd
            Bank. You will still have full card functionality and will be able to access your account by going directly
            to the{" "}
            <a
              id="my-account-access-external-link-2"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.myaccountaccess.com"
            >
              myaccountaccess.com
            </a>{" "}
            portal.
          </li>
          <li>
            Your plastic card will not be automatically reissued, until it expires or is replaced due to being lost or
            stolen. At that time, you can expect a new card with the Elan logo replacing the WaFd Bank logo.
          </li>
          <li>
            If you wish to apply for a new WaFd Bank credit card, you may do so by applying on our website or contacting
            your{" "}
            <Link to="/locations" className="faq-internal-page-link">
              local branch
            </Link>
            .
          </li>
        </ul>
      </>
    )
  },
  {
    id: 169,
    question: <>I forgot my username or password</>,
    answer: (
      <>
        <ol>
          <li>Access the login screen.</li>
          <li>
            Select <strong>Forgot Your Username?</strong>
          </li>
          <li>Follow the steps to reset your information if needed.</li>
        </ol>
        <p>
          If you need additional assistance, please call our Client Care Center at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          or email{" "}
          <a className="faq-ask-wafd-cards-email-link" href="mailto:ask@wafdcards.com">
            ask@wafdcards.com
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 170,
    question: <>What if my card is lost, stolen, or damaged?</>,
    answer: (
      <p>
        You can report your card as lost, stolen, or damaged and order a replacement by contacting our Client Care
        Center at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 171,
    question: <>How do I enroll in paperless statements?</>,
    answer: (
      <>
        <p>There are two statement delivery options:</p>
        <ul>
          <li>
            <>
              <strong>Email</strong>
              <br />
            </>
            Opts you out of receiving paper statements.
          </li>
          <li>
            <>
              <strong>Mail</strong>
              <br />
            </>
            Statements are mailed to you and are available online.
          </li>
        </ul>
        <p>To select your statement delivery option, follow the steps below:</p>
        <ol>
          <li>
            Visit{" "}
            <a className="faq-internal-page-link" href="/creditcard">
              wafdbank.com/creditcard
            </a>
            .
          </li>
          <li>Locate and access the credit card portal.</li>
          <li>Log in using your credentials.</li>
          <li>
            In the <strong>Statements</strong> menu, select <strong>Statement Delivery Options</strong>.
          </li>
          <li>Select your statement delivery method.</li>
        </ol>
      </>
    )
  },
  {
    id: 172,
    question: <>How do I make a payment?</>,
    answer: (
      <>
        <p>You can pay your credit card using one of the following options:</p>
        <ul>
          <li>
            <strong>Online</strong>
            <br />
            To make a payment online
            <ol>
              <li>
                Visit{" "}
                <a className="faq-internal-page-link" href="/creditcard">
                  wafdbank.com/creditcard
                </a>
                .
              </li>
              <li>Access the credit card portal.</li>
              <li>Log into the portal.</li>
              <li>
                Select <strong>Payment</strong> to begin setting up your payment.
              </li>
            </ol>
          </li>
          <li>
            <strong>Phone</strong>
            <br />
            To make a payment by phone, call us at{" "}
            <a className="faq-c3-tel-link" href="tel:800-324-9375">
              800-324-9375
            </a>
          </li>
          <li>
            <strong>Mail</strong>
            <br />
            To make a payment by mail, mail a check with the statement payment coupon.
          </li>
          <li>
            <strong>In Person</strong>
            <br />
            To make a payment in person, visit one of our{" "}
            <Link to="/locations" className="faq-internal-page-link">
              local branches
            </Link>
            .
          </li>
        </ul>
      </>
    )
  },
  {
    id: 173,
    question: <>What permissions are given to authorized users?</>,
    answer: (
      <>
        <p>
          Authorized users are given permission by the primary account owner to make transactions with their card, such
          as purchases or cash advances. Authorized users aren't responsible for paying the credit balance. The primary
          account owner is responsible for the credit balance. However, authorized users can make a payment online or by
          visiting a WaFd Bank branch to make an in-person payment.
          <br />
          <strong className="text-danger">Caution:</strong> Authorized users cannot make cash payments.
        </p>
        <p>
          An authorized user can enroll in the online credit card portal where they have full access to transaction
          history, statements, and can initiate disputes. Authorized users cannot change any of the primary account
          information or request limit changes.
        </p>
      </>
    )
  },
  {
    id: 174,
    question: <>Is an authorized user the same as a joint owner?</>,
    answer: (
      <p>
        No. We don't allow joint owners for any of our consumer credit card products at this time. An authorized user is
        an individual given permission to use the primary account owner's card to make purchases and isn't responsible
        for the credit card balance. The credit card account shows up on their credit report as a line of credit
        account. The use and repayment of the credit card may affect their credit report.
      </p>
    )
  },
  {
    id: 177,
    question: <>What happened to telephone banking?</>,
    answer: (
      <p>
        WaFd Bank has rolled out a new{" "}
        <a
          id="faq-voice-activated-banking-link"
          className="faq-internal-page-link"
          href="/personal-banking/voice-recognition-technology"
        >
          Voice-Activated Banking
        </a>{" "}
        service that has replaced our traditional telephone banking.
      </p>
    )
  },
  {
    id: 178,
    question: <>What is Voice-Activated Banking?</>,
    answer: (
      <>
        <p>
          <Link className="faq-internal-page-link" to="/personal-banking/voice-recognition-technology">
            Voice-Activated Banking
          </Link>{" "}
          is a service that uses your unique voice to verify who you are. After you've authenticated your identity
          securely using your voice, our automated service lets you manage your accounts using voice commands such as
          &ldquo;What's my balance?&rdquo; or &ldquo;Transfer funds&rdquo;.
        </p>
        <p>Signing up is easy:</p>
        <ol>
          <li>If you haven't already, you must sign up for consumer online or mobile banking.</li>
          <li>
            Next, please call{" "}
            <a className="faq-c3-tel-link" href="tel:800-324-9375">
              800-324-9375
            </a>{" "}
            so that we can set up your Voice-Activated Banking profile&mdash;you'll then be guided to record your voice,
            so that our service can authenticate you going forward.
          </li>
          <li>
            Anytime you call in, the service will ask you to authenticate using your voice. Once authenticated, the
            service will say "Hi, how can I help you today?" and will then offer suggestions such as "provide account
            balance", "make a transfer", or "talk to an agent".
          </li>
        </ol>
      </>
    )
  },
  {
    id: 179,
    question: <>What are the daily limits on my WaFd debit card?</>,
    answer: (
      <>
        <p>ATM Withdrawals and POS Limits</p>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>
                <strong>Transaction Type</strong>
              </td>
              <td>
                <strong>Consumer Limits</strong>
              </td>
              <td>
                <strong>Business Limits</strong>
              </td>
            </tr>
            <tr>
              <td>
                <strong>POS (Point of Sale)</strong>
              </td>
              <td>$3,000 per day per card</td>
              <td>$5,000 per day per card</td>
            </tr>
            <tr>
              <td>
                <strong>ATM Withdrawal</strong>
              </td>
              <td>$800 per day per card</td>
              <td>$800 per day per card</td>
            </tr>
          </tbody>
        </table>
      </>
    )
  },
  {
    id: 180,
    question: <>How do I deposit a check after hours?</>,
    answer: (
      <>
        <ul>
          <li>
            There are two easy ways to deposit a check on evenings and weekends. Every WaFd Bank branch has a smart ATM
            that allows you to deposit checks (and cash) without using an envelope. And you'll see images of your
            deposited check right on your receipt.
          </li>
          <li>
            You can also deposit a check using your smartphone. With Mobile Photo Deposit, use the WaFd Bank mobile
            banking app to snap a photo of the front and back of your check. Just follow the on-screen instructions.
          </li>
        </ul>
        <p>
          Reminder: A hold applies to items deposited via the ATM or mobile photo deposit until we can verify the
          validity of the items deposited. If you'd like to request that the hold be removed earlier than normal, please
          call our Client Care Center at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 181,
    question: <>How do I access my account online?</>,
    answer: (
      <ul>
        <li>
          Access your WaFd Bank checking, savings, money market and CDs&mdash;as well as your loans with us&mdash;via
          online and mobile banking. Sign up is easy, just visit our{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://online.wafdbank.com/link/register?application=OLB"
            id="faq-olb-enroll-link"
            className="olb-sign-in-link"
          >
            Online Banking and Mobile enrollment page
          </a>
          .
        </li>
        <li>
          You'll need at least one account number along with your Social Security Number to get started. Once you're
          enrolled, you can also download our mobile app and link your accounts to your smartphone. Start with a visit
          to the{" "}
          <a
            id="apple-app-external-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://apps.apple.com/us/app/wafd-bank/id1054549841"
          >
            Apple App
          </a>{" "}
          or{" "}
          <a
            id="google-app-external-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.washingtonfederal.mobilebanking"
          >
            Google Play
          </a>{" "}
          store and search for "WaFd Bank".
        </li>
      </ul>
    )
  },
  {
    id: 182,
    question: <>How do I update my mortgage hazard insurance?</>,
    answer: (
      <p>
        Please contact your insurance agent and request that they send us evidence of acceptable Hazard Insurance
        coverage. Verification may be emailed to{" "}
        <a id="faq-182-ssis-email-link" href="mailto:docsend@fmq.alliedsolutions.net">
          docsend@fmq.alliedsolutions.net
        </a>
        . If you have any questions, call{" "}
        <a id="faq-182-ssis-tel-link" href="tel:800-653-8812">
          800-653-8812
        </a>
        .
      </p>
    )
  },
  {
    id: 185,
    question: <>How do I clear my browser cache and cookies?</>,
    answer: (
      <>
        <p>Outdated cookies can cause loading and formatting issues, clearing them fixes certain problems.</p>
        <ul>
          <li>
            <a
              id="chrome-clear-history-external-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://support.google.com/accounts/answer/32050"
            >
              Chrome
            </a>
          </li>
          <li>
            <a
              id="safari-clear-history-external-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://support.apple.com/guide/safari/clear-your-browsing-history-sfri47acf5d6/mac"
            >
              Safari
            </a>
          </li>
          <li>
            <a
              id="edge-clear-history-external-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://support.microsoft.com/en-us/microsoft-edge/view-and-delete-browser-history-in-microsoft-edge-00cf7943-a9e1-975a-a33d-ac10ce454ca4"
            >
              Edge
            </a>
          </li>
          <li>
            <a
              id="firefox-clear-history-external-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://support.mozilla.org/en-US/kb/how-clear-firefox-cache"
            >
              Firefox
            </a>
          </li>
        </ul>
      </>
    )
  },
  {
    id: 187,
    question: <>Does WaFd Bank support Quicken and Quickbooks?</>,
    answer: (
      <>
        <p>
          Yes, WaFd Bank supports Quicken and Quickbooks. To download Quicken files, clients will need to enroll in our
          Treasury Express tool on our business platform. You will be able to access your personal account via this
          Treasury tool. To request the ability to integrate your personal WaFd financial accounts, please visit our{" "}
          <Link id="quicken-access-form-link" to="/personal-banking/online-banking/quicken">
            Quicken page
          </Link>{" "}
          and fill out the access form.
        </p>
        <p>
          Upon receipt of your request, it will take 2-3 business days for us to setup your access. A WaFd Banker will
          send you an email with instructions on how to access Treasury and how to download Quicken files.
        </p>
      </>
    )
  },
  {
    id: 190,
    question: <>Having issues opening up online statements or tax statements?</>,
    answer: (
      <>
        <p>
          If you are having trouble downloading a statement it may be due to a browser pop-up blocker, please try
          disabling it temporarily or adding wafdbank.com to your list of allowed sites.
        </p>
        <p>To access your browsers pop-up setting please select from one of the approved WaFd Bank browsers below.</p>
        <ol>
          <li>
            <a
              id="chrome-block-popup-external-link"
              rel="noopener noreferrer"
              href="https://support.google.com/chrome/answer/95472?hl=en&co=GENIE.Platform%3DDesktop"
            >
              Chrome
            </a>
          </li>
          <li>
            <a
              id="edge-block-popup-external-link"
              rel="noopener noreferrer"
              href="https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5"
            >
              Edge
            </a>
          </li>
          <li>
            <a
              id="firefox-block-popup-external-link"
              rel="noopener noreferrer"
              href="https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting"
            >
              Firefox
            </a>
          </li>
          <li>
            <a
              id="safari-block-popup-external-link"
              rel="noopener noreferrer"
              href="https://support.apple.com/guide/safari/block-pop-ups-sfri40696/mac"
            >
              Safari
            </a>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 215,
    question: <>Do I have to open a checking account to get a mortgage from WaFd Bank?</>,
    answer: (
      <p>
        No, it will never be required to open a checking account in order to apply for a mortgage with WaFd Bank. We are
        offering up to $600 off closing costs as an incentive to those who choose to open an account and make their
        payments from their account.
      </p>
    )
  },
  {
    id: 216,
    question: <>Is this offer only available when I'm purchasing a new home?</>,
    answer: (
      <p>
        No, you can apply this offer towards any new WaFd Bank home loan, including Refinancing, Remodeling, Lot,
        Construction, and Home Equity Loans.
      </p>
    )
  },
  {
    id: 217,
    question: <>I'm a WaFd Customer, but don't have a checking account. Can I still get this deal?</>,
    answer: (
      <p>
        No, you'll need a WaFd Checking account to be eligible for the full $600 off. However, your loan officer can
        help you open an account and sign up!{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/contact-loan-officer">
          Find a Loan Officer
        </Link>
      </p>
    )
  },
  {
    id: 224,
    question: <>Will my child get an ATM card?</>,
    answer: <p>Yes, at the request of the custodian/parent/legal guardian.</p>
  },
  {
    id: 225,
    question: <>Are ATM cards different than debit cards?</>,
    answer: <p>Yes, ATM cards cannot be used to make store or online purchases.</p>
  },
  {
    id: 226,
    question: <>Is there an age requirement for access to WafdBank.com?</>,
    answer: (
      <p>
        The Child Online Privacy Protection Act (COPPA) restricts the collection of personal information from children
        for the purpose of website use. For this reason, clients under age 13 cannot sign up for online banking access.
      </p>
    )
  },
  {
    id: 227,
    question: <>Can my child get text alerts about their balance?</>,
    answer: (
      <p>
        Online Banking offers the ability to set up various alert types that can be sent via email or text. Clients over
        the age of 13 are eligible to enroll in Online Banking and get alerts.
      </p>
    )
  },
  {
    id: 228,
    question: <>How do I change my child's ATM card PIN?</>,
    answer: (
      <p>
        If you've forgotten or need to change your ATM card PIN please call{" "}
        <a id="faq-228-atm-pin-tel-link" href="tel:866-661-8550">
          866-661-8550
        </a>
        .
      </p>
    )
  },
  {
    id: 229,
    question: <>What should I do if my child's card is lost, damaged or stolen?</>,
    answer: (
      <p>
        If your child has lost their ATM card or suspect it might be stolen, then we'll quickly disable your old card
        and get you a new one. You may call your local branch, or our Client Care Center is available at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 230,
    question: <>How does my child get online access?</>,
    answer: (
      <p>
        Children over the age of 13 can{" "}
        <a id="online-wafd-external-link" href="https://online.wafdbank.com/link/register?application=OLB">
          {" "}
          enroll in online banking
        </a>{" "}
        or by downloading the WaFd Bank app from our{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/online-banking">
          Online Banking page
        </Link>
        .
      </p>
    )
  },
  {
    id: 231,
    question: <>How can my child deposit checks and cash?</>,
    answer: (
      <p>
        Children can deposit checks or cash by using{" "}
        <Link className="faq-internal-page-link" to="/locations/atm" id="atm-locations-link-1">
          WaFd Bank ATMs
        </Link>{" "}
        (if they have an ATM card), visiting their local branch or using mobile deposit (if over 13 and enrolled in
        online/mobile banking).
      </p>
    )
  },
  {
    id: 232,
    question: <>Can people other than parents make deposits to this account?</>,
    answer: (
      <p>
        Account owners (children, parents, legal guardians or custodians) can make deposits. Restrictions may apply for
        other individuals.
      </p>
    )
  },
  {
    id: 233,
    question: <>Will my child's savings account need to be reported on my taxes?</>,
    answer: (
      <p>
        At WaFd Bank, the minor account is opened under the child's Social Security Number. If interest income is
        reported to the IRS, a 1099-INT will be issued under the child's name. For more assistance, please consult with
        a tax specialist.
      </p>
    )
  },
  {
    id: 234,
    question: <>Can my child make ATM withdrawals from their savings account?</>,
    answer: (
      <p>
        If an ATM card is requested and issued, withdrawals can be made at{" "}
        <Link className="faq-internal-page-link" to="/locations/atm" id="atm-locations-link-2">
          WaFd Bank ATMs
        </Link>{" "}
        or at over thousands MoneyPass ATMs.
      </p>
    )
  },
  {
    id: 236,
    question: (
      <>
        What are Zelle<sup>&reg;</sup> transfer limits?
      </>
    ),
    answer: (
      <table className="table table-bordered table-fixed">
        <thead className="thead-green">
          <tr>
            <th className="w-75">Transfer Details</th>
            <th className="w-25">Limit</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Maximum number of transfers per day</td>
            <td className="text-right">15</td>
          </tr>
          <tr>
            <td>Maximum number of transfers per month (Rolling 30 day window)</td>
            <td className="text-right">30</td>
          </tr>
          <tr>
            <td>Minimum transfer amount</td>
            <td className="text-right">$5</td>
          </tr>
          <tr>
            <td>Daily maximum amount for same day transfers</td>
            <td className="text-right">$600</td>
          </tr>
          <tr>
            <td>Monthly maximum amount for same day transfers (Rolling 30 day window)</td>
            <td className="text-right">$600</td>
          </tr>
          <tr>
            <td>Daily maximum amount for next day or standard transfers</td>
            <td className="text-right">$3,000</td>
          </tr>
          <tr>
            <td>Monthly maximum amount for next day or standard transfers (Rolling 30 day window)</td>
            <td className="text-right">$10,000</td>
          </tr>
        </tbody>
      </table>
    )
  },
  {
    id: 237,
    question: (
      <>
        Can I pay a small business with Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        Some small businesses are able to receive payments with Zelle<sup>&reg;</sup>. Ask your favorite small business
        if they accept payments with Zelle<sup>&reg;</sup>. If they do, you can pay them directly from your WaFd Bank
        mobile app using just their email address or U.S. mobile number. Neither WaFd Bank nor Zelle<sup>&reg;</sup>{" "}
        offers a protection program for any authorized payments made with Zelle<sup>&reg;</sup>, so you should only send
        money to people (and small businesses) you trust. Also, always ensure you've used the correct email address or
        U.S. mobile number when sending money.
      </p>
    )
  },
  {
    id: 238,
    question: (
      <>
        What if I want to send money to someone whose bank or credit union doesn't offer Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          If your recipient's bank or credit union isn't with Zelle<sup>&reg;</sup>, don't worry! The list of
          participating financial institutions is always growing, and your recipient can still use Zelle<sup>&reg;</sup>{" "}
          by downloading the Zelle<sup>&reg;</sup> app for Android and iOS.
        </p>
        <p>
          To enroll with the Zelle<sup>&reg;</sup> app, your recipient will enter their basic contact information, an
          email address and U.S. mobile number, and a Visa or Mastercard debit card with a U.S. based account (does not
          include U.S. territories). Zelle<sup>&reg;</sup> does not accept debit cards associated with international
          deposit accounts or any credit cards.
        </p>
      </>
    )
  },
  {
    id: 239,
    question: (
      <>
        When trying to enroll with Zelle<sup>&reg;</sup>, I received a message saying that I was already enrolled. Why?
      </>
    ),
    answer: (
      <p>
        A couple of reasons why you may be receiving this message:
        <ul>
          <li>Your mobile number or email address is already enrolled with a bank or credit union</li>
          <li>
            You're an existing customer, and after Nov. 15, 2021, you are having problems with Zelle<sup>&reg;</sup>.
          </li>
        </ul>
        In order to fix your enrollment for both use cases above, you must contact support at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 241,
    question: <>How do I cancel a Request for money?</>,
    answer: (
      <p>
        To cancel a request for money, open Zelle<sup>&reg;</sup> and select Activity. Under your Pending list you will
        see your sent Requests for money, just hit Cancel.
      </p>
    )
  },
  {
    id: 256,
    question: <>Can I add money to my CD after it has been opened?</>,
    answer: (
      <>
        <p>
          No, we don't offer the ability to add funds after the account is opened unless the CD is held in an IRA,
          SEP-IRA, or ESA Plan.
        </p>
        <p>
          If additional funds are brought in the same day of the account opening (day when the signature card is
          generated), we will add them to the CD. Otherwise, you will need to open another CD.
        </p>
      </>
    )
  },
  {
    id: 257,
    question: <>Can I withdraw my funds before the CD maturity date?</>,
    answer: <p>Yes, however you will be subject to a penalty.</p>
  },
  {
    id: 258,
    question: <>What is the penalty for early withdrawal?</>,
    answer: (
      <>
        <p>
          We will impose a penalty if you withdraw any of the deposited funds prior to the maturity date, whether earned
          or not. We will charge the full penalty regardless of the amount of time the funds have been on deposit. The
          amount of penalty depends on the current term of the Certificate, as follows:
        </p>
        <>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th style={{ width: "30%" }}>Certificate Term</th>
                  <th style={{ width: "70%" }}>Penalty</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Twelve (12) months or less</td>
                  <td>90 days interest</td>
                </tr>
                <tr>
                  <td>More than twelve (12) months but less than four (4) years</td>
                  <td>180 days interest</td>
                </tr>
                <tr>
                  <td>Four (4) years or more</td>
                  <td>365 days interest</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            For more information, refer to the{" "}
            <a
              id="consumer-disclosure-guide-file"
              target="_blank"
              href="/documents/wafdbank-consumer-disclosure-guide.pdf"
            >
              Personal Deposit Account Agreement
            </a>
            .
          </p>
        </>
      </>
    )
  },
  {
    id: 259,
    question: <>How do I renew my CD after it matures?</>,
    answer: (
      <p>
        The Certificate will automatically renew for the renewal term specified on the maturing Certificate at the
        interest rate offered at the time of renewal for Certificates with like amounts and maturities. Any accumulated
        interest becomes principal upon renewal and unless withdrawn during the Grace Period, will be subject to penalty
        if withdrawn during the new term. For more information, refer to the Deposit Account Agreement. If you'd like to
        renew to a different term, please visit a{" "}
        <Link to="/locations" className="faq-internal-page-link">
          local WaFd Bank branch
        </Link>{" "}
        or call us at{" "}
        <a id="phone-to-renew-term" className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 260,
    question: <>How do I close a CD account?</>,
    answer: (
      <p>
        To close your CD, please visit a{" "}
        <Link to="/locations" className="faq-internal-page-link">
          local WaFd Bank branch
        </Link>{" "}
        or call us at{" "}
        <a id="phone-to-close-cd" className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 261,
    question: <>How often is interest paid on a CD?</>,
    answer: (
      <p>
        Interest accrues daily and is paid on or before the last Calendar Day of the quarter. Interest payments can be
        paid at other frequencies, such as monthly or semi-annually, upon request. For CD terms shorter than 3 months,
        we will pay any accrued interest monthly or upon maturity.
      </p>
    )
  },
  {
    id: 262,
    question: <>What happens if I don't renew my CD after it matures?</>,
    answer: (
      <p>
        The CD will automatically renew. There is a grace period of 10 days following the maturity date. During the
        grace period, you may deposit, withdraw, or change the rate and term of the CD without an interest penalty.
      </p>
    )
  },
  {
    id: 263,
    question: <>Is it possible to have a joint account for a CD?</>,
    answer: (
      <p>
        Yes, when you open the CD, please request to add another individual. Please note that the joint owner will need
        to provide their personal information and sign the signature card.
      </p>
    )
  },
  {
    id: 264,
    question: <>How is the interest on a CD taxed?</>,
    answer: <p>Please consult your tax attorney.</p>
  },
  {
    id: 265,
    question: <>Do I need to make an appointment to open a CD?</>,
    answer: <p>You don't have to make an appointment, but it is recommended.</p>
  },
  {
    id: 266,
    question: <>Do I have to open a CD in person?</>,
    answer: (
      <p>
        Yes, you will need to visit a{" "}
        <Link to="/locations" class="faq-internal-page-link">
          WaFd Bank branch
        </Link>
        .
      </p>
    )
  },
  {
    id: 267,
    question: <>Does Treasury Express have a mobile application?</>,
    answer: (
      <>
        <p>Yes, the app can be found in the App Store or Google Play store by searching "WaFd Treasury"</p>
        <a href="https://apps.apple.com/us/app/wafd-treasury/id1343834928" target="_blank" rel="noopener noreferrer">
          <img className="m-3" src="/images/download-apple-app-store.png" alt="" />
        </a>{" "}
        <a
          href="https://play.google.com/store/apps/details?id=com.obs.android.olm.washfed.prod&hl=en_US"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="m-3" src="/images/google-play-icon.png" alt="" />
        </a>
      </>
    )
  },
  {
    id: 268,
    question: <>Do sub-users have access to the App?</>,
    answer: <p>WaFd provides access to company Administrators, who can elect to give access to additional users.</p>
  },
  {
    id: 269,
    question: <>Do I need to enter my Activation Key every time?</>,
    answer: (
      <p>
        No, the Activation key is a one-time registration, you will be prompted only if you have selected the Forgot
        Password option.
      </p>
    )
  },
  {
    id: 270,
    question: <>The Mobile App asks for a PIN?</>,
    answer: (
      <p>
        Once your app is registered, the PIN is a simplified version of the log in process. This PIN can be the same as
        your Password to the desktop version or it can be different.
      </p>
    )
  },
  {
    id: 271,
    question: <>Can I initiate Payments through the Mobile App?</>,
    answer: <p>Yes! Payments and Positive Pay (Check Validation) can be administered using the Treasury Mobile App</p>
  },
  {
    id: 283,
    question: <>¿Cuál es el número de ruta de WaFd Bank?</>,
    answer: (
      <p>
        El número de ruta de WaFd Bank es <strong>325070980</strong> para todas las transacciones, incluyendo las
        transferencias bancarias electrónicas, los depósitos automáticos o directos, las transacciones de cámara de
        compensación automatizada (ACH) y los pedidos de cheques.
      </p>
    )
  },
  {
    id: 284,
    question: <>¿Qué pasa si olvidé mi nombre de usuario o mi contraseña?</>,
    answer: (
      <ul>
        <li>Puede restablecer su nombre de usuario o contraseña en la página web o aplicación móvil.</li>
        <li>
          Si tiene problemas y necesita ayuda, no dude en llamar a nuestro Centro de Atención al Cliente, que atiende
          las 24 horas del día, los 7 días de la semana, al{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          o envíe un correo electrónico a{" "}
          <a className="faq-c3-email-link" href="mailto:onlinebanking@wafd.com">
            onlinebanking@wafd.com
          </a>
          .
        </li>
        <li>
          Si es una empresa, debe llamarnos o enviarnos un correo electrónico a{" "}
          <a id="faq-business-deposit-ops-email-link" href="mailto:businessdepositops@wafd.com">
            businessdepositops@wafd.com
          </a>
          . (Las consultas por correo electrónico se responderán de 1 a 2 días hábiles).
        </li>
      </ul>
    )
  },
  {
    id: 285,
    question: <>¿Cómo deposito un cheque fuera del horario de atención?</>,
    answer: (
      <>
        <ul>
          <li>
            Ofrecemos dos formas fáciles para depositar cheques por la tarde o durante los fines de semana. Todas las{" "}
            <Link to="/es/sucursales" className="faq-internal-page-link">
              sucursales de WaFd Bank
            </Link>{" "}
            cuentan con un cajero automático inteligente que le permite depositar cheques (y efectivo) sin la necesidad
            de usar un sobre. Y verá la imágenes del cheque depositado en el recibo.
          </li>
          <li>
            También puede depositar un cheque usando su teléfono inteligente. Con el depósito fotográfico móvil, use la
            aplicación Banca móvil de WaFd Bank para tomar fotografías por ambos lados de su cheque. Siga las
            instrucciones en pantalla.
          </li>
        </ul>
        <p>
          Recordatorio: Se aplica una retención al depósito fotográfico móvil o mediante cajero automático hasta que
          verifiquemos la validez de su depósito. Si desea solicitar la eliminación de la retención antes de lo normal,
          llame a nuestro Centro de Atención al Cliente al{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 286,
    question: <>¿Cómo accedo a mi cuenta en línea?</>,
    answer: (
      <ul>
        <li>
          Puede acceder a su cuenta de cheques, de ahorro, de mercado monetario o a los certificados de depósito de WaFd
          Bank, así como a sus préstamos con nosotros, mediante la banca en línea y móvil. Inscribirse es fácil;
          simplemente visite nuestra página de inscripción de la{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://online.wafdbank.com"
            className="olb-sign-in-link"
            id="faq-es-olb-enroll-link"
          >
            banca en línea y móvil
          </a>
          .
        </li>
        <li>
          Necesitará al menos un número de cuenta junto con su número de Seguro Social para comenzar. Una vez que se ha
          inscrito, también puede descargar nuestra aplicación móvil y vincular sus cuentas con su teléfono inteligente.
          Comience por visitar{" "}
          <a
            id="apple-app-external-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://apps.apple.com/us/app/wafd-bank/id1054549841"
          >
            Apple App Store
          </a>{" "}
          o{" "}
          <a
            id="google-app-external-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.washingtonfederal.mobilebanking"
          >
            Google Play
          </a>{" "}
          y busque “WaFd Bank”.
        </li>
      </ul>
    )
  },
  {
    id: 287,
    question: <>¿Qué pasa si pierdo mi tarjeta de débito?</>,
    answer: (
      <p>
        Llámenos directamente si es que perdió su tarjeta de débito o si sospecha de fraude o robo. Puede llamar a la{" "}
        <Link to="/es/sucursales" className="faq-internal-page-link">
          sucursal local
        </Link>{" "}
        o nuestro Centro de Atención al Cliente disponible en el número{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 288,
    question: (
      <>
        ¿Ofrece WaFd Bank préstamos para la compra de automóviles, motocicletas, vehículos recreativos o embarcaciones?
      </>
    ),
    answer: (
      <p>
        WaFd Bank no ofrece préstamos para la compra para automóviles, motocicletas, vehículos recreativos o
        embarcaciones, pero WaFd Bank Insurance Group sí ofrece pólizas de seguro para estos artículos y más para
        satisfacer sus necesidades de seguro. Visite WaFd Bank Insurance Group para obtener más información en{" "}
        <a
          id="wafd-insurance-external-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.wafdinsurance.com/"
        >
          www.wafdinsurance.com
        </a>{" "}
        o llame al{" "}
        <a id="faq-wafd-insurance-tel-link" href="tel:800-562-2555">
          800-562-2555
        </a>
        .
      </p>
    )
  },
  {
    id: 289,
    question: <>¿Cambió Washington Federal su nombre?</>,
    answer: (
      <p>
        Washington Federal modificó el nombre a WaFd Bank. Todavía somos el mismo banco en el que usted confía. Lanzamos
        el nombre simplificado porque el nombre anterior no hacía hincapié en que somos un banco. ¿Nuestra solución?
        Poner la palabra "banco" en nuestro nombre: WaFd Bank.
      </p>
    )
  },
  {
    id: 290,
    question: <>¿Qué significa WaFd?</>,
    answer: (
      <p>
        WaFd es nuestro apodo de big data y la abreviatura de Washington Federal durante más de un siglo. WaFd Bank
        también concuerda con nuestro símbolo bursátil de{" "}
        <a
          id="nasdaq-external-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.nasdaq.com/market-activity/stocks/wafd"
        >
          NASDAQ
        </a>
        , WAFD. Se pronuncia "ua-fed".
      </p>
    )
  },
  {
    id: 291,
    question: <>¿Cómo encuentro mi número de cuenta de WaFd Bank?</>,
    answer: (
      <p>
        Inicie sesión en la banca en línea, revise su estado de cuenta bancario o mire la línea inferior de sus cheques
        impresos para encontrar su número de cuenta. También puede llamar al Centro de Atención al Cliente para obtener
        ayuda al{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        en cualquier momento.
      </p>
    )
  },
  {
    id: 292,
    question: (
      <>
        ¿WaFd Bank tiene Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        WaFd Bank tiene Zelle. Es una forma rápida, segura y sencilla de enviar dinero a amigos, familiares y socios en
        minutos<sup>1</sup>, directamente desde la aplicación móvil de WaFd Bank o de la banca en línea. Para utilizar
        Zelle, debe tener una cuenta bancaria en EE. UU. En general, las transacciones se realizan en minutos cuando la
        dirección de correo electrónico del destinatario o el número de teléfono móvil de EE. UU. ya está registrados en
        Zelle.
      </p>
    )
  },
  {
    id: 293,
    question: <>¿Cuántas sucursales tiene WaFd Bank?</>,
    answer: (
      <p>
        Actualmente, tenemos más de 200 sucursales de WaFd Bank para atender a nuestros clientes en los ocho estados
        occidentales de Washington, Oregon, Idaho, Utah, Arizona, Nevada, Nuevo México y Texas. Dele un vistazo a las{" "}
        <Link className="faq-internal-page-link" to="/es/sucursales">
          ubicaciones de nuestras sucursales
        </Link>{" "}
        y{" "}
        <Link className="faq-internal-page-link" to="/locations/atm">
          cajeros automáticos
        </Link>
        .
      </p>
    )
  },
  {
    id: 294,
    question: <>¿WaFd Bank es una cooperativa de crédito?</>,
    answer: (
      <p>
        WaFd Bank no es una cooperativa de crédito. Somos un banco regional de servicio completo que no requiere
        membresía. Ofrecemos el seguro de depósito de la FDIC a nuestros clientes.
      </p>
    )
  },
  {
    id: 295,
    question: <>¿Puede ser inferior a $1000 mi depósito de apertura de una cuenta en WaFd Bank?</>,
    answer: (
      <p>
        Sí. Las cuentas de cheques y de ahorros de WaFd pueden abrirse con tan solo $25. El depósito de apertura de la
        cuenta de mercado monetario es de $100. Visite las páginas de{" "}
        <Link className="faq-internal-page-link" to="/es/banca-personal/cuenta-de-cheques">
          Cuentas de cheques
        </Link>{" "}
        y{" "}
        <Link className="faq-internal-page-link" to="/es/banca-personal/cuentas-de-ahorro">
          Cuentas de ahorros
        </Link>{" "}
        de WaFd Bank para obtener más detalles.
      </p>
    )
  },
  {
    id: 296,
    question: <>¿Qué tipos de préstamos ofrece WaFd Bank?</>,
    answer: (
      <p>
        WaFd Bank tiene el{" "}
        <Link className="faq-internal-page-link" to="/es/banca-personal/prestamos-hipotecarios">
          préstamo
        </Link>{" "}
        para usted: refinanciamiento, remodelación, construcción personalizada, equidad de la vivienda, préstamos para
        compra de lote o bienes raíces comerciales y líneas de crédito comerciales. Estamos para ayudarle.
      </p>
    )
  },
  {
    id: 297,
    question: <>¿WaFd Bank ofrece préstamos de cartera?</>,
    answer: (
      <p>
        Estamos orgullosos de ser un prestamista de cartera. Nosotros originamos y retenemos su préstamo hipotecario
        durante todo el plazo. Dado que no vendemos nuestros préstamos al mercado secundario, podemos brindarles a
        nuestros prestatarios flexibilidad y servicio personalizado; además, siempre estamos dispuestos a contestar sus
        preguntas.
      </p>
    )
  },
  {
    id: 298,
    question: <>¿WaFd Bank ofrece servicios notariales?</>,
    answer: (
      <p>
        WaFd Bank se complace en ofrecer servicios notariales de cortesía en nuestras{" "}
        <Link className="faq-internal-page-link" to="/es/sucursales">
          sucursales
        </Link>
        .
      </p>
    )
  },
  {
    id: 299,
    question: <>¿Cómo puede cambiarse al servicio electrónico en WaFd Bank?</>,
    answer: (
      <p>
        Para cambiarse al servicio electrónico, simplemente inicie sesión en la banca en línea, escoja la configuración
        en la parte superior de la página, luego seleccione Estados de cuenta electrónicos. Siga las indicaciones para
        cambiar todas las cuentas elegibles a estados de cuenta electrónicos.
      </p>
    )
  },
  {
    id: 300,
    question: <>¿WaFd Bank tiene cajeros automáticos?</>,
    answer: (
      <p>
        ¡Claro! Más de <strong>miles</strong>{" "}
        <Link className="faq-internal-page-link" to="/locations/atm">
          ubicaciones de cajeros automáticos sin cargo
        </Link>
        .
      </p>
    )
  },
  {
    id: 301,
    question: <>¿Puedo abrir una cuenta en línea en WaFd Bank?</>,
    answer: (
      <p>Sí. Solicite una cuenta de WaFd Bank a través de nuestro sitio fácil de usar y seguro en solo minutos.</p>
    )
  },
  {
    id: 303,
    question: <>¿Cómo actualizar su seguro de riesgo hipotecario?</>,
    answer: (
      <p>
        Comuníquese con su agente de seguros y solicite que nos envíe evidencia de cobertura aceptable de seguro de
        riesgos. La verificación puede enviarse por correo electrónico a{" "}
        <a id="faq-303-ssis-email-link" href="mailto:docsend@fmq.alliedsolutions.net">
          docsend@fmq.alliedsolutions.net
        </a>
        . Si tiene alguna pregunta, llame al{" "}
        <a id="faq-303-ssis-tel-link" href="tel:800-653-8812">
          800-653-8812
        </a>
        .
      </p>
    )
  },
  {
    id: 304,
    question: <>¿Tengo que abrir una cuenta corriente para obtener una hipoteca de WaFd Bank?</>,
    answer: (
      <p>
        No, nunca será necesario abrir una cuenta corriente para solicitar una hipoteca con WaFd Bank. Ofrecemos hasta
        $600 de descuento en los costos de cierre como incentivo para aquellos que eligen abrir una cuenta y hacer sus
        pagos desde su cuenta.
      </p>
    )
  },
  {
    id: 305,
    question: <>¿Esta oferta solo está disponible cuando compro una casa nueva?</>,
    answer: (
      <p>
        No, puede aplicar esta oferta a cualquier préstamo hipotecario nuevo de WaFd Bank, incluidos los préstamos para
        refinanciamiento, remodelación, lote, construcción y préstamos con garantía hipotecaria.
      </p>
    )
  },
  {
    id: 306,
    question: <>Ya tengo una cuenta de cheques WaFd, ¿puedo aprovechar esta oferta?</>,
    answer: (
      <p>
        Sí, si ya tiene una cuenta corriente WaFd con depósito directo, es elegible para obtener hasta $200 dólares de
        descuento en los costos de cierre de su hipoteca al momento del cierre del préstamo.
      </p>
    )
  },
  {
    id: 307,
    question: (
      <>Para obtener hasta $400 de descuento adicional, dice que necesito registrarme en EZ-Pay. ¿Qué es EZ-Pay?</>
    ),
    answer: (
      <p>
        EZ-Pay es un programa de transferencia electrónica de fondos que recauda los pagos mensuales del préstamo
        directamente de su cuenta corriente en cualquier banco utilizando su número de cuenta y de ruta.
      </p>
    )
  },
  {
    id: 308,
    question: <>¿Cómo me registro en EZ-Pay?</>,
    answer: <p>Su agente hipotecario o su oficial de préstamos pueden ayudarlo a completar el acuerdo EZ-Pay.</p>
  },
  {
    id: 330,
    question: <>How long does it take to sign up?</>,
    answer: <p>The enrollment process takes less than 3 minutes.</p>
  },
  {
    id: 331,
    question: <>Will I still have to answer security questions or give one-time passcodes?</>,
    answer: (
      <p>
        Once enrolled, the system authenticates you using your voice. Now you no longer have to share personal
        information out loud, making this more secure.
      </p>
    )
  },
  {
    id: 332,
    question: <>What if I'm sick and sound differently than I normally do?</>,
    answer: (
      <p>
        WaFd Voice-Activated Banking is able to recognize you even with a cold. The voice authentication system can
        recognize key features of your voiceprint to provide access. If it can't, you'll simply be transferred to a
        helpful Client Care Center agent to assist you.
      </p>
    )
  },
  {
    id: 342,
    question: <>What is LIBOR?</>,
    answer: (
      <>
        <p>
          The London Interbank Offered Rate (LIBOR) is a benchmark variable interest rate that major global banks have
          historically used to lend to one another, published daily by the Intercontinental Exchange Benchmark
          Administration (ICE). For many years, LIBOR has been the dominant benchmark rate for determining interest
          payments on variable rate financial products.
        </p>
        <p>
          The methodology for calculating LIBOR has remained largely unchanged since it was introduced. Each day, a
          group of large banks, known as "panel banks," report their funding rates to ICE, which averages, adjusts, and
          publishes those rates daily.
        </p>
      </>
    )
  },
  {
    id: 343,
    question: <>What is the LIBOR transition?</>,
    answer: (
      <p>
        The "LIBOR transition" references the discontinuation of LIBOR and the transition away from LIBOR-based rates.
      </p>
    )
  },
  {
    id: 344,
    question: <>When will LIBOR rates no longer be available?</>,
    answer: (
      <p>
        Tenors of LIBOR will not be published after June 30, 2023. Federal banking regulators instructed banks to stop
        originating new LIBOR loans no later than December 31, 2021.
      </p>
    )
  },
  {
    id: 345,
    question: <>What are possible replacement rates for LIBOR?</>,
    answer: (
      <p>
        Many different rates have been considered as replacement indexes by different institutions, with varying levels
        of market acceptance. Replacement and alternative rates include Wall Street Journal Prime ("WSJP"), SOFR, and
        BSBY.
      </p>
    )
  },
  {
    id: 346,
    question: <>What is SOFR?</>,
    answer: (
      <>
        <p>
          The Secured Overnight Financing Rate (SOFR) represents the interest rate that banks impose on each other in
          making loans secured by U.S. Treasuries. SOFR is a daily, overnight, secured, risk-free rate, released by the
          Federal Reserve every morning.
        </p>
        <p>
          "Term SOFR" is a forward-looking rate representing a projection of what daily SOFR will be on a certain date
          in the future. Unlike LIBOR, which is a forward-looking, credit-sensitive rate meant to reflect a bank's cost
          of capital, SOFR measures rates applicable to short-term, secured financing. Because SOFR is secured (while
          LIBOR is unsecured), SOFR has historically been a lower rate than LIBOR, which means it will require a spread
          adjustment if used as a replacement to a LIBOR-based loan.
        </p>
        <p>
          <strong>ARRC Recommended Rate &ndash;</strong> The Alternative Reference Rates Committee (ARRC), a group
          convened by the Federal Reserve Bank of New York, has recommended SOFR as a LIBOR alternative.
        </p>
      </>
    )
  },
  {
    id: 347,
    question: <>What is BSBY?</>,
    answer: (
      <>
        <p>
          The Bloomberg Short-Term Bank Yield Index (BSBY) is a proprietary, credit-sensitive index, that incorporates
          bank credit spreads and calculates a forward term structure. BSBY seeks to measure the average yields at which
          large global banks accessed USD senior, unsecured, wholesale funding.
        </p>
        <p>
          Despite ARRC's recommendation of SOFR as the replacement/alternative to LIBOR, some financial institutions
          prefer BSBY as a replacement rate, particularly because of its nature as a credit-sensitive, forward-looking
          term rate that has historically behaved very similarly to LIBOR.
        </p>
        <p>
          <strong>Comparison of BSBY v. LIBOR</strong>
        </p>
        <ul>
          <li>Both reflect market lending costs</li>
          <li>As forward-looking rates, both anticipate policy rate moves</li>
        </ul>

        <p>
          <strong>Comparison of BSBY v. SOFR</strong>
        </p>
        <ul className="mb-0">
          <li>Both are based on significant transactional volume (though SOFR's volume exceeds that of BSBY)</li>
          <li>Neither is reliant on expert judgment</li>
          <li>As a forward-looking rate, both BSBY and Term SOFR seek to anticipate movement in advance.</li>
          <li>
            SOFR is based on secured repo transactions and will respond to liquidity changes in that market. BSBY will
            respond to conditions in financial markets that affect pricing of short-term fundings
          </li>
        </ul>
      </>
    )
  },
  {
    id: 348,
    question: <>Which of these replacement rates will WaFd Bank be using?</>,
    answer: (
      <>
        <p>
          After carefully monitoring market developments and acceptance, WaFd Bank plans to follow the ARRC's
          replacement rate and spread adjustment recommendations to transition the commercial loans in the bank's
          portfolio by June 30, 2023. WaFd Bank intends to use to use the following Term SOFR plus a spread adjustment
          for commercial loans that were priced using LIBOR:
        </p>
        <table className="table table-bordered w-lg-50">
          <thead className="bg-info">
            <tr className="fw-bold text-white">
              <td className="w-50 text-center">Term</td>
              <td className="text-center">Tenor Spread Adjustment</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Overnight</td>
              <td>0.644 bps</td>
            </tr>
            <tr>
              <td>1-Month</td>
              <td>11.448 bps</td>
            </tr>
            <tr>
              <td>3-Month</td>
              <td>26.161 bps</td>
            </tr>
            <tr>
              <td>6-Month</td>
              <td>42.826 bps</td>
            </tr>
            <tr>
              <td>12-Month</td>
              <td>71.513 bps</td>
            </tr>
          </tbody>
        </table>
        <p>
          While this Adjusted Term SOFR will serve as the replacement rate for WaFd Bank's Commercial Loans whose rates
          have not otherwise been transitioned prior to June 30, 2023, affected commercial clients who would prefer to
          use alternative replacement rates have the option of WSJP, SOFR and BSBY. WSJP, SOFR and BSBY are available
          for pricing new commercial loans, or for pro-actively transitioning existing LIBOR loans prior to June 30,
          2023.
        </p>
        <p>
          Derivatives Products &ndash; LIBOR-based commercial loans that are subject to interest rate hedges, swaps, or
          other derivatives products will require coordination in advance of the June 30, 2023, transition deadline in
          order to transition both the underlying loan product and the derivative product to replacement rates that
          maintain the economics with as little cost and disruption to your client and WaFd Bank as possible.
        </p>
      </>
    )
  },
  {
    id: 349,
    question: <>What happens to my existing LIBOR-based loan?</>,
    answer: (
      <p>
        LIBOR-based loans that mature after June 30, 2023, will need to be transitioned to an alternative fallback rate
        (Term SOFR, please see above for more information on fallback rates). Affected clients can expect to receive
        communication form their relationship manager during the first quarter of 2023 describing the details of the
        transition and any required actions.
      </p>
    )
  },
  {
    id: 350,
    question: <>What about LIBOR-based loans that are subject to a Swap, hedge, or other derivative products?</>,
    answer: (
      <p>
        Swaps and other derivative products define the index rate used separately from the underlying loan documents,
        and those currently referencing a LIBOR index will also need to be revised to use an alternate index rate when
        LIBOR becomes unavailable. For the derivative products to function as intended, the replacement index in the
        derivative should match the replacement index used in the underlying loan transaction. Existing LIBOR-based
        derivatives (and their related loans) will be transitioned to Term SOFR. This transition will need to occur
        prior to June 30, 2023.
      </p>
    )
  },
  {
    id: 360,
    question: <>Can I use Quicken Connect to download my transactions with WaFd Bank?</>,
    answer: <p>Yes, WaFd Bank supports Quicken Express Connect and Web Connect.</p>
  },
  {
    id: 361,
    question: <>Can I download my transactions using Quicken Web Connect?</>,
    answer: (
      <p>
        No, WaFd Bank is not currently supporting the ability to download .qbo or .qfx files for import into Quicken.
      </p>
    )
  },
  {
    id: 362,
    question: <>What type of WaFd Bank accounts can I access through Quicken?</>,
    answer: (
      <>
        <p>You can access the following WaFd Bank account types through Quicken:</p>
        <ul className="mt-3 mb-0">
          <li className="mb-0">All Savings and Checking Accounts</li>
        </ul>
      </>
    )
  },
  {
    id: 388,
    question: <>Is there a minimum age to use Greenlight?</>,
    answer: <p>We support kids and grownups of all ages. No minimum (or maximum) age here!</p>
  },
  {
    id: 389,
    question: <>Where is the Greenlight card accepted?</>,
    answer: (
      <p>
        Just about anywhere, as long as Mastercard is accepted, online, and in-store. As the cards are intended for use
        by kids, there are restrictions in place to ensure the card cannot be used at certain companies and retailers.
      </p>
    )
  },
  {
    id: 390,
    question: <>Can parents see spending history in Greenlight?</>,
    answer: <p>Check all spending history right within the Greenlight app!</p>
  },
  {
    id: 391,
    question: <>Is Greenlight safe?</>,
    answer: (
      <p>
        Greenlight debit cards are FDIC insured up to $250,000 and come with Mastercard's Zero Liability Protection.
        Greenlight blocks “unsafe” spending categories, sends real-time transaction notifications, lets parents turn
        cards off at any time, and gives parents flexible ATM and spending controls.
      </p>
    )
  },
  {
    id: 392,
    question: <>How long does it take for Greenlight debit cards to arrive?</>,
    answer: (
      <p>
        It should arrive in 7-10 business days with free standard shipping. You can also track your card's shipping
        status in the Greenlight app to see when your card is estimated to arrive!
      </p>
    )
  },
  {
    id: 393,
    question: <>Does Greenlight work with Apple Pay and Google Pay?</>,
    answer: (
      <p>
        Yes, once your cards have been activated your kids can add their Greenlight card details to Apple Pay or Google
        Pay to tap and pay in an instant. This is subject to Apple Pay and Google Pay age requirements.
      </p>
    )
  },
  {
    id: 394,
    question: <>How is Greenlight different from a traditional debit card?</>,
    answer: (
      <p>
        It's built with families in mind and is for kids, managed by parents. Using the Greenlight app parents can
        easily manage and see where, when, and how much kids spend to help them learn to manage their money and get
        real-time transaction alerts.
      </p>
    )
  },
  {
    id: 395,
    question: <>I already use and pay for Greenlight, can I get it for free through WaFd Bank?</>,
    answer: (
      <p>
        Existing Greenlight Customers are eligible for a discount (the cost of the SELECT plan) toward the Greenlight
        plan of their choice when they connect their WaFd account as the Greenlight funding source. After connecting
        your WaFd Checking account, call Greenlight at{" "}
        <a href="tel:888-483-2645" id="faq-greenlight-tel-link">
          888-483-2645
        </a>{" "}
        and request to receive the WaFd Bank discount.
      </p>
    )
  },
  {
    id: 396,
    question: <>Why is the LIBOR transition happening?</>,
    answer: (
      <>
        <p>The LIBOR transition is happening because of two main concerns with the LIBOR calculation process:</p>
        <ul>
          <li>
            There has been a significant decline in the sample size for calculating LIBOR since the 2008 financial
            crisis. Fewer panel banks have been reporting, and those that do, report fewer quotes based on market
            transactions. Instead, LIBOR has increasingly relied on, what ICE calls, &ldquo;market and transaction
            data-based expert judgment&rdquo;. Therefore, concerns were raised about how well LIBOR reflects market
            realities.
          </li>
          <li>
            LIBOR's reliance on inputs from panel banks opened it to manipulation, and there have been a range of
            irregularities uncovered by regulators.
          </li>
        </ul>
      </>
    )
  },
  {
    id: 397,
    question: (
      <>
        How do I send money with Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        You can send, request, or receive money with Zelle<sup>&reg;</sup>. After you've enrolled, simply add your
        recipient's email address or U.S. mobile number, the amount you'd like to send or request, review and add a
        memo, and hit "confirm." In most cases, the money is typically available in minutes.
      </p>
    )
  },
  {
    id: 398,
    question: <>What is your maximum loan to value (LTV)?</>,
    answer: <p>Loan amounts up to 75% LTV</p>
  },
  {
    id: 399,
    question: <>What are your Debt Service Coverage Ratio (DSCR) requirements?</>,
    answer: (
      <p>
        Multifamily properties and manufactured home parks require a DSCR of 1.25x for purchases and non-cash-out
        refinance requests, and 1.30x for cash-out refinance requests. Self-storage facilities require a DSCR of 1.30x
        for purchases and non cash-out refinance requests, and 1.35x for cash-out refinance requests.
      </p>
    )
  },
  {
    id: 400,
    question: <>Do your loans have prepayment penalties?</>,
    answer: <p>Our loans have step-down prepayment schedules.</p>
  },
  {
    id: 402,
    question: <>Can you provide financing for a small manufactured home park?</>,
    answer: (
      <p>
        The minimum park size we finance is 20 pads. We require approximately 75% of the pads in the park be double-wide
        in size, the park be connected to public utilities, have paved streets, and have no more than 10% park- owned
        homes.
      </p>
    )
  },
  {
    id: 403,
    question: <>Do you provide financing for a small self-storage property?</>,
    answer: <p>The minimum size self-storage property we finance is 30 units.</p>
  },
  {
    id: 404,
    question: <>Do you offer construction financing?</>,
    answer: (
      <p>
        The Community Multi-Family Lending department offers financing on existing, stabilized properties, and does not
        provide construction financing. Please refer to WaFd Bank's Commercial Real Estate teams for additional
        information on construction lending.
      </p>
    )
  },
  {
    id: 405,
    question: <>Where does WaFd Bank lend?</>,
    answer: (
      <p>
        WaFd Bank is located in 9 western states and finances properties within its branch footprint. WaFd has branches
        in Washington, Oregon, Idaho, Nevada, Utah, Arizona, New Mexico, Texas, and California.
      </p>
    )
  },
  {
    id: 406,
    question: <>Can I dispute more than one transaction in Consumer Online Banking?</>,
    answer: (
      <p>
        No. At this time, disputes are limited to one transaction. If you need to dispute multiple transactions, you can
        contact your
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>{" "}
        or give us a call at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        and we will assist you.
      </p>
    )
  },
  {
    id: 407,
    question: <>Can I dispute a pending transaction?</>,
    answer: (
      <p>
        Only completed transactions can be disputed. If you need more information on a pending transaction, please
        contact your{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>{" "}
        or give us a call at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 408,
    question: <>How can I cancel a debit card dispute?</>,
    answer: (
      <p>
        Please contact your{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>{" "}
        or give us a call at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        and we can assist with your cancellation request.
      </p>
    )
  },
  {
    id: 409,
    question: <>How do I find out the status of my debit card dispute?</>,
    answer: (
      <p>
        Please contact your{" "}
        <Link to="/locations" className="faq-internal-page-link">
          local branch
        </Link>{" "}
        or give us a call at{" "}
        <a href="tel:800-324-9375" className="faq-c3-tel-link">
          800-324-9375
        </a>{" "}
        and we can assist with providing the status.
      </p>
    )
  },
  {
    id: 410,
    question: <>When will I find out if my account is credited for a dispute?</>,
    answer: (
      <p>
        We will mail a letter if your account is given
        <span
          id="provisional-tooltip"
          className="border-primary cursor-pointer"
          style={{ borderBottom: "1px dotted" }}
          title="A provisional credit is when WaFd Bank temporarily gives you the money back for a disputed transaction(s) while we investigate a dispute."
        >
          provisional
        </span>
        or
        <span
          id="final-credit-tooltip"
          className="border-primary cursor-pointer"
          style={{ borderBottom: "1px dotted" }}
          title="A provisional credit becomes final when WaFd completes investigating a disputed transaction(s) and determines funds are owed to you."
        >
          final credit
        </span>
        on a dispute, generally within 10 business days of receiving your dispute. We will also mail a letter if your
        dispute is denied.
      </p>
    )
  },
  {
    id: 412,
    question: <>Why was my dispute denied?</>,
    answer: (
      <p>
        After researching, if your dispute was denied we will mail a letter with information that explains why the
        dispute was denied.
      </p>
    )
  },
  {
    id: 413,
    question: <>Can I file a debit card dispute in Business Online Banking?</>,
    answer: (
      <p>
        No. Only consumer disputes may be filed in online banking. Business and Commercial clients file debit card
        disputes with your relationship manager, the{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>
        , or by calling us at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 414,
    question: <>Do I have to sign a form to submit a debit card dispute?</>,
    answer: (
      <p>
        No, generally we can process your dispute without a signature. If we need a signature, we will follow up with
        you.
      </p>
    )
  },
  {
    id: 415,
    question: <>Do I have to file a police report before I can submit a dispute?</>,
    answer: (
      <p>
        No. A police report is not required to submit a dispute in online banking or to a WaFd Bank employee. If you
        believe you have fraudulent charges on your account, we encourage you to file a police report.
      </p>
    )
  },
  {
    id: 416,
    question: <>Will WaFd Bank file a police report if I submit a debit card dispute?</>,
    answer: <p>As part of processing your dispute we may determine a police report is applicable.</p>
  },
  {
    id: 417,
    question: <>Why can't I dispute an ATM withdrawal, Check, ACH, or Wire on my account?</>,
    answer: (
      <p>
        Currently, WaFd Bank only allows debit card disputes in Online Banking. We are working on adding more
        transaction types to our Consumer Online Banking dispute process. If you need to file a dispute for an ATM
        withdrawal, Check, ACH, or Wire, please contact your{" "}
        <Link className="faq-internal-page-link" to="/locations">
          local branch
        </Link>{" "}
        or call us 24/7 at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        to assist.
      </p>
    )
  },
  {
    id: 418,
    question: <>Why can't you just email or send me a text about my dispute?</>,
    answer: (
      <p>
        Currently WaFd Bank can send all dispute notices and updates via USPS mail. Look for future updates to include
        email and text options!
      </p>
    )
  },
  {
    id: 419,
    question: <>If I file a debit card dispute, will WaFd Bank close my account or my debit card?</>,
    answer: (
      <p>
        In some cases of fraud disputes, we may need to close your account. If this is necessary, you will receive a
        closed account letter in the mail or a warning letter listing the date the account will be closed. In cases of
        debit card disputes for fraud or unauthorized transactions, we will close your debit card and issue a
        replacement.
      </p>
    )
  },
  {
    id: 420,
    question: <>Can the Greenlight card be added to Mobile Wallet?</>,
    answer: (
      <p>
        Yes you can link your card to Apple Pay or Google Pay for secure, contactless payments. This is subject to Apple
        Pay and Google Pay age requirements.
      </p>
    )
  },
  {
    id: 421,
    question: <>What is a Pending Payment Transaction?</>,
    answer: (
      <p>
        Depending on the payment type, there can be a hold placed for fraud verification purposes. The payment is
        considered as processing during this time, and funds and balance are restored shortly. If you have specific
        questions on the primary account owner's account, call{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 422,
    question: <>What is a Pending Debit Transaction?</>,
    answer: (
      <p>
        A pending debit transaction occurs when a debit card transaction has been authorized by the cardholder but
        hasn't been fully processed by the merchant or card issuer. It involves obtaining approval from the card issuer
        to ensure sufficient funds are available. The transaction amount is temporarily reserved, reducing the available
        balance but not yet deducted from the actual account balance. Pending transactions remain in a transitional
        state until they are completed, which usually takes a few business days. They may be labeled differently on
        account statements or online banking portals and can be canceled or modified before final processing. Once
        completed, they become completed debit transactions.
      </p>
    )
  },
  {
    id: 423,
    question: <>What is a Pending Deposit Transaction?</>,
    answer: (
      <p>
        A pending deposit transaction occurs when a deposit has been initiated, but has not been fully processed by the
        bank yet. While pending, the deposit temporarily increases the account balance but cannot be immediately
        withdrawn. The duration of the pending status varies, usually taking a few business days for the deposit to be
        fully processed and the funds to become available. Once completed, the pending status is removed and the funds
        are officially credited to the account for withdrawals or other transactions.
      </p>
    )
  },
  {
    id: 424,
    question: <>How do I set up direct deposit?</>,
    answer: (
      <>
        <p>
          Many businesses offer the option to update direct deposit information directly through their payroll or human
          resources department, site, or application. If that option is not available, you may follow these simple
          steps:
        </p>
        <ol>
          <li>
            Complete the pre-filled WaFd Bank direct deposit form. Here's{" "}
            <a href="#faq-accordion-434" id="faq-424-internal-faq-434-link">
              how to find the routing number and your account number
            </a>
            .
          </li>
          <li>Give the completed form and a voided check (if required) to your employer or payer.</li>
        </ol>
        <p>
          For Social Security or other government payments go to{" "}
          <a
            href="https://fiscal.treasury.gov/GoDirect"
            target="_blank"
            rel="noopener noreferrer"
            id="faq-424-external-fiscal-enroll-link"
          >
            fiscal.treasury.gov/GoDirect
          </a>
          to enroll.
        </p>
      </>
    )
  },
  {
    id: 425,
    question: <>What information do I need to provide to my employer or payer for direct deposit?</>,
    answer: (
      <ol>
        <li>Your employee ID or Social Security Number</li>
        <li>
          Your WaFd Bank account number -{" "}
          <a href="#faq-accordion-434" className="faq-425-internal-faq-434-link">
            How do I find the routing number and my account number?
          </a>
        </li>
        <li>Your WaFd Bank Routing/ABA Number: 325070980</li>
        <li>Your WaFd Bank account type</li>
        <li>
          Some employers or payers will require a WaFd Bank voided check -{" "}
          <a href="#faq-accordion-433" className="faq-425-internal-faq-433-link">
            How do I order checks
          </a>
          ?
        </li>
      </ol>
    )
  },
  {
    id: 426,
    question: <>How long does it take for direct deposit to be activated?</>,
    answer: (
      <p>
        In most cases, direct deposit takes one to two pay cycles. This can vary by employer or payroll provider. Please
        check directly with your employer or payer for specific timing.
      </p>
    )
  },
  {
    id: 427,
    question: <>Can I split my direct deposit into multiple accounts?</>,
    answer: (
      <p>
        Yes, in many cases, you can split your direct deposit into multiple accounts. To set up multiple account
        allocations for your direct deposit, you will need to provide the relevant account numbers, routing numbers, and
        account types for each designated account to your employer or payer.{" "}
      </p>
    )
  },
  {
    id: 428,
    question: <>Is direct deposit available for government benefits like Social Security or Military?</>,
    answer: (
      <p>
        Yes. Go to{" "}
        <a
          href="https://fiscal.treasury.gov/GoDirect"
          id="faq-428-external-fiscal-enroll-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          fiscal.treasury.gov/GoDirect
        </a>{" "}
        to enroll.
      </p>
    )
  },
  {
    id: 429,
    question: <>Can I change my direct deposit information if I switch banks or get a new account?</>,
    answer: (
      <p>
        Yes, you can change your direct deposit information if you switch banks or get a new account. Notify your
        employer or payer as soon as possible about the change in your banking information. They will provide you with
        the necessary forms or instructions to update your direct deposit details.
      </p>
    )
  },
  {
    id: 430,
    question: <>What if I need to stop or cancel my direct deposit?</>,
    answer: (
      <p>
        If you need to stop or cancel your direct deposit, notify your employer or payer immediately and inform them of
        your decision to stop or cancel your direct deposit.
      </p>
    )
  },
  {
    id: 431,
    question: <>Will I receive a confirmation when my direct deposit is set up?</>,
    answer: (
      <p>
        For direct deposit set up confirmation, please contact your employer or payer. You can set up account alerts to
        be notified when your payroll is deposited to your WaFd Bank account.
      </p>
    )
  },
  {
    id: 432,
    question: <>Can my child direct deposit into their Greenlight account?</>,
    answer: (
      <p>
        Yes! Follow the{" "}
        <a
          id="faq-external-greenlight-direct-deposit-instructions-link"
          href="https://help.greenlight.com/hc/en-us/articles/360006464873-What-is-direct-deposit-and-how-does-it-work"
          target="_blank"
          rel="noopener noreferrer"
        >
          Greenlight direct deposit instructions
        </a>
        .
      </p>
    )
  },
  {
    id: 433,
    question: <>How do I order checks?</>,
    answer: (
      <>
        <p>It's simple to order checks from WaFd Bank.</p>
        <ol>
          <li>Sign in to Online Banking</li>
          <li>Navigate to your checking account page</li>
          <li>Look for the Actions menu on the right and select Order Checks</li>
        </ol>
        <p>
          Alternatively, you can call us at{" "}
          <a href="tel:800-324-9375" className="faq-c3-tel-link">
            800-324-9375
          </a>{" "}
          24/7 or visit your{" "}
          <Link to="/locations" className="faq-internal-locations-page-link">
            local branch
          </Link>{" "}
          to order checks.
        </p>
      </>
    )
  },
  {
    id: 434,
    question: <>How do I find the routing number and my account number?</>,
    answer: (
      <>
        <p>
          The routing number and your account number can be found on your WaFd bank check.{" "}
          <strong>WaFd Routing Number: 325070980</strong>
        </p>
        <img src="/images/thumbbnail-voided-wafd-check.jpg" alt="WaFd Bank void check" className="w-100" />
        <p>
          You can also find your account number by signing into{" "}
          <a
            href="https://online.wafdbank.com/index.html"
            id="faq-external-online-banking-sign-in-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            online banking
          </a>{" "}
          or into the{" "}
          <Link to="/personal-banking/online-banking#mobile-app-section" id="faq-internal-ob-page-mobile-app-section">
            WaFd mobile app
          </Link>
          . On your account transaction page, you can see your account number next to your account name.
        </p>
        <div className="row mb-3">
          <div className="col-lg-6">
            <img src="/images/thumbnail-account-number-olb.jpg" alt="WaFd Bank online banking" className="mb-3" />
            <div>
              Click the
              <div className="fa-reg-eye-icon mr-1 d-inline-block"></div>
              eye icon to reveal the entire account number.
            </div>
          </div>
          <div className="col-lg-6">
            <img
              src="/images/thumbnail-account-number-mobile-app.jpg"
              alt="WaFd Bank online banking transaction page"
            />
          </div>
        </div>
      </>
    )
  },
  {
    id: 435,
    question: <>Is there a limit to the amount I can deposit via mobile?</>,
    answer: <p>There is a limit of $50,000 per deposit and a $100,000 limit per day.</p>
  },
  {
    id: 436,
    question: <>When will the mobile deposit funds be available?</>,
    answer: (
      <p>
        The first $225 is available immediately, and the remainder of the funds are available the following business
        day, excluding Federal Holidays (Monday-Friday). Accepted deposits before 3 PM PT on a business day will be
        credited to your account by 6 PM PT the next business day.
      </p>
    )
  },
  {
    id: 437,
    question: <>Can I make a mobile deposit via online banking?</>,
    answer: (
      <p>
        No, you must use the WaFd mobile app to make a mobile deposit. To download the mobile app, please go to the{" "}
        <a
          className="faq-internal-page-link"
          id="faq-mobile-app-link-1"
          href="/personal-banking/online-banking#mobile-app-section"
        >
          app store
        </a>
        .
      </p>
    )
  },
  {
    id: 438,
    question: <>Do I need the WaFd Bank mobile app to make a mobile deposit?</>,
    answer: (
      <p>
        Yes, you need to use the WaFd Bank mobile app to make a mobile deposit. To download the mobile app, please go to
        the{" "}
        <a
          className="faq-internal-page-link"
          id="faq-mobile-app-link-2"
          href="/personal-banking/online-banking#mobile-app-section"
        >
          app store
        </a>
        .
      </p>
    )
  },
  {
    id: 439,
    question: <>Do you offer mobile deposits on all checking accounts?</>,
    answer: <p>Yes, remote capture or mobile deposit is available on all WaFd Checking and Savings accounts.</p>
  },
  {
    id: 440,
    question: <>Do I need to endorse or sign the back of the check when I make a mobile deposit?</>,
    answer: <p>Yes, you must also endorse your mobile deposit check just like a regular deposit.</p>
  },
  {
    id: 441,
    question: <>Can I make a mobile deposit to my WaFd Money Market or savings account?</>,
    answer: <p>Yes, you can use mobile deposit for your WaFd Savings and Money Market accounts.</p>
  },
  {
    id: 442,
    question: <>Account Opening&mdash;Can I make a mobile deposit for my initial deposit?</>,
    answer: (
      <p>
        No, you can't make a mobile deposit as your initial account opening deposit of $25. You can fund your new WaFd
        account with a Debit or Credit Card.
      </p>
    )
  },
  {
    id: 443,
    question: <>Do you offer mobile deposits for your business accounts?</>,
    answer: <p>Yes, you can make mobile deposits with our Business Treasury Accounts.</p>
  },
  {
    id: 472,
    question: <>What is a digital wallet?</>,
    answer: (
      <>
        <p>If you want to use your phone to make contactless payments, consider setting up a digital wallet first.</p>
        <p>
          A digital wallet allows you to safely and securely store your personal payment information in a single place
          through an app on your phone. This includes your name, addresses (shipping and billing), debit and credit card
          numbers, and other payment information.
        </p>
        <p>
          By storing your card information in your digital wallet, you are creating a digital card and no longer need to
          use your physical card to make purchases at participating businesses. It's also an easy and safe way to pay
          your friends and family using P2P (person to person) technology.
        </p>
      </>
    )
  },
  {
    id: 473,
    question: <>How do I get a digital wallet?</>,
    answer: (
      <>
        <p>
          You can download a digital wallet app to create your digital wallet. WaFd Bank's digital debit cards and
          credit cards can be used through{" "}
          <a
            href="https://www.apple.com/apple-pay/"
            id="faq-apple-pay-external-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apple Pay
          </a>
          ,{" "}
          <a
            href="https://pay.google.com/about/"
            id="faq-google-pay-external-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Pay
          </a>{" "}
          and{" "}
          <a
            href="https://www.samsung.com/us/samsung-pay/"
            id="faq-samsung-pay-external-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Samsung Pay
          </a>
          .
        </p>
        <div className="d-flex my-3">
          <a
            id="faq-apple-pay-external-badge"
            href="https://www.apple.com/apple-pay/"
            className="mr-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/icons/apple-pay-badge.svg" alt="Apple Pay badge" />
          </a>

          <a
            id="faq-google-pay-external-badge"
            href="https://pay.google.com/about/"
            className="mr-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/icons/google-pay-badge.svg" alt="Google Pay badge" />
          </a>

          <a
            id="faq-samsung-pay-external-badge"
            href="https://www.samsung.com/us/samsung-pay/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/icons/samsung-pay-badge.svg" alt="Samsung Pay badge" />
          </a>
        </div>
      </>
    )
  },
  {
    id: 474,
    question: <>Are digital wallets safe to use?</>,
    answer: (
      <p>
        Digital wallets keep your personal and financial information safe. The best way to keep your digital wallet safe
        is to use best practices to help protect against hackers obtaining your private data, such as using{" "}
        <Link to="/banking-privacy-security/security-center" id="faq-strong-pw-internal-link">
          strong passwords
        </Link>
        , password managers and a VPN. Learn more in our article{" "}
        <a
          id="faq-google-pay-apple-pay-safety-debit-cards-link"
          href="/articles/security-privacy/google-pay-apple-pay-safety-debit-cards"
        >
          How Safe is it to Use Apple Pay and Google Pay
        </a>
        .
      </p>
    )
  },
  {
    id: 475,
    question: <>Can I use a digital wallet to pay my friends and family?</>,
    answer: (
      <>
        <p>
          Yes, similar to adding a card to your digital wallet, you can add your credit and debit card information to a
          payment transfer app to easily send money to friends and family.
        </p>
        <p>
          WaFd Bank's digital debit cards and credit cards can be used through{" "}
          <a href="https://venmo.com/about/us/" id="faq-venmo-external-link" target="_blank" rel="noopener noreferrer">
            Venmo
          </a>
          ,{" "}
          <a href="https://www.zellepay.com/" id="faq-zelle-external-link" target="_blank" rel="noopener noreferrer">
            Zelle&reg;
          </a>{" "}
          and{" "}
          <a
            href="https://about.pypl.com/about-us/default.aspx"
            id="faq-paypal-external-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            PayPal
          </a>
          . Download one of these apps, add your card information and find your friends. Then you can make a quick
          transfer request in the app when you need to split a bill at a restaurant or send someone birthday money.
        </p>
      </>
    )
  },
  {
    id: 476,
    question: <>How do I use a digital wallet for purchases?</>,
    answer: (
      <>
        <p>
          After loading your debit or credit card information into the mobile app, you can start making purchases using
          your phone instead of your physical card. Simply open your digital wallet app and hold your phone close to a
          payment terminal that offers the contactless option to make an in-person purchase. Check with your local
          retailer since not all businesses currently offer this option. You will also have free access to thousands of
          fee-free{" "}
          <Link id="faq-how-to-use-wallet-atm-link" to="/locations/atm">
            ATMs
          </Link>{" "}
          across the country.
        </p>
        <p>
          When making in-app and online purchases, you may be able to select a payment type saved in your digital wallet
          so you do not have to manually enter your card information. You can also set up text alerts for all your
          purchases to keep better tabs on your spending.
        </p>
      </>
    )
  },
  {
    id: 488,
    question: <>What are the refinancing process steps?</>,
    answer: (
      <ol className="fw-bold">
        <li className="mb-4">
          <span className="fw-normal">
            <strong>Application</strong>
            <br />
            Apply to reduce your monthly payments or get cash out from your lender.
            <br />
            <Link className="faq-internal-page-link" to="/personal-banking/contact-loan-officer">
              Find a loan officer <Icon name="arrow-right" class="ml-2" />
            </Link>
          </span>
        </li>
        <li className="mb-4">
          <span className="fw-normal">
            <strong>Processing</strong>
            <br />
            Get initial approval of credit, income and assets, and determine home value to support your loan
            application.
          </span>
        </li>
        <li className="mb-4">
          <span className="fw-normal">
            <strong>Underwriting</strong>
            <br />
            Your lender will submit your final documentation to the underwriter for final approval. The underwriter
            follows the 3 C's:
            <ul style={{ listStyleType: "disc" }}>
              <li>Credit: Credit History</li>
              <li>Capacity: Cash Flow / Income and Cash & Liquid Assets</li>
              <li>Collateral: Type of Property & Occupancy and Loan to Value</li>
            </ul>
          </span>
        </li>
        <li className="mb-4">
          <span className="fw-normal">
            <strong>Closing</strong>
            <br />
            Complete the final approval steps from your mortgage lender.
          </span>
        </li>
      </ol>
    )
  },
  {
    id: 489,
    question: <>What is the rate for the WaFd Cash Back Credit Card?</>,
    answer: <p>17.24% Annual Percentage Rate (APR) for Purchases.</p>
  },
  {
    id: 491,
    question: <>What are the remodeling process steps?</>,
    answer: (
      <ol className="fw-bold">
        <li className="mb-4">
          <span className="fw-normal">
            <strong>Set Objectives</strong>
            <br />
            Meet with your architect or builder to plan your dream home.
          </span>
        </li>
        <li className="mb-4">
          <span className="fw-normal">
            <strong>Project Planning</strong>
            <br />
            Set your budget, determine the scope of work, and establish a timeline for completion.
          </span>
        </li>
        <li className="mb-4">
          <span className="fw-normal">
            <strong>DIY or Contractor?</strong>
            <br />
            We can work with you either way. Our custom construction loan officers at your local WaFd Bank branch will
            walk you through the process of completing your project.
          </span>
        </li>
        <li className="mb-4">
          <span className="fw-normal">
            <strong>Begin Construction</strong>
            <br />
            Our custom construction loan officers work with you to manage payouts to your builder each month as
            construction progresses from beginning to end.
            <br />
            <br />
            <a
              className="faq-internal-page-link breadcrumb-item-link"
              href="/documents/wafd-bank-remodeling-ebook.pdf"
              id="faq-491-remodeling-ebook-link"
              target="_blank"
            >
              <Icon name="file-alt" lib="far" class="m2-2" />
              WaFd Bank Remodeling eBook
            </a>
          </span>
        </li>
      </ol>
    )
  },
  {
    id: 493,
    question: (
      <>
        How do I use Zelle<sup>&reg;</sup> with a small business account?
      </>
    ),
    answer: (
      <>
        <p>
          Eligible small business accounts can send, receive, or request money with Zelle<sup>&reg;</sup>. To get
          started, log into the WaFd Treasury mobile app or online banking. In the main menu, select "Zelle
          <sup>&reg;</sup>" located at the bottom of the screen.
        </p>
        <p>
          Enter your email address or U.S. mobile number, receive a one-time verification code, enter it, accept the
          terms and conditions, and you're ready to start sending and receiving money with Zelle<sup>&reg;</sup>.
        </p>
        <p>
          To send money with Zelle<sup>&reg;</sup>, simply select someone from your mobile device's contacts (or add a
          trusted recipient's email address or U.S. mobile number), add the amount you'd like to send and an optional
          note, review, then hit "Send." In most cases, the money is available to your recipient in minutes.<sup>1</sup>
        </p>
        <p>
          If the small business or consumer you send money to has already enrolled with Zelle<sup>&reg;</sup> through
          their banking app, the money is sent directly to their bank account and cannot be canceled. It's important to
          only send money to people you trust, and always ensure you've used the correct email address or U.S. mobile
          number when sending money.
        </p>
        <p>
          To receive money using Zelle<sup>&reg;</sup> with a small business account, share your enrolled email address
          or U.S. mobile number with your customers and ask them to send you payment with Zelle<sup>&reg;</sup> right
          from their banking app. No need to share any sensitive account details. After the consumer sends you payment
          with Zelle<sup>&reg;</sup>, you will receive your money directly into your enrolled bank account.
        </p>
        <p>
          To request money using Zelle<sup>&reg;</sup> with a small business account, click "Send Money with Zelle
          <sup>&reg;</sup>," select "Request," enter the individual's email address or U.S. mobile number, confirm the
          recipient is correct and tap "Request."
        </p>
        <p>
          If your customer is using Zelle<sup>&reg;</sup> through their banking app, they'll be able to pay you with
          Zelle<sup>&reg;</sup>. You'll receive a payment notification once your customer has sent you money in response
          to your request. If your customer is enrolled in the Zelle<sup>&reg;</sup>
          app, they will not be able to send you money with Zelle<sup>&reg;</sup>, and you should arrange for a
          different payment method.
        </p>
      </>
    )
  },
  {
    id: 494,
    question: (
      <>
        How do I tell my customers they can pay me with Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          There are a few ways you can encourage your customers to pay you with Zelle<sup>&reg;</sup>.
        </p>
        <ul>
          <li>
            Tell customers verbally that you accept payments with Zelle<sup>&reg;</sup>, and that they can easily send
            you money right from their banking app.
          </li>
          <li>
            Include it on an invoice. We recommend adding "I accept payments with Zelle<sup>&reg;</sup>" or "Pay me with
            Zelle<sup>&reg;</sup>".
          </li>
          <li>
            Use Zelle<sup>&reg;</sup> to request money from your customers (which will send them a notification telling
            them you've requested payment with Zelle<sup>&reg;</sup>).<sup>2</sup>
          </li>
          <li>
            Download Zelle<sup>&reg;</sup> marketing assets for free from{" "}
            <a
              id="faq-zelle-toolkit-link"
              href="https://www.zellepay.com/small-business-payments/zelle-small-business-toolkit"
              target="_blank"
              rel="noopener noreferrer"
            >
              zellepay.com
            </a>{" "}
            and add them to your website, social media and more!
          </li>
        </ul>
        <p>
          Please note, you'll only be able to receive payments from consumers using Zelle<sup>&reg;</sup> through their
          financial institution's banking app. You will not be able to receive payments from consumers enrolled in the
          Zelle<sup>&reg;</sup> app.
        </p>
      </>
    )
  },
  {
    id: 495,
    question: (
      <>
        Does Zelle<sup>&reg;</sup> or WaFd Bank offer purchase protection?
      </>
    ),
    answer: (
      <p>
        Neither WaFd Bank nor Zelle<sup>&reg;</sup> offers purchase protection for payments made with Zelle
        <sup>&reg;</sup>.
      </p>
    )
  },
  {
    id: 496,
    question: (
      <>
        Are there any fees to use Zelle<sup>&reg;</sup> with a small business account at WaFd Bank?
      </>
    ),
    answer: (
      <>
        <p>
          No, WaFd Bank does not charge any fees to use Zelle<sup>&reg;</sup> with a small business account.
        </p>
        <p>Your mobile carrier's messaging and data rates may apply.</p>
      </>
    )
  },
  {
    id: 497,
    question: (
      <>
        Can I use Zelle<sup>&reg;</sup> internationally?
      </>
    ),
    answer: (
      <p>
        In order to use Zelle<sup>&reg;</sup>, the sender and recipient's bank or credit union accounts must be based in
        the U.S.
      </p>
    )
  },
  {
    id: 498,
    question: <>Can I cancel a payment?</>,
    answer: (
      <>
        <p>
          You can only cancel a payment if the small business or consumer you sent money to hasn't yet enrolled with
          Zelle<sup>&reg;</sup>. To check whether the payment is still pending because the recipient hasn't yet
          enrolled, you can go to your activity page, choose the payment you want to cancel, and then select "Cancel
          This Payment." If you do not see this option available, please contact our customer support team at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          for assistance with canceling the pending payment.
        </p>
        <p>
          If you send money to a small business or consumer that has already enrolled with Zelle<sup>&reg;</sup> through
          their bank or credit union's mobile app, the money is sent directly to their bank account and cannot be
          canceled. This is why it's important to only send money to people you know and trust, and always ensure you've
          used the correct email address or U.S. mobile number when sending money.
        </p>
        <p>
          If you try to send money to a consumer who is enrolled in the Zelle<sup>&reg;</sup> app, the payment won't go
          through and a message will pop up to let you know the payment cannot be completed. With small business
          accounts, Zelle<sup>&reg;</sup> does not currently support sending or receiving money to users enrolled in the
          Zelle<sup>&reg;</sup> app.
        </p>
        <p>
          If you sent money to the wrong person, please immediately call our customer support team at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          so we can help you.
        </p>
      </>
    )
  },
  {
    id: 499,
    question: <>Is my information secure?</>,
    answer: (
      <p>
        Keeping your money and information safe is a top priority for WaFd Bank. When you use Zelle<sup>&reg;</sup>{" "}
        within our mobile app or online banking, your information is protected with the same technology we use to keep
        your WaFd Bank account safe.
      </p>
    )
  },
  {
    id: 500,
    question: <>Who should I call if i have questions or need help?</>,
    answer: (
      <p>
        Please call WaFd Bank at{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        so we can help you.
      </p>
    )
  },
  {
    id: 501,
    question: (
      <>
        How do I know if my small business is eligible to use Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        In order for your small business to be eligible to use Zelle<sup>&reg;</sup>, you must have an active WaFd
        business checking account and enrolled in our Treasury Express online banking.
      </p>
    )
  },
  {
    id: 502,
    question: (
      <>
        I already use Zelle<sup>&reg;</sup> through my personal bank account. How do I enroll to use Zelle
        <sup>&reg;</sup> with my small business account?
      </>
    ),
    answer: (
      <p>
        Simply log into the WaFd Treasury mobile app or online banking and select "Send Money with Zelle<sup>&reg;</sup>
        ." Then, enter an email address or U.S. mobile number to connect to your small business bank account. Important
        note: If you already use Zelle<sup>&reg;</sup> for personal use, you must use a different email address or U.S.
        mobile number than the one you used to enroll your personal bank account. For example, name@email.com would be
        connected to your personal checking account, and 555-555-1234 would be connected to your small business bank
        account.
      </p>
    )
  },
  {
    id: 503,
    question: (
      <>
        Are there any differences in the experience between using Zelle<sup>&reg;</sup> with my personal bank account
        versus my small business account?
      </>
    ),
    answer: (
      <p>
        Whether you use Zelle<sup>&reg;</sup> with a small business account or a consumer account, Zelle<sup>&reg;</sup>{" "}
        uses the same network to initiate payments to small businesses and consumers. Consumers who are already enrolled
        with Zelle<sup>&reg;</sup> through their banking app don't need to do anything different to send money to a
        small business. The experience is slightly different for small businesses, as small businesses cannot currently
        send payments to or receive payments from consumers who are only enrolled in the Zelle<sup>&reg;</sup> app.
        <sup>1</sup>
      </p>
    )
  },
  {
    id: 504,
    question: (
      <>
        If I already use Zelle<sup>&reg;</sup> for my small business, do I need to do something different to continue
        using Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        Read the updated terms and conditions that were provided by WaFd Bank. The terms are available once signed into
        Zelle<sup>&reg;</sup>.
      </p>
    )
  },
  {
    id: 506,
    question: <>Why is Luther Burbank Savings merging with WaFd Bank?</>,
    answer: (
      <p>
        This merger will provide Luther Burbank Savings customers with additional banking services, products, tools, and
        technology. Merging will also increase access to services at more than 200 WaFd branch locations in a nine-state
        footprint.
      </p>
    )
  },
  {
    id: 507,
    question: <>Will the Luther Burbank Savings name change?</>,
    answer: <p>Yes, Luther Burbank Savings will transition to WaFd Bank branding and signage in early March.</p>
  },
  {
    id: 508,
    question: <>Will my branch still be here?</>,
    answer: (
      <p>
        Former Luther Burbank Savings branches will remain open with the same hours of operation and phone numbers. All
        branch staff have been offered the opportunity to remain. We are confident most if not all bankers in your
        branch will remain and continue to serve you.
      </p>
    )
  },
  {
    id: 509,
    question: <>Who do I call if I have questions about WaFd Bank stock?</>,
    answer: (
      <p>
        Please call our transfer agent, Broadridge Financial, at{" "}
        <a href="tel:844-983-0877" id="lbs-transfer-agent-tel-link">
          844-983-0877
        </a>{" "}
        or email them at{" "}
        <a href="mailto:shareholder@broadridge.com" id="lbs-broadridge-email-link">
          shareholder@broadridge.com
        </a>
        .
      </p>
    )
  },
  {
    id: 510,
    question: <>Is my money insured by the FDIC? What if I have accounts at both banks?</>,
    answer: (
      <p>
        Deposits remain insured by the FDIC up to $250,000 per depositor. Clients who have accounts at both WaFd Bank
        and Luther Burbank Savings benefit from separately insured deposits at each bank for a period of time following
        the merger. Clients with accounts at both institutions will receive a letter with more detailed information on
        combined deposit insurance following a merger.
      </p>
    )
  },
  {
    id: 511,
    question: <>When can I visit WaFd Bank branches to conduct my daily banking?</>,
    answer: (
      <p>
        You can continue banking at your current Luther Burbank branch, soon to be rebranded as WaFd Bank, and also at
        any of our{" "}
        <Link to="/locations" className="faq-internal-page-link">
          200+ locations
        </Link>{" "}
        across nine states or{" "}
        <Link to="/locations/atm" className="faq-internal-page-link">
          thousands fee-free ATMs
        </Link>
        nationwide.
      </p>
    )
  },
  {
    id: 515,
    question: <>Will I get a new debit card?</>,
    answer: (
      <>
        <p>
          WaFd Bank will issue contactless, EMV chip debit cards to Luther Burbank clients between February 15-29. The
          debit card mailed to you will include instructions to activate your new card. If you'd like, you can use your
          existing PIN number. Simply enter that number when you activate your card and set up your PIN.
        </p>
        <p>
          If there was no activity on your Luther Burbank debit or ATM card over the last 90 days, you will not receive
          a new card. If you would like to receive one and did not, please call{" "}
          <a href="tel:800-324-9375" className="faq-c3-tel-link">
            800-324-9375
          </a>{" "}
          to request one (mention you are a Luther Burbank customer) and it will be sent through the mail. Debit cards
          cannot be activated until March 4th.
        </p>
      </>
    )
  },
  {
    id: 516,
    question: (
      <>
        How do I know when to stop using my Luther Burbank Savings debit card or ATM card and when to start using my
        WaFd Bank debit card or ATM card?
      </>
    ),
    answer: (
      <>
        <p>
          Your Luther Burbank Savings debit or ATM card will function until 8am Monday, March 4. Please begin using your
          new WaFd Bank card on Monday, March 4 at 8am. We recommend you call to activate and select a PIN for your new
          card as soon as you receive it, so that your card is ready to use on March 4. Please do not try to use your
          WaFd Bank debit or ATM card before March 4 as your transactions will be declined.
        </p>
        <p>
          <em>
            Over the weekend of March 1-4, please consider carrying extra cash or using alternate forms of payment.
          </em>
        </p>
      </>
    )
  },
  {
    id: 517,
    question: <>What will happen to my Luther Burbank Savings credit card?</>,
    answer: (
      <p>
        A notice will be sent out by Elan Financial Services regarding your Luther Burbank credit card. Any credit cards
        originated through Luther Burbank will continue to be serviced through Elan. While the relationship between
        Luther Burbank Savings and Elan will be terminated, you may continue to use your card as-is. There is no
        connection between your Elan credit card and WaFd Bank.
      </p>
    )
  },
  {
    id: 518,
    question: <>What happens to my Certificate of Deposit?</>,
    answer: (
      <p>
        The current term, interest rate, maturity date, and early withdrawal penalty on your CD will remain the same
        until maturity, there is nothing you need to do to keep your CD. After it matures, if you do not move those
        funds to another account your CD will revert to the interest rate in effect at that time and at the same or
        similar term, if the same term CD is not available. Please see our{" "}
        <Link className="faq-internal-page-link" to="/personal-banking/savings-account/certificate-of-deposit">
          CD page
        </Link>{" "}
        for more information on WaFd CDs.
      </p>
    )
  },
  {
    id: 519,
    question: <>Will my direct deposits and other automatic payments need to be updated?</>,
    answer: (
      <p>
        Yes, please update your direct deposits and your debit card or routing and account number with each vendor or
        company. WaFd Bank's routing number for checks, direct deposits, and all electronic payments is 325070980. If
        you don't update the routing number with your vendors, it may result in a delay in posting to your account.
        Please request that your vendors start using your new routing and account number on or after March 4, 2024.
      </p>
    )
  },
  {
    id: 520,
    question: (
      <>
        I currently have overdraft protection set up on my Luther Burbank Savings checking account. Will this transfer
        after conversion?
      </>
    ),
    answer: (
      <p>
        If your overdraft protection draws from a savings, money market, or a second checking account that is also
        transferring to WaFd Bank, then this linked relationship will transfer over to WaFd Bank. Otherwise, if you
        would like to enable overdraft service, please contact your{" "}
        <Link to="/locations" className="faq-internal-page-link">
          local WaFd branch
        </Link>
        .
      </p>
    )
  },
  {
    id: 521,
    question: (
      <>What happens to the sweeps (automatic transfers) I have established between my checking and savings accounts?</>
    ),
    answer: (
      <>
        <p>
          Any sweeps or automatic transfers you have established between your accounts will transfer over to your WaFd
          accounts. Please verify that your sweeps have transferred successfully to ensure there is no interruption to
          your accounts. If your sweep needs to be re-established, you can do this through your WaFd online banking, or
          by contacting your{" "}
          <Link to="/locations" className="faq-internal-page-link">
            local branch
          </Link>{" "}
          or calling us at{" "}
          <a href="tel:800-324-9375" className="faq-c3-tel-link">
            800-324-9375
          </a>
          .
        </p>
        <p>
          Automatic transfers between your accounts are different than automatic payments sent to payees through Bill
          Pay, which will not automatically transfer over.
        </p>
      </>
    )
  },
  {
    id: 522,
    question: <>What do I need to know about sending and receiving a wire?</>,
    answer: (
      <>
        <p>
          You will need to provide your own name, account number and address. WaFd Bank's routing number is 325070980,
          and for incoming wires beneficiary bank information is:
        </p>
        <p>
          Bank Name: WaFd Bank
          <br />
          Bank Address: 425 Pike Street, Seattle WA 98101
          <br />
          Country: United States
        </p>
      </>
    )
  },
  {
    id: 523,
    question: <>Do I need to order new checks?</>,
    answer: (
      <p>
        You can continue to use the checks and deposit slips you already have for the time being. Luther Burbank Savings
        checks will continue to be valid after the system transition. The routing number and your account number will be
        transferred to WaFd Bank. You may order new checks when needed at your branch, via online banking, or by calling{" "}
        <a href="tel:800-324-9375" className="faq-c3-tel-link">
          800-324-9375
        </a>
        . We will waive or reimburse "house" check order fees for the first 90 days after the transition (through June
        30, 2024).
      </p>
    )
  },
  {
    id: 524,
    question: <>How do I access previous statements?</>,
    answer: (
      <>
        <p>
          Please visit your local branch or call{" "}
          <a href="tel:800-324-9375" className="faq-c3-tel-link">
            800-324-9375
          </a>{" "}
          for access to historical statements issued before March 2024. To access statements from March 2024 or later
          for printing or download:
        </p>
        <ol>
          <li>Sign into online banking.</li>
          <li>Select "Statements" from the bar at the top.</li>
          <li>Select "Account Statements" from the dropdown menu.</li>
          <li>Select an account in the dropdown menu.</li>
          <li>Select the month you're looking for. The statement will open in another window.</li>
          <li>Download or print the statement via the icons in the top right corner.</li>
        </ol>
      </>
    )
  },
  {
    id: 525,
    question: <>How do I sign up for eStatements?</>,
    answer: (
      <>
        <p>
          WaFd Bank offers eStatements on all consumer accounts, mortgages, and business checking accounts. To sign up
          for eStatements:
        </p>
        <ol>
          <li>Sign in to WaFd online banking on or after March 4, 2024.</li>
          <li>Select "Statements" from the bar at the top.</li>
          <li>Select "Account Statements" from the dropdown menu.</li>
          <li>Select "Go Green! Go Paperless" on the right side of the dropdown menu.</li>
          <li>Check the box for the account(s) that you want to go paperless.</li>
          <li>Select "Save".</li>
        </ol>
      </>
    )
  },
  {
    id: 526,
    question: <>How much account transaction history will be available?</>,
    answer: (
      <p>
        You will be able to view transactions in WaFd online banking starting the day Luther Burbank converts to WaFd
        systems on March 4. If you need to access historical transactions, please contact your branch or give us a call
        at{" "}
        <a href="tel:800-324-9375" className="faq-c3-tel-link">
          800-324-9375
        </a>{" "}
        to access your statements issued before March 2024. We recommend you download your account statements for easy
        access before system conversion.
      </p>
    )
  },
  {
    id: 527,
    question: <>How do I access WaFd Bank's online banking?</>,
    answer: (
      <>
        <p>Luther Burbank customers can access WaFd's Online Banking by following these simple steps:</p>
        <ol>
          <li>
            <strong>Enroll:</strong> Select{" "}
            <a
              id="faq-527-online-banking-enroll-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://online.wafdbank.com/link/register?application=OLB"
            >
              Enroll in WaFd Online Banking
            </a>{" "}
            in order to setup access to your account.
          </li>
          <li>
            <strong>Set Up Bill Payees:</strong> Though your transactions have been transferred, you need to manually
            add your bill payees in the new system. To do this, after signing in navigate to the "Pay Bills" section
            under "Move Money" to enter payee details.
          </li>
          <li>
            <strong>Schedule Payments:</strong> With your payees set up, you can now schedule your payments. You can
            also opt for recurring payments for regular bills.
          </li>
        </ol>
        <p>
          Need help? Contact WaFd's customer support for assistance with enrollment or any other questions. Welcome to
          WaFd Bank!
        </p>
      </>
    )
  },
  {
    id: 528,
    question: <>Where are my scheduled payments?</>,
    answer: (
      <p>
        During the transition to the WaFd Online Banking system we were not able to transfer your scheduled payments, we
        apologize for the inconvenience. You will have to setup new payees and scheduled payments in online banking.
        Navigate to the "Pay Bills" section under "Move Money" in online banking to enter payee details.
      </p>
    )
  },
  {
    id: 529,
    question: <>Will the interest rate on my loan change? Will my due date change?</>,
    answer: (
      <p>
        We will honor your interest rate agreement established with Luther Burbank Savings. Please note that you may
        have a variable interest rate that could cause your interest rate to change in the future. Your loan's due date
        will not change.
      </p>
    )
  },
  {
    id: 530,
    question: <>Where do I make my loan payments?</>,
    answer: (
      <>
        <p>You have several options for making your loan payments:</p>
        <ol>
          <li>You can make a loan payment online via the WaFd Online Banking tool</li>
          <li>
            Mail your loan payments to:
            <br />
            Loan Payment Lockbox
            <br />
            P.O. Box 80670
            <br />
            City of Industry, CA 91716
          </li>
          <li>
            Make the payment at the nearest{" "}
            <Link to="/locations" className="faq-internal-page-link">
              WaFd Branch location
            </Link>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 531,
    question: <>Can I still make my loan payments by phone?</>,
    answer: (
      <p>
        WaFd Bank does not allow loan payments to be made from external accounts by phone. Instead, make a deposit to
        your WaFd checking or savings account and then log in to online or mobile banking to make a payment. After the
        deposit is processed, you can also call us at{" "}
        <a href="tel:800-324-9375" className="faq-c3-tel-link">
          800-324-9375
        </a>{" "}
        to make an internal transfer to process a loan payment.
      </p>
    )
  },
  {
    id: 532,
    question: <>My loan payment is automatically processed from my account; will that continue?</>,
    answer: (
      <p>
        Yes, but if your automatic loan payment is coming from a bank other than Luther Burbank or WaFd Bank, it will
        pull from your account one business day <strong>after</strong> your payment is scheduled.
      </p>
    )
  },
  {
    id: 534,
    question: <>What is the website URL to log in to Treasury Prime?</>,
    answer: (
      <p>
        <a
          href="https://commercial.washingtonfederal.com"
          target="_blank"
          rel="noopener noreferrer"
          id="treasury-prime-login-link"
        >
          https://commercial.washingtonfederal.com
        </a>
      </p>
    )
  },
  {
    id: 535,
    question: <>What are the cutoff times for my Treasury Prime Services?</>,
    answer: (
      <>
        <p>The following table includes the cutoff times for the various treasury solutions:</p>
        <table className="table table-bordered">
          <thead className="thead-green">
            <tr>
              <th>Service</th>
              <th>Client Cut-off Time (Pacific Time)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>ACH Origination (Same Day Settlement)</td>
              <td>11:00 AM</td>
            </tr>
            <tr>
              <td>ACH Origination (Next Day Settlement)</td>
              <td>5:00 PM</td>
            </tr>
            <tr>
              <td>eWire Origination (Domestic & International)</td>
              <td>3:00 PM</td>
            </tr>
            <tr>
              <td>Positive Pay Review (Check & ACH)</td>
              <td>10:30 AM</td>
            </tr>
            <tr>
              <td>Remote Deposit Capture</td>
              <td>9:00 AM, 11:00 AM, 1:00 PM, 3:00 PM, 5:00 PM</td>
            </tr>
          </tbody>
        </table>
      </>
    )
  },
  {
    id: 536,
    question: <>How do I reset my password? (This is also used if your profile is locked)</>,
    answer: (
      <>
        <p>Follow the below steps to reset your password in Treasury Prime:</p>
        <div className="row">
          <div className="col-md-8">
            <ol>
              <li>Enter Company ID and Username (Note:Username is case sensitive)</li>
              <li>Click Login</li>
              <li>Click Forgot Password?</li>
              <li>Choose how you would like to receive the Temporary Password - email or text.</li>
              <li>
                Once you receive the Temporary Password, you can manually enter the password,or you can copy and paste.
              </li>
            </ol>
          </div>
          <div className="col-md-4">
            <img
              src="/images/treasury-prime-forgot-password.png"
              alt='Screenshot of login screen with a red square around the "Forgot Password?" button. Company ID 123456, UserID TESTUSER, Password input field, Login, Cancel and Forgot Password? buttons.'
            />
          </div>
        </div>
        <p>
          <strong>Tip:</strong> Temporary passwords are 9 characters. It is a good best practice to count the total
          bullets when copy and pasting in the password field to ensure an additional space was not added.
        </p>
        <p>When creating your new password, it must meet the following criteria:</p>
        <ul>
          <li>Between 9-16 characters in length</li>
          <li>At least one upper and lower case letter</li>
          <li>At least one number and one special character</li>
        </ul>
      </>
    )
  },
  {
    id: 537,
    question: <>What is the Software Activation Key and where can I find it?</>,
    answer: (
      <>
        <p>
          The Software Activation key is required for the WaFd Treasury Mobile App or WaFd Treasury Token App
          registration. Only Treasury Prime administrative users can access the Software Activation Key.
        </p>
        <ul>
          <li>
            For Sub-Users - Go to <strong>Administration &gt; Administration</strong>. Click <strong>Actions</strong>{" "}
            dropdown next to applicable user and select
            <strong>Edit Profile</strong>. The key is located at the bottom of the page. If the Key is expired, click
            reset and it will generate a new key.
          </li>
          <li>
            For yourself - Go to <strong>My Settings &gt; My Profile</strong>
          </li>
        </ul>
      </>
    )
  },
  {
    id: 538,
    question: <>My sub user locked themselves out of Prime, can I unlock them?</>,
    answer: (
      <p>
        Yes, Administrators can unlock users. Go to
        <strong>Administration &gt; Administration</strong>. Click
        <strong>Actions</strong> dropdown across from the applicable user and select
        <strong>Unlock User</strong>. Any user can unlock themselves by successfully completing a Password Reset.
      </p>
    )
  },
  {
    id: 539,
    question: <>I forgot my PIN, how do I reset it? (Used to send eWire and ACH payments)</>,
    answer: (
      <p>
        For your security, you cannot reset your PIN. If you forget your PIN, call Treasury Servicing at{" "}
        <a href="tel:877-423-9742" id="treasury-servicing-tel-link">
          877-423-9742
        </a>{" "}
        and we will assist in the creation of a new PIN.
      </p>
    )
  },
  {
    id: 540,
    question: <>How do I see why an ACH was returned?</>,
    answer: (
      <p>
        You can see any returned ACH originated items in the
        <strong>NACHA Return File</strong> report. This report is located under the
        <strong>Account Information</strong> tab.
      </p>
    )
  },
  {
    id: 541,
    question: (
      <>I completed a Remote Deposit Capture scan &mdash; Why can't I see the deposit in my transaction history?</>
    ),
    answer: (
      <p>
        Deposits will be processed at set intervals throughout the day. Refer to the Cut-off Times table above. Once
        processed, your deposit will show up before the next processing interval.
      </p>
    )
  },
  {
    id: 542,
    question: <>I used Remote Deposit Capture and deposited into the wrong account. What should I do?</>,
    answer: <p>Once the deposit posts, you can transfer the funds to the correct account.</p>
  },
  {
    id: 543,
    question: <>What resources are available to help me with Treasury Prime?</>,
    answer: (
      <>
        <p>Within Treasury Prime's File Vault, you have access to many User Guides such as:</p>
        <ul>
          <li>ACH User Guide</li>
          <li>New User Setup Guide</li>
          <li>Remote Deposit Capture User Guide</li>
          <li>Wire User Guide</li>
          <li>And more</li>
        </ul>
        <p>
          To access <strong>File Vault</strong>, go to <strong>My Settings &gt; File Vault &gt; Public Vault</strong>.
          You can also click on Help in the top right corner of each page for in-depth information of that page.
        </p>
      </>
    )
  },
  {
    id: 544,
    question: <>Do I need to open a new WaFd Bank account?</>,
    answer: (
      <p>
        No, your Luther Burbank accounts were transferred over to WaFd Bank. However, you will need to{" "}
        <a
          id="wafd-online-banking-enroll-link"
          href="https://online.wafdbank.com/link/register?application=OLB"
          target="_blank"
          rel="noopener noreferrer"
        >
          Enroll in WaFd's Online Banking
        </a>{" "}
        in order to gain access to your accounts. Your old Luther Burbank username and password will not work.
      </p>
    )
  },
  {
    id: 545,
    question: <>¿Cómo puedo pedir o reordenar cheques?</>,
    answer: (
      <p>
        Para solicitar cheques, inicie sesión en la Banca en Línea. Seleccione la cuenta corriente que está solicitando
        y haga clic en Solicitar cheques en el menú Acción en el lado derecho de la pantalla. Esto lo dirigirá al sitio
        web externo de nuestro socio para explorar el catálogo de cheques y realizar un pedido.
      </p>
    )
  },
  {
    id: 546,
    question: <>Can I use Voice-Activated Banking for all my transactions?</>,
    answer: (
      <p>
        Voice-Activated Banking currently supports balance inquiries, transfers, bill payments, and hearing recent
        transactions, with more features coming soon.
      </p>
    )
  },
  {
    id: 547,
    question: <>How do I sign up?</>,
    answer: (
      <p>
        Setting up Voice-Activated Banking is easy and only takes a couple of minutes. If you are not already, you will
        need to first{" "}
        <a
          href="https://online.wafdbank.com/index.html"
          id="faq-547-external-online-banking-sign-in-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          enroll in online banking
        </a>
        . Then call us at{" "}
        <a href="tel:800-324-9375" className="faq-c3-tel-link">
          800-324-9375
        </a>{" "}
        to set up Voice-Activated Banking.
      </p>
    )
  },
  {
    id: 548,
    question: <>Is Voice-Activated Banking safe?</>,
    answer: (
      <p>
        Yes, our AI uses advanced voice-authentication technology to ensure your banking is secure. Once you're
        enrolled, no one else can call the bank trying to impersonate you&mdash;we've got your voice on file and the
        call must come from the cell phone registered to you.{" "}
        <a
          className="faq-internal-page-link text-decoration-none"
          href="/articles/security-privacy/how-voice-activated-banking-works"
        >
          How Voice-Activated Banking Works
          <Icon name="arrow-right" class="ml-2" />
        </a>
      </p>
    )
  },
  {
    id: 549,
    question: <>Can I deposit cash?</>,
    answer: (
      <p>
        Absolutely! Cash can be deposited to your account by using a WaFd ATM machine or visiting your local branch.
      </p>
    )
  },
  {
    id: 550,
    question: <>What kinds of checks can I deposit?</>,
    answer: (
      <>
        <p>WaFd Bank accepts:</p>
        <ul>
          <li>U.S. Treasury Checks, payable to you</li>
          <li>State and local government checks, payable to you</li>
          <li>Cashier's, certified, and teller's checks, payable to you</li>
          <li>
            Federal Reserve Bank checks, Federal Home Loan Bank checks, U.S. Postal Service money orders, and traveler's
            checks, payable to you
          </li>
        </ul>
      </>
    )
  },
  {
    id: 551,
    question: <>Can I deposit a post-dated check?</>,
    answer: <p>WaFd Bank may elect not to accept any checks that have been dated six or more months ago.</p>
  },
  {
    id: 552,
    question: <>How do I deposit a check that's made out to me and someone else?</>,
    answer: (
      <p>
        As long as all payees have endorsed the check, it can be deposited using mobile deposit, ATM deposit or in
        person.
      </p>
    )
  },
  {
    id: 553,
    question: <>How much money can I deposit with a mobile deposit?</>,
    answer: <p>There is a limit of $50,000 per deposit and a $100,000 limit per day.</p>
  },
  {
    id: 554,
    question: <>How many deposits can I make each month?</>,
    answer: (
      <>
        <p>
          WaFd Bank doesn't restrict the number of deposits you can make to your account. We will not accept for Mobile
          Deposit:
        </p>
        <ul>
          <li>If more than one check is included in transmission</li>
          <li>If the check exceeds $50,000</li>
          <li>
            The amount of the check will cause your combined Mobile Deposits on that Business Day to exceed $100,000
          </li>
        </ul>
      </>
    )
  },
  {
    id: 555,
    question: <>How many checks can I deposit at the ATM at one time?</>,
    answer: <p>ATM will allow between 30-50 checks to be deposited at one time.</p>
  },
  {
    id: 556,
    question: <>Which WaFd Bank accounts can I use with mobile deposits?</>,
    answer: <p>Mobile deposits are accepted on Checking, Savings and Money Market accounts.</p>
  },
  {
    id: 557,
    question: <>What are the WaFd Bank mobile deposit check and image submission requirements?</>,
    answer: (
      <>
        <p>Do not use Mobile Deposit to deposit any ineligible items:</p>
        <ul>
          <li>Payable to “Cash” or any indefinite payee or to a person other than you, even if endorsed by you</li>
          <li>Lacks the original signature of the drawer</li>
          <li>Was created from an electronic image</li>
          <li>Is irregular in any way, as determined by WaFd Bank, in our sole discretion</li>
          <li>Was returned unpaid</li>
          <li>Is not dated or is postdated, or is more than six months old</li>
          <li>Was drawn on a foreign bank or any entity that is not a bank, or is payable in foreign currency</li>
          <li>Is a traveler's check or registered government warrant or bond</li>
          <li>Is not a check under Regulation CC</li>
        </ul>
        <p>The image of the item transmitted to us using Mobile Deposit must be legible.</p>
      </>
    )
  },
  {
    id: 558,
    question: <>Do I need to endorse or sign the back of the check when I make a mobile deposit?</>,
    answer: <p>Yes, you must also endorse your mobile deposit check just like a regular deposit.</p>
  },
  {
    id: 559,
    question: <>Are my deposits FDIC-insured?</>,
    answer: (
      <p>
        Yes, Consumer WaFd Bank accounts are covered under FDIC. See the EDIE calculator on the Treasury Website to
        determine total coverage.{" "}
        <a
          href="https://edie.fdic.gov/calculator.html"
          target="_blank"
          rel="noopener noreferrer"
          id="external-edie-fdic-calculator-faq-link"
        >
          https://edie.fdic.gov/calculator.html
        </a>
      </p>
    )
  },
  {
    id: 560,
    question: <>How do I know if my mobile deposit has been accepted?</>,
    answer: (
      <p>
        You will receive confirmation inside the Mobile Banking App after completing the Mobile Deposit process that the
        check image you transmitted has been accepted for deposit (or alternatively, an adjustment notice setting forth
        the reason it could not be deposited).
      </p>
    )
  },
  {
    id: 561,
    question: <>When will my deposit be available?</>,
    answer: (
      <p>
        The first $225 is available immediately, and the remainder of the funds are generally available the following
        business day, excluding Federal Holidays (Monday-Friday). Accepted deposits before 3 PM PT on a business day
        will be credited to your account by 6 PM PT the next business day. Please see the{" "}
        <a
          href="/documents/wafdbank-consumer-disclosure-guide.pdf"
          target="_blank"
          id="internal-funds-availability-faq-link"
        >
          funds availability disclosure
        </a>{" "}
        for further information.
      </p>
    )
  },
  {
    id: 562,
    question: <>Why is there a hold on my money after I make a mobile deposit?</>,
    answer: (
      <p>
        Accepted mobile deposits made prior to 5 PM PT on a Business Day will be credited by 6 PM PT the same Business
        Day. Accepted mobile deposits made after 5 PM PT or on a day that is not a Business Day will be credited the
        following Business Day. Please note that, although our Business Days exclude federal banking holidays, we will
        use reasonable efforts to process deposits made through Mobile Deposit on all calendar days, except
        Thanksgiving, Christmas, and New Year's Day.
      </p>
    )
  },
  {
    id: 563,
    question: <>How soon will my checks clear after depositing them at an ATM?</>,
    answer: (
      <p>
        Cash deposited at the ATM will be made available no later than the first Business Day after the Business Day of
        deposit. When you deposit a check at an ATM, regardless of the type of check, we will make the funds available
        no later than the first Business Day after the Business Day of deposit, unless we deem a longer delay is
        necessary.
      </p>
    )
  },
  {
    id: 564,
    question: <>When will my deposit hold be released?</>,
    answer: (
      <p>
        The day funds become available, and the length of the delay is determined by counting Business Days from the day
        of your deposit. The length of deposit delay varies depending on the type of the deposit. WaFd Bank will notify
        you if we delay your ability to withdraw funds for any reason, and we will disclose to you when the funds will
        be available.
      </p>
    )
  },
  {
    id: 565,
    question: <>What should I do if my deposit is not showing up in my account?</>,
    answer: (
      <p>
        Please contact your{" "}
        <Link to="/locations" id="faq-locations-link">
          local branch
        </Link>{" "}
        or call us at at
        <a href="tel:800-324-9375" id="faq-c3-tel-link">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 566,
    question: <>What is a Pending Deposit Transaction?</>,
    answer: (
      <p>
        A pending deposit transaction occurs when a deposit has been initiated, but has not been fully processed by the
        bank yet. While pending, the deposit temporarily increases the account balance but cannot be immediately
        withdrawn. The duration of the pending status varies, usually taking a few business days for the deposit to be
        fully processed and the funds to become available. Once completed, the pending status is removed and the funds
        are officially credited to the account for withdrawals or other transactions.
      </p>
    )
  },
  {
    id: 567,
    question: <>Can I make a mobile deposit via online banking?</>,
    answer: (
      <p>
        No, you must use the WaFd mobile app to make a mobile deposit. To download the mobile app, please go to the{" "}
        <a href="/personal-banking/online-banking#mobile-app-section" id="internal-faq-online-banking-link">
          app store
        </a>
        .
      </p>
    )
  },
  {
    id: 568,
    question: <>Do I need the WaFd Bank mobile app to make a mobile deposit?</>,
    answer: (
      <p>
        Yes, you need to use the WaFd Bank mobile app to make a mobile deposit. To download the mobile app, please go to
        the{" "}
        <a href="/personal-banking/online-banking#mobile-app-section" id="internal-faq-online-banking-link-2">
          app store
        </a>
        .
      </p>
    )
  },
  {
    id: 569,
    question: <>What should I do with my check after I make a mobile deposit?</>,
    answer: (
      <p>
        We recommend that you safeguard and keep the original check for 14 business days after you have transmitted the
        check. After that period, once you have verified that the check has been credited to your Eligible Deposit
        Account, you can use a permanent marker to write "Void" across the check and shred it or otherwise dispose of it
        in a way that will prevent others from being able to deposit the check.
      </p>
    )
  },
  {
    id: 570,
    question: <>Is there a fee for using mobile check deposit?</>,
    answer: (
      <p>
        No, we don't have a fee for mobile deposit. Please refer to{" "}
        <Link to="/personal-banking/account-fees" id="faq-account-fees-link">
          Personal Savings Accounts Fee Schedule
        </Link>{" "}
        for a complete list of fees.
      </p>
    )
  },
  {
    id: 571,
    question: <>How can I set up direct deposit?</>,
    answer: (
      <p>
        <a
          className="text-decoration-none"
          href="/articles/banking-101/how-to-set-up-direct-deposit"
          id="internal-how-to-set-up-direct-deposit-blog-link"
        >
          How to Set Up Direct Deposit for Payroll Checks, Social Security Payments, and Other Government Checks
          <Icon name="arrow-right" class="ml-2" />
        </a>
      </p>
    )
  },
  {
    id: 572,
    question: <>Account opening—Can I make a mobile deposit for my initial deposit?</>,
    answer: (
      <p>
        No, you can't make a mobile deposit as your initial account opening deposit of $25. You can fund your new WaFd
        account with a Debit or Credit Card, or Electronic Transfer from a bank account.
      </p>
    )
  },
  {
    id: 573,
    question: <>Can I fund a CD with a mobile deposit?</>,
    answer: (
      <p>
        No. CDs are typically funded at account opening or when renegotiating terms. Mobile deposits are not available
        for those transactions.
      </p>
    )
  },
  {
    id: 574,
    question: <>Can I add money to a CD after it has been opened?</>,
    answer: (
      <p>
        No, we don't offer the ability to add funds after the account is opened. If additional funds are brought in the
        same day of the account opening (day when the signature card is generated), we will add them to the CD.
        Otherwise, you will need to open another CD.
      </p>
    )
  },
  {
    id: 581,
    question: <>What is the difference between Rewards and Premium Rewards?</>,
    answer: (
      <>
        <p>
          The difference between the two is that you receive more rewards and, in some cases, increased coverage with
          the Premium Rewards account.
        </p>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-gray">
              <tr>
                <th>Interest Checking</th>
                <th>Premium Rewards Checking</th>
                <th>Rewards Checking</th>
              </tr>
            </thead>
            <tbody className="tbody-white">
              <tr>
                <td>$25 initial deposit</td>
                <td>$25 initial deposit</td>
                <td>$25 initial deposit</td>
              </tr>
              <tr>
                <td>
                  Includes:
                  <ul>
                    <li>Earns interest on all balances</li>
                    <li>Free WaFd-branded Checks</li>
                    <li>Free 3x5” Safe Deposit (where available)</li>

                    <li>
                      5¢/gal Shell Fuel Savings<sup>2</sup>
                    </li>
                    <li>
                      Credit Monitoring and Identity Theft Resolution Service<sup>3</sup>
                    </li>
                    <li>
                      Up to $1 million in Identity theft Reimbursement<sup>3</sup>
                    </li>
                    <li>
                      Credit Score Simulator<sup>5</sup>
                    </li>
                    <li>
                      Up to $800 Mobile Phone Protection<sup>3</sup>, per claim
                    </li>
                    <li>Dark Web Monitoring</li>
                    <li>
                      24/7 Roadside Assistance<sup>3</sup>
                    </li>
                    <li>
                      Rideshare Protection<sup>3</sup>
                    </li>
                    <li>
                      24/7 Telehealth Services<sup>4</sup>
                    </li>
                    <li>Buyer's Protection / Extended Warranty</li>
                    <li>AD&D Insurance</li>
                    <li>
                      Shopping Discounts<sup>7</sup>
                    </li>
                    <li>
                      Health Discounts<sup>6</sup>
                    </li>
                    <li>
                      Travel & Leisure Discounts<sup>8</sup>
                    </li>
                  </ul>
                </td>
                <td>
                  Premium Rewards include:
                  <ul>
                    <li>
                      5¢/gal Shell Fuel Savings<sup>2</sup>
                    </li>
                    <li>
                      Credit Monitoring and Identity Theft Resolution Service<sup>3</sup>
                    </li>
                    <li>
                      Up to $1 million in Identity theft Reimbursement<sup>3</sup>
                    </li>
                    <li>
                      Credit Score Simulator<sup>5</sup>
                    </li>
                    <li>
                      Up to $800 Mobile Phone Protection<sup>3</sup>, per claim
                    </li>
                    <li>Dark Web Monitoring</li>
                    <li>
                      24/7 Roadside Assistance<sup>3</sup>
                    </li>
                    <li>
                      24/7 Telehealth Services<sup>4</sup>
                    </li>
                    <li>Buyer's Protection / Extended Warranty</li>
                    <li>AD&D Insurance</li>
                    <li>
                      Shopping Discounts<sup>7</sup>
                    </li>
                    <li>
                      Health Discounts<sup>6</sup>
                    </li>
                    <li>
                      Travel & Leisure Discounts<sup>8</sup>
                    </li>
                  </ul>
                </td>
                <td>
                  Rewards include:
                  <ul>
                    <li>
                      5¢/gal Shell Fuel Savings<sup>2</sup>
                    </li>
                    <li>
                      Credit Monitoring and Identity Theft Resolution Service<sup>3</sup>
                    </li>
                    <li>
                      Up to $25,000 in Identity theft Reimbursement<sup>3</sup>
                    </li>
                    <li>
                      Up to $500 Mobile Phone Protection<sup>3</sup>, per claim
                    </li>
                    <li>Buyer's Protection / Extended Warranty</li>
                    <li>AD&D Insurance</li>
                    <li>
                      Shopping Discounts<sup>7</sup>
                    </li>
                    <li>
                      Health Discounts<sup>6</sup>
                    </li>
                    <li>
                      Travel & Leisure Discounts<sup>8</sup>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="text-success fw-bold">$12</span> per month <br />
                  Fee waived with $5,000 daily average balance or $50,000 in related accounts
                </td>
                <td>
                  <span className="text-success fw-bold">$9</span> per month
                  <br />
                  No minimum balance requirement.
                </td>
                <td>
                  <span className="text-success fw-bold">$6</span> per month
                  <br />
                  No minimum balance requirement.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    )
  },
  {
    id: 582,
    question: <>How do I access rewards in Online Banking?</>,
    answer: (
      <p>
        To access rewards in Online Banking, first click on an eligible account, then select Rewards on the Actions
        menu.
      </p>
    )
  },
  {
    id: 583,
    question: <>How do I access rewards in Mobile Banking?</>,
    answer: <p>To access rewards in Mobile Banking, click on the Rewards tile.</p>
  },
  {
    id: 584,
    question: (
      <>
        How do I register for Fuel Savings<sup>2</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Enjoy Extended Gold Status at participating Shell stations with Fuel Rewards<sup>&reg;</sup> program and save
          5¢/gal on every fill-up!
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Login to Online Banking</li>
          <li>Click on an eligible account</li>
          <li>Select Rewards on the Actions menu</li>
          <li>
            Click on <strong>Learn More</strong> under Fuel Savings to register
          </li>
        </ol>
        <p className="fw-bold">Mobile Banking</p>
        <ol>
          <li>Login to Mobile Banking</li>
          <li>Click on the Rewards tile</li>
          <li>
            Click on <strong>Learn More</strong> under Fuel Savings to register
          </li>
        </ol>
      </>
    )
  },
  {
    id: 585,
    question: (
      <>
        What does Mobile Phone Protection<sup>3</sup> cover?
      </>
    ),
    answer: (
      <>
        <p>
          Mobile Phone Protection will cover the replacement or repair costs if your cellphone is stolen or damaged, in
          the U.S. and abroad. For your cellphone to qualify, your cellphone bill must be paid through an eligible
          account.
        </p>
        <p>Refer to the table above to see specific amount coverages depending on the account type you have.</p>
      </>
    )
  },
  {
    id: 586,
    question: (
      <>
        How do I file a claim for Mobile Phone Protection<sup>3</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          File your claim online through Online or Mobile Banking. A $50 deductible applies for each claim. You can
          claim up to two times per twelve-month period.
        </p>
        <p className="fw-bold">Online Banking</p>
        <>
          <ol>
            <li>Login to Online Banking</li>
            <li>Click on an eligible account</li>
            <li>Select Rewards on the Actions menu</li>
            <li>
              Click on <strong>Security</strong>
            </li>
            <li>File claim</li>
          </ol>
          <p className="fw-bold">Mobile Banking</p>
          <ol>
            <li>Login to Mobile Banking</li>
            <li>Click on the Rewards tile</li>
            <li>
              Click on <strong>Security</strong>
            </li>
            <li>File claim</li>
          </ol>
        </>
      </>
    )
  },
  {
    id: 587,
    question: <>What do I do if I'm a victim of identity theft?</>,
    answer: (
      <>
        <p>
          As part of the Identity Theft Resolution Service<sup>3</sup>, should you become a victim of identity theft, a
          dedicated fraud specialist will be assigned to manage your case. Your fraud specialist will walk you through
          the recovery process and assist you until your credit and identity are restored.
        </p>
        <p>
          If you have become a victim of identity theft, please contact the Benefits Service Center at{" "}
          <a href="tel:866-210-0361" id="faq-benefits-service-center-tel-link">
            866-210-0361
          </a>{" "}
          Monday-Friday, 8:30am-4:00pm Pacific Time.
        </p>
      </>
    )
  },
  {
    id: 588,
    question: (
      <>
        How do I use Roadside Assistance<sup>3</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          24-hour roadside assistance includes vehicle towing, fuel/oil/fluid/water delivery, and battery/lock-out/tire
          assistance up to $100 per occurrence. Maximum of two occurrences per twelve-month period.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Login to Online Banking</li>
          <li>Click on an eligible account</li>
          <li>Select Rewards on the Actions menu</li>
          <li>
            Click on <strong>Travel and Leisure</strong>
          </li>
          <li>Locate the dedicated phone number and your unique access code</li>
          <li>Save to your phone as soon as possible!</li>
        </ol>
        <p className="fw-bold">Mobile Banking</p>
        <ol>
          <li>Login to Mobile Banking</li>
          <li>Click on the Rewards tile</li>
          <li>
            Click on <strong>Travel and Leisure</strong>
          </li>
          <li>Locate the dedicated phone number and your unique access code</li>
          <li>Save to your phone as soon as possible!</li>
        </ol>
      </>
    )
  },
  {
    id: 589,
    question: (
      <>
        What is my coverage on Rideshare Protection<sup>3</sup>?
      </>
    ),
    answer: (
      <p>
        Rideshare Protections covers up to $100,000 of AD&D coverage and $10,000 of accident medical expense benefits if
        injured while traveling in a vehicle operated by a Transportation Network Company, as defined in the insurance
        certificate. This includes up to $250 personal property benefits for replacement of property stolen, damaged, or
        destroyed due to an accident while traveling in a vehicle operated by a Transportation Network Company. Not
        available to residents of MO and NY.
      </p>
    )
  },
  {
    id: 590,
    question: (
      <>
        What does Telehealth<sup>4</sup> cover?
      </>
    ),
    answer: (
      <>
        <p>
          Access to 24/7 video or phone visits with U.S.-based board-certified, licensed, and credentialed doctors ready
          to help with urgent care or mental health for you and your family, all at no additional cost.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Login to Online Banking</li>
          <li>Click on an eligible account</li>
          <li>Select Rewards on the Actions menu</li>
          <li>
            Click on <strong>Health</strong>
          </li>
        </ol>
        <p className="fw-bold">Mobile Banking</p>
        <ol>
          <li>Login to Mobile Banking</li>
          <li>Click on the Rewards tile</li>
          <li>
            Click on <strong>Health</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 591,
    question: (
      <>
        How do I access Health Discounts<sup>6</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          A discount card will be mailed to the address on file upon account opening. A virtual card is available to
          download from the rewards site. Additional savings and discounts are also available online.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Login to Online Banking</li>
          <li>Click on an eligible account</li>
          <li>Select Rewards on the Actions menu</li>
          <li>
            Click on <strong>Health</strong>
          </li>
        </ol>
        <p className="fw-bold">Mobile Banking</p>
        <ol>
          <li>Login to Mobile Banking</li>
          <li>Click on the Rewards tile</li>
          <li>
            Click on <strong>Health</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 592,
    question: (
      <>
        How do I access Shopping Discounts<sup>7</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          With Shopping Rewards you can access exclusive offers and discounts at thousands of leading online retailers.
          Simply shop online using the Rewards customized shopping portal and get cash back.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Login to Online Banking</li>
          <li>Click on an eligible account</li>
          <li>Select Rewards on the Actions menu</li>
          <li>
            Click on <strong>Savings</strong>
          </li>
        </ol>
        <p className="fw-bold">Mobile Banking</p>
        <ol>
          <li>Login to Mobile Banking</li>
          <li>Click on the Rewards tile</li>
          <li>
            Click on <strong>Savings</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 593,
    question: (
      <>
        How do I access Travel and Leisure Discounts<sup>8</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Enjoy travel, dining, and shopping discounts year-round with InstaDeals™! Redeem and print coupons or access
          discounts from your smartphone.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Login to Online Banking</li>
          <li>Click on an eligible account</li>
          <li>Select Rewards on the Actions menu</li>
          <li>
            Click on <strong>Travel and Leisure</strong>
          </li>
        </ol>
        <p className="fw-bold">Mobile Banking</p>
        <ol>
          <li>Login to Mobile Banking</li>
          <li>Click on the Rewards tile</li>
          <li>
            Click on <strong>Travel and Leisure</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 594,
    question: <>¿Cuál es la diferencia entre Rewards y Premium Rewards?</>,
    answer: (
      <>
        <p>
          La diferencia entre los dos es que recibe más recompensas y, en algunos casos, una mayor cobertura con la
          cuenta Premium Rewards.
        </p>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-gray">
              <tr>
                <th>Interest Checking</th>
                <th>Premium Rewards Checking</th>
                <th>Rewards Checking</th>
              </tr>
            </thead>
            <tbody className="tbody-white">
              <tr>
                <td>$25 deposito inicial</td>
                <td>$25 deposito inicial</td>
                <td>$25 deposito inicial</td>
              </tr>
              <tr>
                <td>
                  Incluye:
                  <ul>
                    <li>Gana intereses sobre todos los saldos</li>
                    <li>Cheques gratuitos de la marca WaFd</li>
                    <li>Caja de seguridad 3x5” gratuito donde esté disponible</li>

                    <li>
                      Ahorro de Gasolina Shell de 5¢/gal<sup>2</sup>
                    </li>
                    <li>
                      Servicio de monitoreo de crédito y resolución de robo de identidad<sup>3</sup>
                    </li>
                    <li>
                      Hasta $1 millón en reembolso por robo de identidad<sup>3</sup>
                    </li>
                    <li>
                      Simulador de puntuación de crédito<sup>5</sup>
                    </li>
                    <li>
                      Hasta $800 de protección para teléfono móvil, por reclamo<sup>3</sup>
                    </li>
                    <li>Monitoreo de la Web Oscura</li>
                    <li>
                      Asistencia en carretera 24 horas al día, 7 días a la semana<sup>3</sup>
                    </li>
                    <li>
                      Protección de viajes compartidos<sup>3</sup>
                    </li>
                    <li>
                      Servicios de Telesalud 24 horas al día, 7 días a la semana<sup>4</sup>
                    </li>
                    <li>Protección del Comprador/Garantía Extendida</li>
                    <li>Seguro AD&amp;D</li>
                    <li>
                      Descuentos en compras<sup>7</sup>
                    </li>
                    <li>
                      Descuentos de salud<sup>6</sup>
                    </li>
                    <li>
                      Descuentos en viajes y ocio<sup>8</sup>
                    </li>
                  </ul>
                </td>
                <td>
                  Los Rewards premium incluyen:
                  <ul>
                    <li>
                      Ahorro de Gasolina Shell de 5¢/gal<sup>2</sup>
                    </li>
                    <li>
                      Servicio de Monitoreo de Crédito y Resolución de Robo de Identidad<sup>3</sup>
                    </li>
                    <li>
                      Hasta $1 millón en reembolso por robo de identidad<sup>3</sup>
                    </li>
                    <li>
                      Simulador de puntuación de crédito<sup>5</sup>
                    </li>
                    <li>
                      Hasta $800 de protección para teléfono móvil, por reclamo<sup>3</sup>
                    </li>
                    <li>Monitoreo de la Web Oscura</li>
                    <li>
                      Asistencia en carretera 24 horas al día, 7 días a la semana<sup>3</sup>
                    </li>
                    <li>
                      Servicios de Telesalud 24 horas al día, 7 días a la semana<sup>4</sup>
                    </li>
                    <li>Protección del Comprador/Garantía Extendida</li>
                    <li>Seguro AD&amp;D</li>
                    <li>
                      Descuentos en compras<sup>7</sup>
                    </li>
                    <li>
                      Descuentos en compras<sup>6</sup>
                    </li>
                    <li>
                      Descuentos en viajes y ocio<sup>8</sup>
                    </li>
                  </ul>
                </td>
                <td>
                  Rewards incluye:
                  <ul>
                    <li>
                      Ahorro de Gasolina Shell de 5¢/gal<sup>2</sup>
                    </li>
                    <li>
                      Servicio de Monitoreo de Crédito y Resolución de Robo de Identidad<sup>3</sup>
                    </li>
                    <li>
                      Hasta $25,000 en reembolso por robo de identidad<sup>3</sup>
                    </li>
                    <li>
                      Hasta $500 de protección para teléfono móvil, por reclamo<sup>3</sup>
                    </li>
                    <li>Protección del Comprador/Garantía Extendida</li>
                    <li>Seguro AD&amp;D</li>
                    <li>Descuentos en compras</li>
                    <li>
                      Descuentos de salud<sup>7</sup>
                    </li>
                    <li>
                      Descuentos en viajes y ocio<sup>6</sup>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <span className="text-success fw-bold">$12</span> por mes
                  <br />
                  Tarifa exenta con un saldo promedio diario de $5,000 o $50,000 en cuentas relacionadas
                </td>
                <td>
                  <span className="text-success fw-bold">$9</span> por mes
                  <br />
                  Sin requisito de saldo mínimo.
                </td>
                <td>
                  <span className="text-success fw-bold">$6</span> por mes
                  <br />
                  Sin requisito de saldo mínimo.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    )
  },
  {
    id: 595,
    question: <>¿Cómo accedo a rewards en la Banca en Línea?</>,
    answer: (
      <p>
        Para acceder a recompensas en la Banca en Línea, primero haga clic en una cuenta elegible y luego seleccione
        Rewards en el menú Acciones.
      </p>
    )
  },
  {
    id: 596,
    question: <>¿Cómo accedo a Rewards en la Banca Móvil?</>,
    answer: <p>Para acceder a recompensas en la Banca Móvil, haga clic en el mosaico Rewards.</p>
  },
  {
    id: 597,
    question: (
      <>
        ¿Cómo me registro en Fuel Savings<sup>2</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Disfrute del estatus Gold extendido en las estaciones Shell participantes con el programa Fuel Rewards
          <sup>&reg;</sup> y ahorre 5¢/gal.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Inicie sesión en la Banca en Línea</li>
          <li>Haga clic en una cuenta elegible</li>
          <li>Seleccione Rewards en el menú Acciones</li>
          <li>
            Haga clic en <strong>Más información</strong> en Ahorros de combustible para registrarse
          </li>
        </ol>
        <p className="fw-bold">La banca móvil</p>
        <ol>
          <li>Inicie sesión en Banca Móvil</li>
          <li>Haga clic en Rewards</li>
          <li>
            Haga clic en <strong>Más información</strong> en Ahorros de Gasolina para registrarse
          </li>
        </ol>
      </>
    )
  },
  {
    id: 598,
    question: (
      <>
        ¿Qué cubre la Protección del Teléfono<sup>3</sup> Móvil?
      </>
    ),
    answer: (
      <>
        <p>
          Mobile Phone Protection cubrirá los costos de reemplazo o reparación si su teléfono celular es robado o
          dañado, en los EE. UU. y en el extranjero. Para que su teléfono celular califique, su factura de teléfono
          celular debe pagarse a través de una cuenta elegible.
        </p>
        <p>
          Consulte la tabla anterior para ver las coberturas de montos específicos según el tipo de cuenta que tenga.
        </p>
      </>
    )
  },
  {
    id: 599,
    question: (
      <>
        ¿Cómo presento un reclamo de Protección para Teléfono Móvil<sup>3</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Presente su reclamo en línea a través de la Banca en Línea o Móvil. Se aplica un deducible de $50 por cada
          reclamo. Puedes reclamar hasta dos veces por período de doce meses.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Inicie sesión en la Banca en Línea</li>
          <li>Haga clic en una cuenta elegible</li>
          <li>Seleccione Rewards en el menú Acciones</li>
          <li>
            Haga clic en <strong>Seguridad</strong>
          </li>
          <li>Presentar reclamo</li>
        </ol>
        <p className="fw-bold">La banca móvil</p>
        <ol>
          <li>Inicie sesión en Banca Móvil</li>
          <li>Haga clic en Recompensas</li>
          <li>
            Haga clic en <strong>Seguridad</strong>
          </li>
          <li>Presentar reclamo</li>
        </ol>
      </>
    )
  },
  {
    id: 600,
    question: <>¿Qué hago si soy víctima de robo de identidad?</>,
    answer: (
      <>
        <p>
          Como parte del Servicio de resolución de robo de identidad, si usted se convierte en víctima de robo de
          identidad, se le asignará un especialista en fraude dedicado para gestionar su caso. Su especialista en fraude
          lo guiará a través del proceso de recuperación y lo ayudará hasta que se restablezcan su crédito y su
          identidad.
        </p>
        <p>
          Si ha sido víctima de robo de identidad, comuníquese con el Centro de servicios de beneficios al{" "}
          <a href="tel:866-210-0361" id="faq-benefits-service-center-tel-link">
            866-210-0361
          </a>{" "}
          de Lunes a Viernes, de 8:30 a. m. a 4:00 p. m., hora del Pacífico.
        </p>
      </>
    )
  },
  {
    id: 601,
    question: (
      <>
        ¿Cómo uso la asistencia en la carretera<sup>3</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          La asistencia en carretera las 24 horas incluye remolque de vehículos, entrega de gas/aceite/líquido/agua y
          asistencia con batería/bloqueo/llantas hasta $100 por incidente. Máximo de dos ocurrencias por período de doce
          meses.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Inicie sesión en la Banca en Línea</li>
          <li>Haga clic en una cuenta elegible</li>
          <li>Seleccione Rewards en el menú Acciones</li>
          <li>
            Haga clic en <strong>Viajes y Ocio</strong>
          </li>
          <li>Localice el número de teléfono exclusivo y su código de acceso único</li>
          <li>Guarde en su teléfono lo antes posible!</li>
        </ol>
        <p className="fw-bold">La banca móvil</p>
        <ol>
          <li>Inicie sesión en Banca Móvil</li>
          <li>Haga clic en Rewards</li>
          <li>
            Haga clic en <strong>Viajes y Ocio</strong>
          </li>
          <li>Localice el número de teléfono exclusivo y su código de acceso único</li>
          <li>Guarde en su teléfono lo antes posible!</li>
        </ol>
      </>
    )
  },
  {
    id: 602,
    question: (
      <>
        ¿Cuál es mi cobertura en Rideshare Protection<sup>3</sup>?
      </>
    ),
    answer: (
      <p>
        Rideshare Protections cubre hasta $100,000 de cobertura AD&D y $10,000 de beneficios de gastos médicos por
        accidente si se lesiona mientras viaja en un vehículo operado por una Compañía de Red de Transporte, como se
        define en el certificado de seguro. Esto incluye hasta $250 de beneficios de propiedad personal para el
        reemplazo de propiedad robada, dañada o destruida debido a un accidente mientras viajaba en un vehículo operado
        por una Compañía de la Red de Transporte. No disponible para residentes de MO y NY.
      </p>
    )
  },
  {
    id: 603,
    question: (
      <>
        ¿Qué cubre Telesalud<sup>4</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Acceso a visitas telefónicas o por video las 24 horas, los 7 días de la semana, con médicos certificados,
          autorizados y acreditados con sede en los EE. UU., listos para ayudarlo con atención de urgencia o salud
          mental para usted y su familia, todo sin costo adicional.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Inicie sesión en la Banca en Línea</li>
          <li>Haga clic en una cuenta elegible</li>
          <li>Seleccione Rewards en el menú Acciones</li>
          <li>
            Haga clic en <strong>Salud</strong>
          </li>
        </ol>
        <p className="fw-bold">La banca móvil</p>
        <ol>
          <li>Inicie sesión en Banca Móvil</li>
          <li>Haga clic en Recompensas</li>
          <li>
            Haga clic en <strong>Salud</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 604,
    question: (
      <>
        ¿Cómo accedo a Descuentos de Salud<sup>6</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Se enviará una tarjeta de descuento por correo a la dirección registrada al momento de abrir la cuenta. Hay
          una tarjeta virtual disponible para descargar desde el sitio de recompensas. Ahorros y descuentos adicionales
          también están disponibles en línea.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Inicie sesión en la Banca en Línea</li>
          <li>Haga clic en una cuenta elegible</li>
          <li>Seleccione Rewards en el menú Acciones</li>
          <li>
            Haga clic en <strong>Salud</strong>
          </li>
        </ol>
        <p className="fw-bold">La banca móvil</p>
        <ol>
          <li>Inicie sesión en Banca Móvil</li>
          <li>Haga clic en Recompensas</li>
          <li>
            Haga clic en <strong>Salud</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 605,
    question: (
      <>
        ¿Cómo accedo a los descuentos en compras<sup>7</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Con Shopping Rewards puedes acceder a ofertas y descuentos exclusivos en miles de minoristas líderes en línea.
          Simplemente compre en línea utilizando el portal de compras personalizado de Rewards y obtenga un reembolso en
          efectivo.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Inicie sesión en la Banca en Línea</li>
          <li>Haga clic en una cuenta elegible</li>
          <li>Seleccione Rewards en el menú Acciones</li>
          <li>
            Haga clic en <strong>Ahorros</strong>
          </li>
        </ol>
        <p className="fw-bold">La banca móvil</p>
        <ol>
          <li>Inicie sesión en Banca Móvil</li>
          <li>Haga clic en Recompensas</li>
          <li>
            Haga clic en <strong>Ahorros</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 606,
    question: (
      <>
        ¿Cómo accedo a los descuentos en viajes y ocio<sup>8</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Disfrute de descuentos en viajes, cenas y compras durante todo el año con InstaDeals™! Canjea e imprime
          cupones o accede a descuentos desde tu smartphone.
        </p>
        <p className="fw-bold">Online Banking</p>
        <ol>
          <li>Inicie sesión en la Banca en Línea</li>
          <li>Haga clic en una cuenta elegible</li>
          <li>Seleccione Rewards en el menú Acciones</li>
          <li>
            Haga clic en <strong>Viajes y Ocio</strong>
          </li>
        </ol>
        <p className="fw-bold">La banca móvil</p>
        <ol>
          <li>Inicie sesión en Banca Móvil</li>
          <li>Haga clic en Rewards</li>
          <li>
            Haga clic en <strong>Viajes y Ocio</strong>
          </li>
        </ol>
      </>
    )
  },
  {
    id: 607,
    question: <>How do I turn off my browser pop-up blocker?</>,
    answer: (
      <>
        <p>
          A pop-up blocker is any program that prohibits a pop-up at some point in time. This may consist of multiple
          internet windows, or actual pop-ups caused by coding on a webpage. Generally, pop-up blockers are installed to
          avoid pop-up ads from webpages. However, depending upon the pop-up blocker, they may block useful information
          as well. These could include option screens such as print and download options screens, or they could stop
          pop-ups which would confirm downloads or show a result to a page.
        </p>
        <ul>
          <li>
            <a
              href="https://support.google.com/chrome/answer/95472?hl=en&co=GENIE.Platform%3DDesktop"
              id="faq-607-chrome-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Chrome
            </a>
          </li>
          <li>
            <a
              href="https://support.apple.com/guide/safari/block-pop-ups-sfri40696/17.0/mac/14.0"
              id="faq-607-safari-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Safari
            </a>
          </li>
          <li>
            <a
              href="https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5"
              id="faq-607-edge-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Edge
            </a>
          </li>
          <li>
            <a
              href="https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting"
              id="faq-607-firefox-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Firefox
            </a>
          </li>
        </ul>
      </>
    )
  },
  {
    id: 608,
    question: <>What is the half-season ticket membership offer?</>,
    answer: (
      <p>
        Receive a $200 Kraken team store gift card and an invite to an exclusive Kraken player meet and greet during the
        2024-25 NHL season.
      </p>
    )
  },
  {
    id: 609,
    question: <>How do I qualify?</>,
    answer: (
      <>
        <p>
          Open an eligible WaFd Bank checking account with a Kraken debit card and purchase a half-season ticket plan
          for the Seattle Kraken using your WaFd Kraken debit card.
        </p>
        <p>
          You can open an eligible account with a Kraken debit card at a{" "}
          <Link to="/locations" id="faq-609-locations-link">
            branch near you
          </Link>
          or{" "}
          <Link to="/open-bank-account-online" id="faq-609-open-bank-account-online-link">
            https://www.wafdbank.com/open-bank-account-online
          </Link>
          .
        </p>
      </>
    )
  },
  {
    id: 610,
    question: <>What account options are eligible?</>,
    answer: (
      <p>
        **Free Checking, ***Rewards Checking, and ***Premium Rewards Checking accounts are eligible for this promotion.
        You can find more information on{" "}
        <Link to="/personal-banking/free-checking-account" id="faq-610-free-checking-account-link">
          Free Checking
        </Link>{" "}
        or{" "}
        <Link to="/personal-banking/checking-account/rewards-checking" id="faq-610-rewards-checking-account-link">
          Rewards and Premium Rewards Checking
        </Link>{" "}
        (which come with a slew of benefits, discounts, and more, like gas savings) on our account pages.
      </p>
    )
  },
  {
    id: 611,
    question: <>How long is this offered?</>,
    answer: <p>This offer runs June 18, 2024 through November 1, 2024.</p>
  },
  {
    id: 612,
    question: <>Where do I go to sign up online?</>,
    answer: (
      <p>
        <a
          href="https://www.nhl.com/kraken/tickets/season-tickets"
          id="faq-612-nhl-season-tickets-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.nhl.com/kraken/tickets/season-tickets
        </a>
      </p>
    )
  },
  {
    id: 613,
    question: <>Can I open an account online?</>,
    answer: (
      <p>
        You can{" "}
        <Link to="/open-bank-account-online" id="faq-613-open-bank-account-online-link">
          open an account online
        </Link>{" "}
        anytime! If you have questions during the account opening process, feel free to give us a call at{" "}
        <a href="tel:800-324-9375" id="faq-613-kraken-tickets-tel-link">
          800-324-9375
        </a>
        . To be eligible, you must open a Free Checking, Rewards Checking, or Premium Rewards Checking and choose a
        Kraken debit card.
      </p>
    )
  },
  {
    id: 614,
    question: <>Where are WaFd Bank branches?</>,
    answer: (
      <p>
        We have 74 branches across Washington State.{" "}
        <Link to="/locations" id="faq-614-locations-link">
          Find a branch near you
        </Link>
        .
      </p>
    )
  },
  {
    id: 615,
    question: <>What will I receive?</>,
    answer: (
      <p>
        Once your eligible WaFd Bank checking account is opened and you use your WaFd Bank Kraken debit card to make a
        payment on your half-season ticket plan, you'll receive a $200 Kraken Team Store gift card and an email
        invitation to a meet and greet event with Kraken players.
      </p>
    )
  },
  {
    id: 616,
    question: <>When will I receive the gift card and invitation to the player event?</>,
    answer: (
      <>
        <p>
          Your team store gift card will be sent to you once the Seattle Kraken ticketing team verifies you have made a
          payment on your half-season ticket plan using your new WaFd Bank Kraken debit card.
        </p>
        <p>
          Your invitation to the player event will be sent later in the 2024-25 season to the email address on file with
          your Kraken season ticket holder account.
        </p>
      </>
    )
  },
  {
    id: 617,
    question: (
      <>
        Do I qualify for this offer if I'm a current WaFd Bank Kraken debit card holder purchasing a Kraken half-season
        ticket plan?
      </>
    ),
    answer: (
      <p>
        Current WaFd Bank Kraken debit card holders that use their card to purchase a half-season ticket plan qualify
        for the player meet and greet later in 2024-2025 season but not the $200 team store gift card.
      </p>
    )
  },
  {
    id: 618,
    question: <>What other rules or fees apply to my WaFd checking account?</>,
    answer: (
      <>
        <p>*See below for terms and conditions.</p>
        <p>**Nonsufficient funds fees may apply.</p>
        <p>***Some benefits may require activation and/or registration. Restrictions may apply.</p>
        <p>
          Only Free Checking, Rewards Checking, and Premium Rewards Checking accounts with a Kraken debit card are
          eligible for this promotion. $25 initial deposit required for all accounts. For additional terms and
          conditions of your account, please refer to the Personal Deposit Account Agreement and Disclosures governing
          your account.
        </p>
      </>
    )
  },
  {
    id: 619,
    question: <>Offer Terms and Conditions</>,
    answer: (
      <>
        <p>
          Offer Period: The WaFd Bank / Seattle Kraken Half-Season Ticket Membership Offer (the "Offer") begins at
          8:00am PDT on June 18, 2024 and ends at 5:00pm PDT on November 1, 2024 (the "Offer Period").
        </p>
        <p>
          Eligibility and Offer Requirements: The Offer is for new WaFd Bank Free Checking, Rewards Checking or Premium
          Rewards Checking accounts opened with a Seattle Kraken debit card. You must be a Washington state resident at
          least 18 years of age to be eligible for this promotion. All account applications are subject to approval.
          After an eligible account is opened, the account owner must use their WaFd Bank Kraken debit card to purchase
          a Half-Season Ticket Membership Plan from the Seattle Kraken. Both the new WaFd Bank account opening and at
          least one (1) payment on the Seattle Kraken Half-Season Ticket Membership Plan using the WaFd Kraken debit
          card (as part of a payment plan, if any, agreed by the Seattle Kraken) must be complete before the end of the
          Offer Period. Neither WaFd Bank nor the Seattle Kraken are responsible for failures of any kind which may
          cause or contribute to a delay in completing the Offer requirements. Employees of WaFd Bank, Seattle Hockey
          Partners LLC, Seattle Arena Company, LLC and any of their respective subsidiaries, parent companies or
          affiliates, or people living within such employee households are not eligible to participate in the Offer.
        </p>
        <p>
          Offer Fulfillment: Once WaFd Bank and the Seattle Kraken have verified that the Offer requirements have been
          met (i) a $200 gift card to the Seattle Kraken team store will be mailed to the account owner at the address
          on file with the Seattle Kraken postmarked no later than thirty (30) days after the end of the Offer Period
          (terms and conditions on gift card may apply) and (ii) the account owner will receive an invitation for a meet
          and greet with Seattle Kraken players, including the date, time, location and other details, via e-mail at the
          e-mail address on file with the Seattle Kraken no later than thirty (30) days after the end of the Offer
          Period (collectively, the “Bonus”). All federal, state and local taxes and any expenses relating to the
          receipt or use of the Bonus are the sole responsibility of the applicable account owner.
        </p>
        <p>
          Data Privacy: By completing the Offer requirements, each account owner consents to the collection, use and
          sharing of their personal information by (i) the Seattle Kraken in accordance with their privacy policy
          (available at{" "}
          <a
            href="https://www.nhl.com/kraken/info/privacy"
            id="faq-619-nhl-privacy-page"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.nhl.com/kraken/info/privacy
          </a>
          ) and (ii) WaFd in accordance with their privacy policy (available at
          <Link to="/privacy-center" id="faq-619-privacy-center-link">
            https://www.wafdbank.com/privacy-center
          </Link>
          ).
        </p>
        <p>
          Additional Terms and Conditions: The Offer cannot be reproduced, sold, transferred or traded. Limit one (1)
          Bonus per account owner.
        </p>
        <p>A limited amount of Half-Season Ticket packages are available for purchase.</p>
      </>
    )
  },
  {
    id: 620,
    question: <>Can I request a credit line change?</>,
    answer: (
      <p>
        Yes, you can request either a credit line increase or decrease. Consideration for credit line increases is only
        available to cardholders who have had an active card in good standing for at least 24 months. Community Banking
        increase requirements differ based on relationship. Any credit line changes may impact Visa tier benefits or
        loyalty resulting in a new card issued. Call{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        or work with your local branch to learn more.
      </p>
    )
  },
  {
    id: 621,
    question: <>Can I have more than one WaFd Bank credit card?</>,
    answer: (
      <p>
        You may qualify for multiple card products. However, Community Banking Cash Bank cardholders are limited to one
        open credit card per business, up to two businesses per client. Total maximum aggregate credit line amount must
        equal the total qualifying amount of the individual.
      </p>
    )
  },
  {
    id: 622,
    question: <>Can I transfer balances from my non-WaFd Bank accounts to my WaFd Bank credit card?</>,
    answer: (
      <p>
        We don't allow balance transfers at this time, with the exception of our Select Banking credit card. If you're a
        select client, contact your Select Banker for more information.
      </p>
    )
  },
  {
    id: 623,
    question: <>I'm concerned about fraud. What can I do to protect my account?</>,
    answer: (
      <p>
        WaFd Bank is always looking for ways to implement new protections to keep your accounts secure. Our fraud vendor
        may send out fraud alerts related to your account to verify whether a transaction was fraudulent or not. The SMS
        number you can expect a fraud alert from is <strong>86975</strong>. Ensure your mobile phone number is updated
        on your account to receive alerts for seamless usage. You can find additional information regarding fraud tools
        and services on the{" "}
        <a
          id="visa-security-external-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://usa.visa.com/support/consumer/security.html"
        >
          Visa Security and Fraud Prevention website
        </a>
        .
      </p>
    )
  },
  {
    id: 624,
    question: <>Can I still apply for a WaFd Bank credit card if I'm retired or unemployed?</>,
    answer: (
      <>
        <p>
          Yes, you can apply. If you've been retired or unemployed for less than two years, the following information is
          required.
        </p>
        <ul>
          <li>Previous employment</li>
          <li>Occupation</li>
          <li>Employer name</li>
          <li>Duration</li>
        </ul>
      </>
    )
  },
  {
    id: 625,
    question: <>¿Cómo puedo solicitar una tarjeta de crédito?</>,
    answer: (
      <>
        <ol>
          <li>
            Visita{" "}
            <Link className="faq-internal-page-link" to="/es/banca-personal/tarjetas-de-credito">
              wafdbank.com/es/banca-personal/tarjetas-de-credito
            </Link>
            .
          </li>
          <li>
            Presiona <strong>Aplica Ya</strong> debajo del producto de tarjeta de crédito que deseas.{" "}
          </li>
          <li>Sigue las indicaciones para el proceso de solicitud en línea.</li>
        </ol>
        <p>
          Por favor, visita tu{" "}
          <Link to="/es/sucursales" className="faq-internal-page-link">
            sucursal local
          </Link>{" "}
          si necesitas ayuda adicional.
        </p>
      </>
    )
  },
  {
    id: 626,
    question: <>¿Cómo puedo acceder a mi cuenta de tarjeta de crédito?</>,
    answer: (
      <ol>
        <li>
          Visita{" "}
          <Link className="faq-internal-page-link" to="/es/banca-personal/tarjetas-de-credito">
            wafdbank.com/es/banca-personal/tarjetas-de-credito
          </Link>
          .
        </li>
        <li>Accede al portal de la tarjeta de crédito.</li>
        <li>
          Ingresa tus credenciales para iniciar sesión.
          <br />
          <em>Si eres un nuevo usuario, se te pedirá que te inscribas para crear tu cuenta.</em>
        </li>
        <li>
          Si eres titular de una cuenta de consumidor de WaFd Bank (con una cuenta corriente o de ahorros) con banca en
          línea de WaFd Bank, puedes:
          <ul>
            <li>Verifica el saldo de tu tarjeta de crédito.</li>
            <li>Ver información relacionada de forma limitada.</li>
            <li>Accede a un enlace directo al portal de la tarjeta de crédito para obtener funcionalidad completa.</li>
          </ul>
        </li>
      </ol>
    )
  },
  {
    id: 627,
    question: <>¿Cuánto tiempo tardaré en recibir mi tarjeta de crédito?</>,
    answer: (
      <p>
        Quienes hayan sido aprobados automáticamente deberían recibir su tarjeta de crédito en un plazo de 7 a 10 días
        hábiles.
      </p>
    )
  },
  {
    id: 628,
    question: <>Mi solicitud está siendo revisada. ¿Cuándo seré aprobado?</>,
    answer: (
      <p>
        Por lo general, comenzamos a revisar manualmente las solicitudes al siguiente día hábil. Si tenemos preguntas
        adicionales, nos pondremos en contacto contigo. Por lo general, la revisión puede tomar alrededor de una semana,
        pero a veces puede tardar un par de semanas.
      </p>
    )
  },
  {
    id: 629,
    question: <>No fui aprobado. ¿Por qué?</>,
    answer: (
      <>
        <p>
          Tu solicitud de tarjeta de crédito fue sometida a un proceso de decisión exhaustivo basado en lo siguiente:
        </p>
        <ul>
          <li>Tu historial crediticio</li>
          <li>Normas de suscripción de prestamos</li>
          <li>Políticas de riesgo del banco</li>
        </ul>
        <p>
          Nuestra decisión puede haberse basado en su totalidad o en parte en información obtenida en un informe de una
          agencia de informes de consumidores. La agencia de informes no tuvo participación en nuestra decisión y no
          puede proporcionar razones específicas por las cuales hemos denegado el crédito para usted. Aquellos que sean
          denegados recibirán una carta por correo que define las razones de la negación.
        </p>
      </>
    )
  },
  {
    id: 630,
    question: <>¿Cómo activo mi tarjeta de crédito?</>,
    answer: (
      <>
        <p>Debes inscribir tu tarjeta de crédito antes de activarla.</p>
        <p>
          <strong>Inscribirse</strong>
        </p>
        <ol>
          <li>
            Visita{" "}
            <Link className="faq-internal-page-link" to="/es/banca-personal/tarjetas-de-credito">
              wafdbank.com/es/banca-personal/tarjetas-de-credito
            </Link>
          </li>
          <li>Accede al portal de la tarjeta de crédito y sigue las indicaciones para crear credenciales.</li>
        </ol>
        <p>
          <strong>Activar en línea</strong>
        </p>
        <ol>
          <li>
            Visita{" "}
            <Link className="faq-internal-page-link" to="/es/banca-personal/tarjetas-de-credito">
              wafdbank.com/es/banca-personal/tarjetas-de-credito
            </Link>
            .
          </li>
          <li>Accede al portal de la tarjeta de crédito</li>
          <li>Inicie su sesión en el portal</li>
          <li>
            Selecciona el menú de <strong>Servicios de Cuenta</strong>
          </li>
          <li>
            Encuentra y selecciona el enlace de <strong>Activación de Tarjeta</strong>, y sigue las indicaciones para
            activar tu tarjeta.
          </li>
        </ol>
        <p>
          <strong>Activar por teléfono</strong>
        </p>
        <p>
          Activa tu tarjeta por teléfono llamando al{" "}
          <a className="faq-credit-card-activation-tel-link-2" href="tel:866-513-0483">
            866-513-0483
          </a>
          . Para problemas con la activación, llama a nuestro Centro de Atención al Cliente al{" "}
          <a className="faq-credit-card-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 631,
    question: <>Ya tengo una tarjeta de crédito de WaFd Bank. ¿Esta es diferente?</>,
    answer: (
      <>
        <p>
          Si ya tienes una tarjeta de crédito con el logo de WaFd Bank, ¡entonces sí, es diferente! La tarjeta de
          crédito que tienes fue proporcionada por WaFd Bank a través de una asociación con Elan. Tomamos la decisión de
          terminar nuestra asociación con Elan y ya no ofreceremos sus productos de tarjetas de crédito a partir del 1
          de abril de 2020.
        </p>
        <ul>
          <li>
            Tu cuenta existente de tarjeta de crédito y los términos no cambiarán. Simplemente, ya no será respaldada
            por WaFd Bank. Seguirás teniendo funcionalidad completa de la tarjeta y podrás acceder a tu cuenta yendo
            directamente al portal{" "}
            <a
              id="my-account-access-external-link-2"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.myaccountaccess.com"
            >
              myaccountaccess.com
            </a>
            portal.
          </li>
          <li>
            Tu tarjeta plástica no se reemitirá automáticamente, hasta que expire o sea reemplazada debido a pérdida o
            robo. En ese momento, puedes esperar una nueva tarjeta con el logo de Elan reemplazando el logo de WaFd
            Bank.
          </li>
          <li>
            Si deseas solicitar una nueva tarjeta de crédito de WaFd Bank, puedes hacerlo solicitando en nuestro sitio
            web o contactando tu{" "}
            <Link to="/es/sucursales" className="faq-internal-page-link">
              sucursal local
            </Link>
            .
          </li>
        </ul>
      </>
    )
  },
  {
    id: 632,
    question: <>¿Olvidaste tu nombre de usuario o contraseña?</>,
    answer: (
      <>
        <ol>
          <li>Accede a la pantalla de inicio de sesión.</li>
          <li>
            Selecciona <strong>¿Olvidaste tu nombre de usuario?</strong>
          </li>
          <li>Sigue los pasos para restablecer tu información si es necesario.</li>
        </ol>
        <p>
          Si necesitas ayuda adicional, por favor llama a nuestro Centro de Atención al Cliente al{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          o envía un correo electrónico a{" "}
          <a className="faq-ask-wafd-cards-email-link" href="mailto:ask@wafdcards.com">
            ask@wafdcards.com
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 633,
    question: <>¿Qué sucede si mi tarjeta se pierde, es robada o está dañada?</>,
    answer: (
      <p>
        Puedes reportar tu tarjeta como perdida, robada o dañada y solicitar un reemplazo contactando a nuestro Centro
        de Atención al Cliente al{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 634,
    question: <>¿Cómo me inscribo en los estados de cuenta electrónicos?</>,
    answer: (
      <>
        <p>Hay dos opciones de entrega de estados de cuenta:</p>
        <ul>
          <li>
            <>
              <strong>Electrónica</strong>
              <br />
            </>
            Optar por no recibir estados de cuenta en papel.
          </li>
          <li>
            <>
              <strong>Correo</strong>
              <br />
            </>
            Los estados de cuenta se envían por correo y también están disponibles en línea.
          </li>
        </ul>
        <p>Para seleccionar tu opción de entrega de estados de cuenta, sigue los siguientes pasos:</p>
        <ol>
          <li>
            Visita{" "}
            <Link className="faq-internal-page-link" to="/es/banca-personal/tarjetas-de-credito">
              wafdbank.com/es/banca-personal/tarjetas-de-credito
            </Link>
            .
          </li>
          <li>Localiza y accede al portal de la tarjeta de crédito.</li>
          <li>Inicia sesión utilizando tus credenciales.</li>
          <li>
            En el <strong>menú de Estados de cuenta</strong>, selecciona{" "}
            <strong>Opciones de entrega de estados de cuenta.</strong>
          </li>
          <li>Selecciona tu método de entrega de estados de cuenta.</li>
        </ol>
      </>
    )
  },
  {
    id: 635,
    question: <>¿Cómo hago un pago?</>,
    answer: (
      <>
        <p>Puedes pagar tu tarjeta de crédito utilizando una de las siguientes opciones:</p>
        <ul>
          <li>
            <strong>En línea</strong>
            <br />
            Para hacer un pago en línea
            <ol>
              <li>
                Visita{" "}
                <Link className="faq-internal-page-link" to="/es/banca-personal/tarjetas-de-credito">
                  wafdbank.com/es/banca-personal/tarjetas-de-credito
                </Link>
                .
              </li>
              <li>Localiza y accede al portal de la tarjeta de crédito.</li>
              <li>Inicia sesión utilizando tus credenciales.</li>
              <li>
                Selecciona <strong>Pago</strong> para comenzar a configurar tu pago.
              </li>
            </ol>
          </li>
          <li>
            <strong>Teléfono</strong>
            <br />
            Para hacer un pago por teléfono, llamanos al{" "}
            <a className="faq-c3-tel-link" href="tel:800-324-9375">
              800-324-9375
            </a>
          </li>
          <li>
            <strong>Correo</strong>
            <br />
            Para hacer un pago por correo, envía un cheque junto con el cupón de pago del estado de cuenta.
          </li>
          <li>
            <strong>En Persona</strong>
            <br />
            Para hacer un pago en persona, visita una de nuestras{" "}
            <Link to="/es/sucursales" className="faq-internal-page-link">
              sucursales locales
            </Link>
            .
          </li>
        </ul>
      </>
    )
  },
  {
    id: 636,
    question: <>¿Qué permisos se otorgan a los usuarios autorizados?</>,
    answer: (
      <>
        <p>
          Los usuarios autorizados tienen permiso del titular principal de la cuenta para realizar transacciones con su
          tarjeta, como compras o adelantos de efectivo. Los usuarios autorizados no son responsables de pagar el saldo
          de crédito. El titular principal de la cuenta es responsable del saldo de crédito. Sin embargo, los usuarios
          autorizados pueden hacer un pago en línea o visitar una sucursal de WaFd Bank para hacer un pago en persona.
          <br />
          <strong className="text-danger">Precaución:</strong> Los usuarios autorizados no pueden hacer pagos en
          efectivo.
        </p>
        <p>
          Un usuario autorizado puede inscribirse en el portal en línea de la tarjeta de crédito donde tienen acceso
          completo al historial de transacciones, estados de cuenta y pueden iniciar disputas. Los usuarios autorizados
          no pueden cambiar ninguna información de la cuenta principal ni solicitar cambios en el límite de crédito.
        </p>
      </>
    )
  },
  {
    id: 637,
    question: <>¿Es un usuario autorizado lo mismo que un titular conjunto?</>,
    answer: (
      <p>
        No. En este momento, no permitimos titulares conjuntos para ninguno de nuestros productos de tarjetas de crédito
        para consumidores. Un usuario autorizado es una persona a la que se le da permiso para usar la tarjeta del
        titular principal de la cuenta para hacer compras y no es responsable del saldo de la tarjeta de crédito. La
        cuenta de la tarjeta de crédito aparece en su informe crediticio como una cuenta de línea de crédito. El uso y
        la devolución de la tarjeta de crédito pueden afectar su informe crediticio.
      </p>
    )
  },
  {
    id: 638,
    question: <>¿Qué es una transacción de pago pendiente?</>,
    answer: (
      <p>
        Dependiendo del tipo de pago, puede haber un bloqueo colocado por fines de verificación de fraude. El pago se
        considera en proceso durante este tiempo y los fondos y el saldo se restauran en breve. Si tienes preguntas
        específicas sobre la cuenta del titular principal, llama al{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>
        .
      </p>
    )
  },
  {
    id: 639,
    question: <>¿Puedo solicitar un cambio en la línea de crédito?</>,
    answer: (
      <p>
        Sí, puedes solicitar un aumento o una disminución en la línea de crédito. La consideración para aumentos en la
        línea de crédito minorista está disponible solo para titulares de tarjetas que han tenido una tarjeta activa en
        buen estado durante al menos 24 meses. Los requisitos para aumentos en la línea de crédito de Community Banking
        difieren según la relación. Cualquier cambio en la línea de crédito puede afectar los beneficios de nivel Visa o
        la fidelidad, lo que podría resultar en la emisión de una nueva tarjeta. Llama al{" "}
        <a className="faq-c3-tel-link" href="tel:800-324-9375">
          800-324-9375
        </a>{" "}
        o trabaja con tu{" "}
        <Link to="/es/sucursales" className="faq-internal-page-link">
          sucursal locales
        </Link>{" "}
        para obtener más información.
      </p>
    )
  },
  {
    id: 640,
    question: <>¿Puedo tener más de una tarjeta de crédito de WaFd Bank?</>,
    answer: (
      <p>
        Puedes calificar para varios productos de tarjetas. Sin embargo, los titulares de tarjetas Community Banking
        Cash Bank están limitados a una tarjeta de crédito abierta por negocio, hasta dos negocios por cliente. El monto
        máximo total de la línea de crédito agregada debe igualar el monto total calificado del individuo.
      </p>
    )
  },
  {
    id: 641,
    question: (
      <>¿Puedo transferir saldos de mis cuentas no pertenecientes a WaFd Bank a mi tarjeta de crédito de WaFd Bank?</>
    ),
    answer: (
      <p>
        Actualmente, no permitimos transferencias de saldo, con excepción de nuestra tarjeta de crédito Select Banking.
        Si eres un cliente selecto, comunícate con tu Banquero Select para obtener más información.
      </p>
    )
  },
  {
    id: 642,
    question: <>Estoy preocupado por el fraude. ¿Qué puedo hacer para proteger mi cuenta?</>,
    answer: (
      <p>
        WaFd Bank siempre está buscando formas de implementar nuevas protecciones para mantener seguras tus cuentas.
        Nuestro proveedor de fraude puede enviar alertas de fraude relacionadas con tu cuenta para verificar si una
        transacción fue fraudulenta o no. El número de SMS desde el que puedes esperar una alerta de fraude es{" "}
        <strong>86975</strong>. Asegúrate de que tu número de teléfono móvil esté actualizado en tu cuenta para recibir
        alertas y garantizar un uso sin problemas. Puedes encontrar información adicional sobre herramientas y servicios
        contra el fraude en el{" "}
        <a
          id="visa-security-external-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://usa.visa.com/support/consumer/security.html"
        >
          sitio web de Visa de Seguridad y Prevención de Fraude
        </a>
        .
      </p>
    )
  },
  {
    id: 643,
    question: <>¿Puedo solicitar una tarjeta de crédito de WaFd Bank si estoy jubilado o desempleado?</>,
    answer: (
      <>
        <p>
          Sí, puedes solicitar. Si te has jubilado o retirado hace menos de dos años, se requiere la siguiente
          información.
        </p>
        <ul>
          <li>Empleo anterior</li>
          <li>Ocupación</li>
          <li>Nombre del empleador</li>
          <li>La Duración </li>
        </ul>
      </>
    )
  },
  {
    id: 644,
    question: <>Why should I restart my browser?</>,
    answer: (
      <>
        <p>
          Restarting your browser can resolve various issues, such as slow performance, unresponsive pages, and
          unexpected errors. It clears temporary data and refreshes the browser's processes.
        </p>
        <p>To restart your browser, close all open browser windows and tabs, then reopen the browser. </p>
      </>
    )
  },
  {
    id: 645,
    question: <>What is Incognito Mode or Private Browsing?</>,
    answer: (
      <>
        <p>
          Using Incognito Mode or Private Browsing can be a quick and effective way to diagnose and resolve browser
          issues without the influence of extensions, cached data, or stored cookies.
        </p>
        <p>
          <strong>Steps to open Incognito Mode or Private Browsing in different browsers:</strong>
        </p>
        <div className="pl-3">
          <p>
            <strong>Google Chrome:</strong> Click the three dots in the upper-right corner and select "New Incognito
            Window," or press Ctrl+Shift+N (Windows) or Cmd+Shift+N (Mac).
          </p>
          <p>
            <strong>Mozilla Firefox:</strong> Click the three lines in the upper-right corner and select "New Private
            Window," or press Ctrl+Shift+P (Windows) or Cmd+Shift+P (Mac).
          </p>
          <p>
            <strong>Microsoft Edge:</strong> Click the three dots in the upper-right corner and select "New InPrivate
            Window," or press Ctrl+Shift+N (Windows) or Cmd+Shift+N (Mac).
          </p>
          <p>
            <strong>Safari:</strong> Go to "File" in the menu bar and select "New Private Window," or press Cmd+Shift+N.
          </p>
        </div>
      </>
    )
  },
  {
    id: 646,
    question: <>What browsers does WaFd support?</>,
    answer: (
      <p>
        Using an up-to-date browser improves your security, speed, and experience.{" "}
        <Link to="/supported-browsers" id="faq-646-supported-browsers-link">
          Learn what browsers WaFd Bank supports
        </Link>{" "}
        and easily upgrade if needed.
      </p>
    )
  },
  {
    id: 647,
    question: <>How do I download the WaFd mobile app?</>,
    answer: (
      <>
        <p>
          Mobile apps are optimized for better performance and user experience on smartphones compared to browsers. You
          can download the WaFd mobile app by scanning the QR code below or through the Apple App Store or Google Play
          for Android devices.
        </p>
        <AppDownloadHub
          containerClass="col-12 col-md-7 col-lg-6 col-xl-5"
          structureStyle="buttons-row qr-left"
          mainBtn={{
            id: "faq-647-play-store-wafd-app-link"
          }}
          secondaryBtn={{
            id: "faq-647-app-store-wafd-app-link"
          }}
        />
      </>
    )
  },
  {
    id: 649,
    question: <>What is the rate for the WaFd Secured Credit Card?</>,
    answer: <p>24.99% annual percentage rate (APR) for purchases.</p>
  },
  {
    id: 650,
    question: <>Is the WaFd Bank Secured Credit Card a prepaid or debit card?</>,
    answer: (
      <p>
        No, the Secured Credit Card is NOT a prepaid or debit card. It works just like a traditional credit card, only
        you and WaFd Bank will know the credit card is secured. Secured means that you have given a security deposit to
        WaFd that is 105% of your credit limit. With responsible use, you can build your credit over time and upgrade to
        a traditional credit card. At that time, your security deposit will be refunded, minus any balance left on your
        card, which may include interest or fees if applicable.
      </p>
    )
  },
  {
    id: 651,
    question: <>Do I need to be a current WaFd client to apply for the Secured Credit Card?</>,
    answer: (
      <>
        <p>
          Yes. Available to current WaFd Bank clients only. Applicants must be a tax reported owner on a WaFd Bank
          account or Direct Borrower on a WaFd Bank loan.
        </p>
        <p>Accounts must be in "good standing" meaning not past due.</p>
        <p>
          Applicants may apply to open their account (e.g. checking, savings, etc.) along with the application for the
          Secured card.
        </p>
      </>
    )
  },
  {
    id: 652,
    question: <>Will I have to put down a deposit for the Secured Credit Card?</>,
    answer: (
      <p>
        Yes, a deposit account must be opened that will serve as collateral for the Secured credit card. The security
        deposit will be 105% of the qualified credit line amount. The security deposit will be refunded upon closure of
        the Secured account, unless it is needed to cover any delinquencies or charges.
      </p>
    )
  },
  {
    id: 653,
    question: <>¿Cuál es la tasa de la tarjeta Secured Credit Card de WaFd Bank?</>,
    answer: <p>Tasa porcentual anual (TAE) del 24.99% para compras.</p>
  },
  {
    id: 654,
    question: <>¿La tarjeta de crédito asegurada de WaFd Bank es una tarjeta prepaga o de débito?</>,
    answer: (
      <p>
        No, la tarjeta de crédito asegurada NO es una tarjeta prepaga ni de débito. Funciona igual que una tarjeta de
        crédito tradicional, solo tú y WaFd Bank sabrán que la tarjeta de crédito está asegurada. Asegurada significa
        que has entregado un depósito de seguridad a WaFd que equivale al 105% de su límite de crédito. Con un uso
        responsable, puedes generar crédito con el tiempo y actualizar tu tarjeta a una tarjeta de crédito tradicional.
        En ese momento, se te reembolsará el depósito de seguridad, menos el saldo restante en su tarjeta, que puede
        incluir intereses o cargos, si corresponde.
      </p>
    )
  },
  {
    id: 655,
    question: <>Para la tarjeta Secured Credit Card, ¿Necesito ser cliente actual de WaFd?</>,
    answer: (
      <>
        <p>
          Sí. Disponible únicamente para clientes actuales de WaFd Bank. Los solicitantes deben ser propietarios
          declarados de impuestos en una cuenta de WaFd Bank o prestatarios directos de un préstamo de WaFd Bank.
        </p>
        <p>Las cuentas deben estar al día, es decir, no vencidas.</p>
        <p>
          Los solicitantes pueden solicitar la apertura de su cuenta (por ejemplo, cuenta corriente, de ahorros, etc.)
          junto con la solicitud de la tarjeta asegurada.
        </p>
      </>
    )
  },
  {
    id: 656,
    question: <>¿Tendré que realizar un depósito para la tarjeta Secured Credit Card?</>,
    answer: (
      <p>
        Sí, se debe abrir una cuenta de depósito que servirá como garantía para la tarjeta Secured Credit Card. El
        depósito de seguridad será del 105% del monto de la línea de crédito calificada. El depósito de seguridad se
        reembolsará al cerrar la cuenta asegurada, a menos que sea necesario para cubrir cargos.
      </p>
    )
  },
  {
    id: 657,
    question: <>¿Cuál es la tasa de la tarjeta de crédito WaFd Cash Back?</>,
    answer: <p>Tasa de porcentaje anual (APR) del 17.24% para compras.</p>
  },
  {
    id: 658,
    question: <>How do I fund my account?</>,
    answer: (
      <p>
        You can fund your new WaFd account by ACH Bank Transfer, Credit Card or by visiting a{" "}
        <Link to="/locations" id="faq-658-locations-page-link">
          local WaFd branch
        </Link>
        .
      </p>
    )
  },
  {
    id: 659,
    question: <>How much do I need to fund my account?</>,
    answer: <p>It just takes an initial $25 deposit to get started.</p>
  },
  {
    id: 660,
    question: <>What are the requirements to open an account online?</>,
    answer: (
      <p>
        You must be 18+ years of age, reside in one of the nine states WaFd Bank operates in, and we review your banking
        history as part of the account application process to ensure eligibility and security.
      </p>
    )
  },
  {
    id: 661,
    question: <>Will you run a credit report?</>,
    answer: <p>Rest assured, we do not pull your credit report as part of this account application process.</p>
  },
  {
    id: 662,
    question: <>How long does the process take?</>,
    answer: <p>The review process can take up to three business days.</p>
  },
  {
    id: 663,
    question: <>Why did I get an email referring me to a branch?</>,
    answer: (
      <p>
        If we are unable to fully process your application online, to better serve your needs, we invite you to complete
        your application at one of our{" "}
        <Link to="/locations" id="faq-663-locations-page-link">
          branch locations
        </Link>
        .
      </p>
    )
  },
  {
    id: 664,
    question: <>How do I open a joint account?</>,
    answer: <p>You can add a joint owner after you have opened your account.</p>
  },
  {
    id: 665,
    question: <>What are the fees associated with this checking account?</>,
    answer: (
      <p>
        To learn more about the fees associate to a WaFd account visit{" "}
        <a
          href="/documents/schedule-of-consumer-fees-service-charges-effective.pdf"
          target="_blank"
          id="faq-665-consumer-fees-pdf-link"
        >
          WaFd Consumer Fees
        </a>
        .
      </p>
    )
  },
  {
    id: 666,
    question: <>Is my money insured and secure?</>,
    answer: <p>Yes, WaFd Bank is FDIC insured.</p>
  },
  {
    id: 667,
    question: <>Can I open a checking account online?</>,
    answer: (
      <p>
        Yes, please visit{" "}
        <Link to="/open-an-account" id="faq-667-open-an-account-link">
          WaFd Online Account Opening
        </Link>
        .
      </p>
    )
  },
  {
    id: 668,
    question: <>I have a negative ChexSystem personal report, can I still open an account?</>,
    answer: (
      <p>
        Possibly, please check out our{" "}
        <Link
          to="/personal-banking/fresh-start-second-chance-account"
          id="faq-668-fresh-start-second-chance-account-page-link"
        >
          WaFd Fresh Start Account
        </Link>
        .
      </p>
    )
  },
  {
    id: 669,
    question: (
      <>
        Can my business account receive money from Venmo, Stripe or Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <p>
        Yes, we support Venmo, Stripe and Zelle<sup>&reg;</sup>.
      </p>
    )
  },
  {
    id: 670,
    question: <>Do I need an online username to open an account?</>,
    answer: <p>No, you can open an account first and then enroll in online banking.</p>
  },
  {
    id: 671,
    question: <>I am having issues with CAPTCHA trying to prove I am not a robot.</>,
    answer: (
      <>
        <p>
          We're sorry you're having trouble with the CAPTCHA. Try giving it another go&mdash;here are a couple of steps
          you can try:
        </p>
        <ol>
          <li>Refresh the CAPTCHA and try a different image.</li>
          <li>
            Try a different device or browser. Sometimes a particular device or browser may struggle rendering the
            CAPTCHA correctly.
          </li>
        </ol>
      </>
    )
  },
  {
    id: 672,
    question: <>If I open an account today, will I get a debit card today with my name on it?</>,
    answer: (
      <p>
        Getting a debit card with your name on it today is possible, but you'll need to visit one of our{" "}
        <Link to="/locations" id="faq-672-locations-page-link">
          local branches
        </Link>
        . Just call ahead to make sure they have the card-printing equipment. Use our{" "}
        <a href="/locations#branch-search-section" id="faq-672-locations-branch-search-link">
          WaFd Branch Locator tool
        </a>{" "}
        to find the nearest branch.
      </p>
    )
  },
  {
    id: 673,
    question: <>Why wasn't my account opened instantly?</>,
    answer: (
      <p>
        Your account might need some additional verification on our end. We're handling it, and you'll be notified as
        soon as everything is finalized.
      </p>
    )
  },
  {
    id: 674,
    question: <>What types of accounts can I open online?</>,
    answer: (
      <p>
        To learn more about what accounts you can open online visit{" "}
        <Link to="/personal-banking" id="faq-674-personal-banking-page-link">
          WaFd's Personal Banking
        </Link>{" "}
        page.
      </p>
    )
  },
  {
    id: 676,
    question: <>What updates are included in WaFd's latest mobile app?</>,
    answer: (
      <>
        <p>
          When you open the existing WaFd Bank app, please follow the prompts to update to the new app. Then you can
          sign in using your current username and password. You will need to choose Face or Touch ID again (depending on
          your device) if you want biometric login enabled as part of the update. You will also need to complete a quick
          identity verification, choose your password, and accept updated terms.
        </p>
        <p>
          You'll notice the layout has been simplified to deliver a faster and friendlier mobile banking experience.
          Among other things, we've added the ability to manage your WaFd credit card, set up notifications that will
          come through instantly, and view your available balance in all accounts. We'd love to hear what you think!
          Simply navigate to the Menu and click "Feedback." If you have account specific questions or need help, please
          call us at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 677,
    question: <>Will all of my information be transferred to the new experience?</>,
    answer: (
      <p>
        All of the following will be migrated to the new platform: Username and password, transaction history, online
        bill payments and payees, Zelle<sup>&reg;</sup> contacts and scheduled transactions, external accounts and
        transfers, and statements. Alerts and notifications will not transfer over, so take a look at what you have set
        up currently so you can set them up again inside the new experience.
      </p>
    )
  },
  {
    id: 678,
    question: <>How far back does my transaction history go in the mobile app?</>,
    answer: <p>Currently, you can view transactions as old as those made in October 2023.</p>
  },
  {
    id: 679,
    question: <>Do I need to change my username or password?</>,
    answer: (
      <p>
        No, you can use the same username and password. If needed, please use Forgot Username/Password to reset your
        login information.
      </p>
    )
  },
  {
    id: 680,
    question: <>What's new in online banking?</>,
    answer: (
      <p>
        Some tools (like bubble budgets) have also been removed from WaFd online banking. However, we now support
        instant notifications which can be set up in online banking as well. We remain committed to making financial
        management easier, so keep an eye out for new tools in the future. Spending categories will still be available
        in the app so you can track your transactions there.
      </p>
    )
  },
  {
    id: 681,
    question: <>Do I need to set up notifications and alerts inside the new app?</>,
    answer: (
      <>
        <p>
          Yes, we recommend everyone set notifications to be alerted when large purchases are made, your balance gets
          low, and much more to prevent fraud and help you stay on top of your finances. If you were already receiving
          account activity notifications such as low balance or large deposit notifications, you will need to set them
          up in the new app.
        </p>
        <p>
          Good news: we've improved our notifications setup in both the mobile app and online banking, and it's a few
          easy steps to set them up. Simply navigate to the bell icon in the app or to Notifications in online banking.
        </p>
      </>
    )
  },
  {
    id: 682,
    question: <>Can I still use mobile deposit?</>,
    answer: <p>Yes, we continue to support mobile photo deposit.</p>
  },
  {
    id: 683,
    question: (
      <>
        Can I still use Zelle<sup>&reg;</sup>, Bill Pay, and External Transfers?
      </>
    ),
    answer: (
      <p>
        Yes, these services have been consolidated to one place for ease of use. Just tap Move Money and choose the one
        you'd like to use.
      </p>
    )
  },
  {
    id: 684,
    question: <>Can I still use tools like bubble budgets in the mobile app?</>,
    answer: (
      <p>
        Some tools (including bubble budgets and view net worth) have been removed. If you created bubble budgets, they
        will no longer be available. We remain committed to making financial management easier, so stay tuned for new
        tools in the future.
      </p>
    )
  },
  {
    id: 685,
    question: <>Can I still create a Quick Save transfer?</>,
    answer: (
      <p>
        We no longer have a Quick Save tile, however, transferring funds can be done by navigating to Money Movement and
        submitting a transfer there. You can even set up recurring transfers to save automatically!
      </p>
    )
  },
  {
    id: 686,
    question: <>Can I still reorder my accounts on the dashboard?</>,
    answer: (
      <p>
        Our new app doesn't support this feature, but we are working on including that option in an upcoming release.
      </p>
    )
  },
  {
    id: 687,
    question: <>Does the new app support different themes?</>,
    answer: (
      <p>
        Yes, the new app includes a light and dark theme. Kraken fans, stay tuned for an updated Kraken theme coming
        soon!
      </p>
    )
  },
  {
    id: 688,
    question: <>What does Add Account do?</>,
    answer: (
      <p>
        We are excited to share that you can continue to add accounts from your other banks to see all of your finances
        in one place. Once an account is added, you can easily view your balances and transactions from other banks
        inside the WaFd app.
      </p>
    )
  },
  {
    id: 689,
    question: <>Can I provide feedback to WaFd from inside the app?</>,
    answer: (
      <p>
        Yes! We are grateful for any feedback or suggestion you'd like to send our way. Simply navigate to the Menu and
        click Feedback.
      </p>
    )
  },
  {
    id: 690,
    question: <>Will there be changes to the Loan Payment feature?</>,
    answer: <p>Yes, payments to your WaFd loan will now be visible as soon as you make the payment.</p>
  },
  {
    id: 691,
    question: <>Can I still access Rewards through the app?</>,
    answer: (
      <p>
        Yes you can! The Rewards icon will be on the home screen of the app for easy access if you have a Rewards,
        Premium Rewards, or Interest Checking account.
      </p>
    )
  },
  {
    id: 692,
    question: <>How do I get my cashback rewards?</>,
    answer: (
      <p>
        Cash back rewards are issued as automated statement credit&mdash;easy for cardholders as no redemption is
        required!
      </p>
    )
  },
  {
    id: 693,
    question: <>When are cash back rewards paid out?</>,
    answer: <p>The cash back rewards payout is scheduled on a quarterly basis each calendar year.</p>
  },
  {
    id: 694,
    question: <>Are there any restrictions on receiving cash back rewards?</>,
    answer: <p>Accounts must be in good standing to receive cash back rewards.</p>
  },
  {
    id: 695,
    question: <>How do I activate my new debit card?</>,
    answer: (
      <p>
        Have your new debit card handy and call{" "}
        <a href="tel:866-661-8550" id="faq-debit-card-activation-tel-link">
          866-661-8550
        </a>
        . The system will ask for your full card number, then simply follow the prompts to finish activating your new
        card and set a PIN before hanging up. Your new debit card is ready to go! While you're at it, consider adding
        your new card to your{" "}
        <Link id="faq-695-digital-debit-card-link" to="/personal-banking/debit-cards/digital-debit-card">
          digital wallet
        </Link>
        .
      </p>
    )
  },
  {
    id: 696,
    question: <>How can I apply?</>,
    answer: (
      <p>
        Please visit your{" "}
        <a href="/locations" id="faq-696-locations-link">
          local branch
        </a>{" "}
        to apply for a WaFd Bank Secured Credit Card.
      </p>
    )
  },
  {
    id: 697,
    question: <>Will I get my deposit back after closing my Secured Credit Card?</>,
    answer: (
      <p>
        As long as there are no outstanding balances left unpaid when your account is closed, you can receive your
        deposit back. Refer to your cardholder agreement to understand when you'll receive less than your full deposit
        back.
      </p>
    )
  },
  {
    id: 698,
    question: <>Can I still apply for a WaFd Bank secured credit card if I'm retired or unemployed?</>,
    answer: (
      <>
        <p>
          Yes, you can apply. If you've been retired or unemployed for less than two years, the following information is
          required.
        </p>
        <ul>
          <li>Previous employment</li>
          <li>Occupation</li>
          <li>Employer name</li>
          <li>Duration</li>
        </ul>
      </>
    )
  },
  {
    id: 699,
    question: <>How does Bill Pay work?</>,
    answer: (
      <>
        <p>Watch this video for a quick overview:</p>
        <VimeoVideoFrame vimeoId="1003382405" videoTitle="WaFd Bank New Bill Pay Tutorial" />
      </>
    )
  },
  {
    id: 700,
    question: <>¿Cómo obtengo mis recompensas de cashback?</>,
    answer: (
      <p>
        Las recompensas cashback se emiten como crédito en el estado de cuenta automático, lo que resulta fácil para los
        titulares de tarjetas, ya que no se requiere canje.
      </p>
    )
  },
  {
    id: 701,
    question: <>¿Cuándo se pagan las recompensas cashback?</>,
    answer: <p>El pago de recompensas cashback se programa trimestralmente cada año.</p>
  },
  {
    id: 702,
    question: <>¿Existen restricciones para recibir recompensas cashback?</>,
    answer: <p>Las cuentas deben estar en buena posicion para recibir recompensas en efectivo.</p>
  },
  {
    id: 703,
    question: <>¿Cómo puedo aplicar?</>,
    answer: (
      <p>
        Visita tu{" "}
        <Link href="/es/sucursales" id="faq-703-es-sucursales-link">
          sucursal local
        </Link>{" "}
        para solicitar una WaFd Bank Secured Credit Card.
      </p>
    )
  },
  {
    id: 704,
    question: <>¿Recibiré mi depósito de vuelta después de cerrar mi Secured Credit Card?</>,
    answer: (
      <p>
        Siempre que no haya saldos pendientes sin pagar cuando se cierre tu cuenta, podrás recibir tu depósito de
        vuelta. Consulta el acuerdo de titular de su tarjeta para saber en que casos recibirás menos de la totalidad de
        tu depósito de vuelta.
      </p>
    )
  },
  {
    id: 705,
    question: <>¿Cómo activo mi nueva tarjeta de débito?</>,
    answer: (
      <p>
        Tenga a mano su nueva tarjeta de débito y llame al{" "}
        <a href="tel:866-661-8550" id="faq-696-debit-card-activation-tel-link">
          866-661-8550
        </a>
        . El sistema le pedirá su número de tarjeta completo, luego simplemente siga las instrucciones para terminar de
        activar su nueva tarjeta y establecer un PIN antes de colgar. ¡Tu nueva tarjeta de débito está lista para
        funcionar!
      </p>
    )
  },
  {
    id: 710,
    question: <>I'm getting a text message with a link from WaFd Bank, is this legitimate?</>,
    answer: (
      <p>
        If they are coming from the number 76369, yes it is legitimate. This is a free, secure, and personalized mobile
        communication network providing you relevant information about your account and other educational content. When
        you are connected to this free service, a personal message feed will be automatically created for you. An SMS
        message will be sent to your mobile device with a link to access your personal message feed. Unlike social media
        platforms, no one can see the messages on your feed but you. When you have new content or a message posted to
        your feed, you will receive an SMS alert to notify you, which is the text message you received.
      </p>
    )
  },
  {
    id: 711,
    question: <>What are the benefits of getting text message alerts for a personalized news feed?</>,
    answer: (
      <p>
        Your news feed provides you with the fastest and easiest way to stay on top of your most important
        communications from WaFd Bank. Designed just for you, this delivers the information you need, right when you
        need it, to your own private online message feed.
      </p>
    )
  },
  {
    id: 712,
    question: <>Am I charged for text messages or for my personalized news feed?</>,
    answer: (
      <p>
        The service is free, but depending on your mobile plan, standard message and data rates may apply. Msg & Data
        Rates may apply disclaimer is included with every SMS message, and you have the ability to opt out when you
        receive a message from us.
      </p>
    )
  },
  {
    id: 713,
    question: <>Can I opt out of the text and news feed program?</>,
    answer: (
      <p>
        You can opt out of receiving notifications at any time by going to the most recent message you received, and
        texting back STOP.
      </p>
    )
  },
  {
    id: 714,
    question: <>Will my information be sold to a 3rd party?</>,
    answer: <p>Your information is secure and will never be sold to a third party.</p>
  },
  {
    id: 715,
    question: <>Is this feed directly linked to my personal bank accounts?</>,
    answer: (
      <p>No, you will have your own separate login credentials to any service or platform you access with WaFd Bank.</p>
    )
  },
  {
    id: 716,
    question: <>What are the WaFd Bank Foundation's primary focus areas for giving?</>,
    answer: (
      <>
        <p>
          Our community giving and engagement is primarily focused on areas we see as critical for building more
          resilient and thriving communities.
        </p>
        <p>
          We give to the following areas impacting primarily low-income populations in the communities where our
          branches operate:
        </p>
        <p>
          <strong>Micro Grants: $1,000 - $5,000</strong>
        </p>
        <ol id="faq-706-micro-grants-list">
          <li id="faq-706-micro-grants-list-item-1">
            <strong>Social services and basic needs</strong>: Emergency housing and rental assistance, utility
            assistance, clothing, toiletries, household items, food and nutrition programs, basic skills training and
            independent living, childcare, crisis programs, and social services.
          </li>
          <li id="faq-706-micro-grants-list-item-2">
            <strong>Financial literacy:</strong> Budgeting, understanding of basic finances, first time home buyers,
            small business startups, getting out of debt, understanding and building credit, identifying scams and
            fraud, etc.
          </li>
        </ol>
        <p>
          <strong>Community Impact Grants: $5,000 - $10,000+</strong>
        </p>
        <ol id="faq-706-community-impact-grants-list">
          <li id="faq-706-community-impact-grants-list-item-1">
            <strong>Permanent, affordable, and sustainable housing:</strong> Creation of individual and multi-family
            housing for LMI populations
          </li>
          <li id="faq-706-community-impact-grants-list-item-2">
            <strong>Economic development:</strong> Programs that promote economic development for businesses (primarily
            small business) that target LMI geographic areas, size eligibility and gross revenue of $1million or less.
            Preference is given to businesses owned by women, BIPOC, LGBTQIA+, minority and immigrant individuals
          </li>
          <li id="faq-706-community-impact-grants-list-item-3">
            <strong>Community revitalization:</strong> Programs that stabilize and recover communities by attracting or
            retaining jobs, businesses and homes
          </li>
          <li id="faq-706-community-impact-grants-list-item-4">
            <strong>Job development:</strong> Apprenticeships, job training and employment education programs that
            enable communities to revitalize their workforce and attract businesses that provide living wages
          </li>
        </ol>
      </>
    )
  },
  {
    id: 717,
    question: <>Does WaFd Bank Foundation approve funding for grants outside the primary focus areas?</>,
    answer: (
      <p>
        We may support other local needs in eligible communities. However, opportunities are limited as our intent is to
        direct the majority of our giving within our primary focus areas.
      </p>
    )
  },

  {
    id: 718,
    question: <>What if my organization is not near a WaFd Bank branch?</>,
    answer: (
      <p>
        WaFd Bank operates in a 9-state footprint. We focus on the communities where our bankers live and work.
        Unfortunately, organizations outside of our banking footprint are unable to apply.
      </p>
    )
  },
  {
    id: 719,
    question: <>Will WaFd Bank sponsor my charitable fundraising event?</>,
    answer: (
      <p>
        WaFd Bank prefers to fund programs and projects rather than unrestricted sponsorships and events for nonprofits.
        However, we do a limited amount of sponsorships for fundraising events. To be considered, please contact your
        local WaFd Bank branch and speak to the Branch Manager. Priority is given to organizations that support our
        primary focus areas.
      </p>
    )
  },
  {
    id: 720,
    question: <>How do I obtain a letter of support?</>,
    answer: (
      <p>
        Letters of support are given by a WaFd Bank employee after meeting with an organization and understanding your
        needs and programming. This ensures the organizations we fund are aligned with our giving priorities and have a
        direct contact with an employee for volunteer needs, financial literacy classes, and relationship building.
        Organizations can request a meeting with a branch manager by calling or emailing the nearest WaFd Bank branch in
        your community.
      </p>
    )
  },
  {
    id: 721,
    question: <>Do you have any advice for how to structure our request?</>,
    answer: (
      <>
        <p>
          Your submission should be thoughtful and concise and closely follow section guidelines. It's important that it
          tells a concise story of the problem or opportunity and how funding will help your organization address the
          needs effectively.
        </p>
        <p>
          Funding purpose and project description: Your executive summary should give a brief overview of the low-income
          population you serve, the need for support, what your project does, and what impact you plan to expand or
          sustain.
        </p>
        <p>
          Detailed project information: Please provide information on your project/program, including how the funding
          will specifically be used.
        </p>
        <p>
          Ability to report quantifiable results of defined success metrics for project: Outcomes and impact reporting
          or other key success measures tracked by your organization will need to be submitted within one calendar year
          of funding.
        </p>
        <p>
          Previous year funding: If you received a grant from WaFd Bank in a prior year, please explain the impact of
          that funding. What were the benefits, successes, and lessons learned? Why should you receive continued
          support?
        </p>
      </>
    )
  },
  {
    id: 722,
    question: <>Do I have to submit all documentation, even if my request is small?</>,
    answer: (
      <p>
        Yes, you must complete all required fields and submit requested documentation as identified within the
        application in order to submit your grant request.
      </p>
    )
  },
  {
    id: 723,
    question: <>Will someone from WaFd Bank make a site visit to our organization?</>,
    answer: (
      <p>
        In the event your organization is awarded funds, a WaFd Bank employee will contact you to schedule a site visit.
        Photos will be taken at this time for use on social media and documentation.
      </p>
    )
  },
  {
    id: 724,
    question: <>How do you define low- to moderate-income individuals and families?</>,
    answer: <p>Annual income of 80% or less of the area median income.</p>
  },
  {
    id: 725,
    question: <>May I submit a grant request directly to a WaFd Bank representative?</>,
    answer: (
      <p>
        No. All grant requests must be submitted through the official online grant application portal. We do not accept
        printed, paper or emailed applications. If you have a letter of support from a WaFd Bank representative, please
        submit it with your application.
      </p>
    )
  },
  {
    id: 726,
    question: <>When can we expect payment if the request is approved?</>,
    answer: <p>Payment is typically sent within one month after a proposal has been approved.</p>
  },
  {
    id: 727,
    question: <>What do I need to submit for payment?</>,
    answer: (
      <p>
        All funding is paid through ACH (automated clearing house) and is deposited into your organizations account via
        the W9 documentation you submitted with your application. This includes bank account information and routing
        numbers.
      </p>
    )
  },
  {
    id: 728,
    question: <>How long does it take to review and approve requests?</>,
    answer: (
      <p>
        Depending on the number of eligible applications in the queue, it can take three to four months to move through
        the approval process.
      </p>
    )
  },
  {
    id: 729,
    question: <>Can I contact WaFd Bank to discuss my grant request?</>,
    answer: (
      <p>
        If you have a clarifying issue, you can email{" "}
        <a id="faq-719-mail-support-foundation-link" href="mailto:FoundationSupport@wafd.com">
          FoundationSupport@wafd.com
        </a>
        . Due to the large number of requests we receive, we don't discuss grant proposals after they have been
        submitted.
      </p>
    )
  },
  {
    id: 730,
    question: <>Who do I contact to check on our application status?</>,
    answer: (
      <p>
        Please wait at least 120 days after submitting your application. In most cases, you will have heard from us by
        then. If not, please send an email to{" "}
        <a id="faq-720-mail-support-foundation-link" href="mailto:FoundationSupport@wafd.com">
          FoundationSupport@wafd.com
        </a>
        .
      </p>
    )
  },
  {
    id: 731,
    question: <>If our proposal is declined, can we reapply?</>,
    answer: (
      <p>
        The request may not be resubmitted in the same calendar year. Organizations are welcome to reapply the following
        calendar year.
      </p>
    )
  },
  {
    id: 732,
    question: <>If we are turned down, can we contact you to find out why?</>,
    answer: (
      <p>
        Our Foundation Board makes decisions based on alignment to our priorities, available funds, geo areas of need,
        and ability to report measurable outcomes. We do not answer specific questions about why grant requests were
        declined. We appreciate the time and effort you spent in preparing the application, however, we ask that you
        accept the final decision made by the Foundation Board.
      </p>
    )
  },
  {
    id: 733,
    question: <>How do I access my free credit score?</>,
    answer: (
      <>
        <p>You can view your credit score from the WaFd app or inside online banking.</p>
        <p>From your mobile app:</p>
        <ol>
          <li>Choose the round Rewards icon from the main menu screen; you may need to swipe left to see it</li>
          <li>Tap the hamburger menu in the top right corner and choose Identity Protection</li>
          <li>Scroll to the Monitoring Benefits, Credit Report and Score section</li>
          <li>Tap Access your benefits</li>
          <li>In the new screen tap Activate Benefits</li>
          <li>In the Credit Report section tap the Get Your Report/Score button and view your score</li>
        </ol>
        <p>From online banking in your browser or on your desktop:</p>
        <ol>
          <li>Click on your Rewards, Premium Rewards, or Interest Checking account</li>
          <li>Click Rewards from the menu on the right</li>
          <li>Choose Identity Protection at the top of the screen</li>
          <li>Scroll to the Monitoring Benefits, Credit Report and Score section and click Access your benefits</li>
          <li>Click Activate Benefits</li>
          <li>View your score just under the Credit Score section</li>
        </ol>
      </>
    )
  },
  {
    id: 734,
    question: <>Where do I access CashFlow Central?</>,
    answer: (
      <>
        <p>
          CashFlow Central can be accessed directly in your Treasury Express or Treasury Prime online banking profile.
        </p>
        <p className="fw-bold">Treasury Express</p>
        <img
          className="w-100 w-md-75 mb-4"
          src="/images/cash-flow-central/treasury-express.png"
          alt="CashFlow Central in Treasury Express."
        />
        <p className="fw-bold">Treasury Prime</p>
        <img
          className="w-100 w-md-75 mb-4"
          src="/images/cash-flow-central/treasury-prime.png"
          alt="CashFlow Central in Treasury Prime."
        />
      </>
    )
  },
  {
    id: 735,
    question: <>Are there steps that have to be taken the first time I log in?</>,
    answer: (
      <>
        <p>Yes, as the primary administrator there are a few first-time login steps we recommend:</p>
        <ol>
          <li>
            Log in to CashFlow Central and verify your payees are available. Payees are available in the{" "}
            <strong>Pay Bills &gt; Vendors</strong> tab.
          </li>
          <li>
            Verify any pending future dated payments. Find these in the <strong>Pay Bills &lt; Activity</strong> tab.
          </li>
          <li>
            Verify any recurring payments, available in the <strong>Pay Bills &lt; Activity</strong> tab. Recurring
            payments will be indicated with an icon.
          </li>
          <li>
            Activate any additional users that require access to CashFlow Central. You can do this in the{" "}
            <strong>Settings &gt; User and Roles</strong> tab.
          </li>
        </ol>
      </>
    )
  },
  {
    id: 736,
    question: <>Where do I activate additional users in CashFlow Central?</>,
    answer: (
      <>
        <p>
          Go to the <strong>Settings</strong> tab and then choose <strong>User and Roles</strong>
        </p>
        <ol>
          <li>
            Select the user you would like to activate. Current user status will show in the "Role" column.
            <br />
            <img
              className="w-100 w-md-75 mb-4"
              src="/images/cash-flow-central/additional-users.png"
              alt="CashFlow Central Users and Roles."
            />
          </li>
          <li>
            Turn on the <strong>Account Activation</strong> toggle.
            <br />
            <img
              className="w-100 w-md-75 mb-4"
              src="/images/cash-flow-central/account-activation.png"
              alt="CashFlow Central Account Activation."
            />
          </li>
          <li>
            Review <strong>Roles and Permissions</strong> to ensure the user is enrolled in the correct level and make
            any updates if needed.
            <br />
            <img
              className="w-100 w-md-75 mb-4"
              src="/images/cash-flow-central/roles-permissions.png"
              alt="CashFlow Central Roles and Permissions."
            />
          </li>
          <li>
            Review the <strong>Funding method access</strong>. If the user should have "full access" to all accounts
            enabled with CashFlow Central service turn the toggle <strong>on</strong> or turn the toggle{" "}
            <strong>off</strong> to select specific accounts.
            <br />
            <img
              className="w-100 w-md-75 mb-4"
              src="/images/cash-flow-central/funding-method-access.png"
              alt="CashFlow Central Funding Method."
            />
          </li>
          <li>
            Review <strong>Payment approval limit</strong> (Level 3 users only) and update if needed.
            <br />
            <img
              className="w-100 w-md-75 mb-4"
              src="/images/cash-flow-central/payment-approval-limit.png"
              alt="CashFlow Central Payment Approval Limit."
            />
          </li>
          <li>
            Click <strong>Save</strong> to complete.
          </li>
        </ol>
      </>
    )
  },
  {
    id: 737,
    question: <>Are there fees for having access to CashFlow Central?</>,
    answer: (
      <>
        <p>
          Yes, monthly service fees depend on number of users entitled to access CashFlow Central and the number of
          payments sent within the billing period.
        </p>
        <table className="table table-bordered">
          <thead className="thead-gray text-center">
            <tr>
              <th style={{ width: "50%" }}>Account Payable Base Plan</th>
              <th>Account Payable Pro Plan</th>
            </tr>
          </thead>
          <tbody className="tbody-white">
            <tr className="text-center">
              <td>$0 per month</td>
              <td>$9 per month</td>
            </tr>
            <tr>
              <td>{checkIcon()}2 user seats</td>
              <td>{checkIcon()}3 user seats</td>
            </tr>
            <tr>
              <td>{checkIcon()}5 transactions</td>
              <td>
                {checkIcon()}
                10 transactions
              </td>
            </tr>
            <tr>
              <td>
                {checkIcon()}
                Pay any bill or vendor
              </td>
              <td>
                {checkIcon()}
                All features available in Base plan
              </td>
            </tr>
            <tr>
              <td>
                {checkIcon()}
                Pay by account or card
              </td>
              <td>
                {checkIcon()}
                2-way sync with QuickBooks
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>
                <em>Additional fees</em>
              </td>
              <td>
                <em>Additional fees</em>
              </td>
            </tr>
            <tr>
              <td>
                {checkIcon()}
                Excess transactions (over 5) - $0.40 cents
              </td>
              <td>
                {checkIcon()}
                Excess transactions (over 10) - $0.40 cents per transaction
              </td>
            </tr>
            <tr>
              <td>
                {checkIcon()}
                Additional user seats - move to Pro plan
              </td>
              <td>
                {checkIcon()}
                Additional user seats - $1.50 per user
              </td>
            </tr>
          </tbody>
        </table>
      </>
    )
  },
  {
    id: 738,
    question: <>How do I know what plan my business will be migrated to once my business moves to CashFlow Central?</>,
    answer: (
      <p>
        Business will be migrated to the applicable plan based on number of users currently entitled to access Bill Pay
        in Treasury Express or Treasury Prime.
      </p>
    )
  },
  {
    id: 739,
    question: <>Does this sync with my accounting software?</>,
    answer: (
      <p>
        Yes! Cashflow Central has a two-way sync with Intuit QuickBooks. Users can link their QuickBooks profile by
        selecting the sync icon located in the top left corner of their screen or by going to the{" "}
        <strong>Settings</strong> tab and selecting <strong>Sync and Import</strong>.
      </p>
    )
  },
  {
    id: 740,
    question: <>When will I see my CashFlow Central service fees post to my account?</>,
    answer: (
      <>
        <p>
          Service fees post on the third business day of the month. Businesses can view their billing statement within
          CashFlow Central and will receive an email once the service fee has been processed.
        </p>
        <p>
          Billing Statements can be found by going to the <strong>Settings</strong> tab at the top of your screen and
          then select <strong>Billing Statements</strong>.
        </p>
      </>
    )
  },
  {
    id: 741,
    question: <>Where do I find what account my service fees will be billed to?</>,
    answer: (
      <>
        <p>
          Primary administrators can see their billing account in the <strong>settings &lt; Plans and billing</strong>{" "}
          tab.
        </p>
        <img
          className="w-100 w-md-75 mb-4"
          src="/images/cash-flow-central/billing-account.png"
          alt="CashFlow Central Billing Account."
        />
      </>
    )
  },
  {
    id: 742,
    question: <>Can I change what account my service fees will be posted to?</>,
    answer: (
      <>
        <p>
          Yes, from the <strong>Settings &lt; Plans and Billing</strong>, select <strong>Change billing account</strong>
          .
        </p>
        <img
          className="w-100 w-md-75 mb-4"
          src="/images/cash-flow-central/change-billing-account.png"
          alt="CashFlow Central Change Billing Account."
        />
      </>
    )
  },
  {
    id: 743,
    question: <>How can I change which CashFlow Central Plan my business is enrolled in?</>,
    answer: (
      <>
        <p>
          The primary administrator can manage the plan at any time. Go to the <strong>Settings</strong> menu at the top
          of the screen and then select <strong>Plans and Billing</strong>.
        </p>
        <img
          className="w-100 w-md-75 mb-4"
          src="/images/cash-flow-central/plans-billing.png"
          alt="CashFlow Central Plans and Billing."
        />
      </>
    )
  },
  {
    id: 744,
    question: <>How do I know when my payment will debit my WaFd account?</>,
    answer: (
      <>
        <ul>
          <li>
            Payments sent via check will debit your WaFd account 5 business days before the selected Deliver By date
          </li>
          <li>
            Payments sent via Bank Transfer will debit your WaFd account 1 business day before the selected Deliver By
            date
          </li>
          <li>
            Users can see when a payment is scheduled to debit their account in the Activity screen, listed in the
            "Debit on" column
          </li>
        </ul>
        <img
          className="w-100 w-md-75 mb-4"
          src="/images/cash-flow-central/payment-activity.png"
          alt="CashFlow Central Payment Activity."
        />
      </>
    )
  },
  {
    id: 745,
    question: <>What happens if my account does not have sufficient funds to send the payment?</>,
    answer: (
      <>
        <p>
          If the WaFd account a payment is sent out of does not have enough funds to cover a transaction on the listed
          "Debit on" date, the transaction will fail. You will then be required to re-initiate the payment if it is
          still needed.
        </p>
      </>
    )
  },
  {
    id: 746,
    question: <>If sending a payment by check, how do I know what the check number is?</>,
    answer: (
      <>
        <p>
          All payments, regardless if sent by check or bank transfer, will debit your WaFd account as an electronic
          debit transaction (external withdrawal).
        </p>
      </>
    )
  },
  {
    id: 747,
    question: <>Do my vendors need an account?</>,
    answer: (
      <>
        <p>No, your vendors do not need an account to receive payments through CashFlow Central.</p>
      </>
    )
  },
  {
    id: 748,
    question: <>Do payments look like they come from me or CashFlow Central?</>,
    answer: (
      <>
        <p>
          Payments from CashFlow Central will include your information and show they come from your business. For
          example, your company name and address will be among the included information.
        </p>
      </>
    )
  },
  {
    id: 749,
    question: <>Will my CD special renew to another CD special at maturity?</>,
    answer: (
      <>
        <p>
          CD Specials are promotional interest rates and apply to the initial term only. At maturity, the special rate
          CD will automatically renew into a standard rate CD for the exact term at the non-special interest rate and
          APY in effect on maturity. If you'd like to renew to a different term, please visit a{" "}
          <Link to="/locations" id="faq-749-locations-internal-link">
            local WaFd Bank branch
          </Link>{" "}
          or call us at{" "}
          <a href="tel:800-324-9375" className="faq-c3-tel-link">
            800-324-9375
          </a>
          .
        </p>
      </>
    )
  },
  {
    id: 750,
    question: <>What is a CD's grace period?</>,
    answer: (
      <>
        <p>
          Grace Period refers to the ten (10) Calendar Days following the maturity date of your Certificate. During the
          Grace Period, you may add or withdraw funds, subject to minimum balance requirements, without interest
          penalty.
        </p>
      </>
    )
  },
  {
    id: 751,
    question: <>How much can I withdraw from an ATM with my credit card?</>,
    answer: (
      <>
        <p>
          When you withdraw cash from an ATM using your credit card, it is considered a cash advance, which means you
          may be charged a different interest rate and fees on the amount you withdraw.{" "}
          <strong>The limit is $500</strong>, provided that this amount does not exceed your Cash Advance limit. See
          your Cardholder Agreement for more details.
        </p>
      </>
    )
  },
  {
    id: 752,
    question: (
      <>
        How do I unenroll from Zelle<sup>&reg;</sup>?
      </>
    ),
    answer: (
      <>
        <p>
          Log in to Online Banking (not the mobile app) and click the Move Money tab, then choose Zelle<sup>&reg;</sup>.
          From there, select Settings and then Manage to unenroll.
        </p>
        <p>
          If you do not have at least two contacts added (people you have paid) you will not be able to self-unenroll.
          Give us a call at{" "}
          <a className="faq-c3-tel-link" href="tel:800-324-9375">
            800-324-9375
          </a>{" "}
          and we will complete the steps for you.
        </p>
      </>
    )
  },
  {
    id: 753,
    question: <>How do I add or activate an eBill?</>,
    answer: (
      <>
        <p>
          Only vendors that have chosen to allow eBills will be available. Navigate to the Vendors tab within CashFlow
          Central and click the eBill icon next to the vendor you want to enroll with and follow the prompts to complete
          activation.
        </p>
      </>
    )
  }
];
